var dd = Object.defineProperty;
var Ks = (e) => {
  throw TypeError(e);
};
var fd = (e, t, n) => t in e ? dd(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var dt = (e, t, n) => fd(e, typeof t != "symbol" ? t + "" : t, n), eo = (e, t, n) => t.has(e) || Ks("Cannot " + n);
var S = (e, t, n) => (eo(e, t, "read from private field"), n ? n.call(e) : t.get(e)), me = (e, t, n) => t.has(e) ? Ks("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), oe = (e, t, n, r) => (eo(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), ye = (e, t, n) => (eo(e, t, "access private method"), n);
import { jsx as p, jsxs as ve, Fragment as $t } from "react/jsx-runtime";
import * as c from "react";
import ge, { createContext as pd, useState as St, useEffect as An, useContext as hd, forwardRef as ai, createElement as So, useLayoutEffect as md, useRef as Zs, useMemo as to, useCallback as In } from "react";
import * as Hn from "react-dom";
import gd from "react-dom";
const ii = pd(void 0);
function Uw({
  children: e,
  defaultTheme: t = "system",
  storageKey: n = "tms-theme"
}) {
  const [r, o] = St(t), [s, a] = St(), [i, u] = St(), l = ge.useMemo(() => r === "system" ? typeof window < "u" && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : r, [r]);
  An(() => {
    const g = localStorage.getItem(n);
    g && ["light", "dark", "hc", "system"].includes(g) && o(g);
  }, [n]), An(() => {
    const g = window.document.documentElement;
    g.setAttribute("data-theme", l), s ? g.style.setProperty("--tenant-primary", s) : g.style.removeProperty("--tenant-primary"), i ? g.style.setProperty("--tenant-primary-fg", i) : g.style.removeProperty("--tenant-primary-fg");
  }, [l, s, i]), An(() => {
    if (r !== "system") return;
    const g = window.matchMedia("(prefers-color-scheme: dark)"), v = () => {
      o("system");
    };
    return g.addEventListener("change", v), () => g.removeEventListener("change", v);
  }, [r]);
  const d = (g) => {
    o(g), localStorage.setItem(n, g);
  }, f = (g, v) => {
    a(g), u(v);
  };
  return /* @__PURE__ */ p(
    ii.Provider,
    {
      value: {
        theme: r,
        setTheme: d,
        resolvedTheme: l,
        tenantPrimary: s,
        tenantPrimaryFg: i,
        setTenantBranding: f
      },
      children: e
    }
  );
}
function vd() {
  const e = hd(ii);
  if (e === void 0)
    throw new Error("useTheme must be used within a ThemeProvider");
  return e;
}
function zw({ className: e }) {
  const { theme: t, setTheme: n } = vd(), r = () => {
    const s = ["light", "dark"], i = (s.indexOf(t) + 1) % s.length;
    n(s[i]);
  }, o = () => {
    switch (t) {
      case "light":
        return "☀️";
      case "dark":
        return "🌙";
      case "hc":
        return "🔆";
      case "system":
        return "💻";
      default:
        return "☀️";
    }
  };
  return /* @__PURE__ */ p(
    "button",
    {
      onClick: r,
      className: `inline-flex h-9 w-9 items-center justify-center rounded-md text-sm font-medium transition-colors hover:bg-accent hover:text-accent-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 ${e}`,
      "aria-label": `Switch to ${t === "light" ? "dark" : t === "dark" ? "high contrast" : t === "hc" ? "system" : "light"} theme`,
      children: o()
    }
  );
}
var ie;
(function(e) {
  e.assertEqual = (o) => {
  };
  function t(o) {
  }
  e.assertIs = t;
  function n(o) {
    throw new Error();
  }
  e.assertNever = n, e.arrayToEnum = (o) => {
    const s = {};
    for (const a of o)
      s[a] = a;
    return s;
  }, e.getValidEnumValues = (o) => {
    const s = e.objectKeys(o).filter((i) => typeof o[o[i]] != "number"), a = {};
    for (const i of s)
      a[i] = o[i];
    return e.objectValues(a);
  }, e.objectValues = (o) => e.objectKeys(o).map(function(s) {
    return o[s];
  }), e.objectKeys = typeof Object.keys == "function" ? (o) => Object.keys(o) : (o) => {
    const s = [];
    for (const a in o)
      Object.prototype.hasOwnProperty.call(o, a) && s.push(a);
    return s;
  }, e.find = (o, s) => {
    for (const a of o)
      if (s(a))
        return a;
  }, e.isInteger = typeof Number.isInteger == "function" ? (o) => Number.isInteger(o) : (o) => typeof o == "number" && Number.isFinite(o) && Math.floor(o) === o;
  function r(o, s = " | ") {
    return o.map((a) => typeof a == "string" ? `'${a}'` : a).join(s);
  }
  e.joinValues = r, e.jsonStringifyReplacer = (o, s) => typeof s == "bigint" ? s.toString() : s;
})(ie || (ie = {}));
var Gs;
(function(e) {
  e.mergeShapes = (t, n) => ({
    ...t,
    ...n
    // second overwrites first
  });
})(Gs || (Gs = {}));
const V = ie.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), mt = (e) => {
  switch (typeof e) {
    case "undefined":
      return V.undefined;
    case "string":
      return V.string;
    case "number":
      return Number.isNaN(e) ? V.nan : V.number;
    case "boolean":
      return V.boolean;
    case "function":
      return V.function;
    case "bigint":
      return V.bigint;
    case "symbol":
      return V.symbol;
    case "object":
      return Array.isArray(e) ? V.array : e === null ? V.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? V.promise : typeof Map < "u" && e instanceof Map ? V.map : typeof Set < "u" && e instanceof Set ? V.set : typeof Date < "u" && e instanceof Date ? V.date : V.object;
    default:
      return V.unknown;
  }
}, A = ie.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class st extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const n = t || function(s) {
      return s.message;
    }, r = { _errors: [] }, o = (s) => {
      for (const a of s.issues)
        if (a.code === "invalid_union")
          a.unionErrors.map(o);
        else if (a.code === "invalid_return_type")
          o(a.returnTypeError);
        else if (a.code === "invalid_arguments")
          o(a.argumentsError);
        else if (a.path.length === 0)
          r._errors.push(n(a));
        else {
          let i = r, u = 0;
          for (; u < a.path.length; ) {
            const l = a.path[u];
            u === a.path.length - 1 ? (i[l] = i[l] || { _errors: [] }, i[l]._errors.push(n(a))) : i[l] = i[l] || { _errors: [] }, i = i[l], u++;
          }
        }
    };
    return o(this), r;
  }
  static assert(t) {
    if (!(t instanceof st))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, ie.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (n) => n.message) {
    const n = {}, r = [];
    for (const o of this.issues)
      if (o.path.length > 0) {
        const s = o.path[0];
        n[s] = n[s] || [], n[s].push(t(o));
      } else
        r.push(t(o));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
st.create = (e) => new st(e);
const Co = (e, t) => {
  let n;
  switch (e.code) {
    case A.invalid_type:
      e.received === V.undefined ? n = "Required" : n = `Expected ${e.expected}, received ${e.received}`;
      break;
    case A.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, ie.jsonStringifyReplacer)}`;
      break;
    case A.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${ie.joinValues(e.keys, ", ")}`;
      break;
    case A.invalid_union:
      n = "Invalid input";
      break;
    case A.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${ie.joinValues(e.options)}`;
      break;
    case A.invalid_enum_value:
      n = `Invalid enum value. Expected ${ie.joinValues(e.options)}, received '${e.received}'`;
      break;
    case A.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case A.invalid_return_type:
      n = "Invalid function return type";
      break;
    case A.invalid_date:
      n = "Invalid date";
      break;
    case A.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : ie.assertNever(e.validation) : e.validation !== "regex" ? n = `Invalid ${e.validation}` : n = "Invalid";
      break;
    case A.too_small:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "bigint" ? n = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : n = "Invalid input";
      break;
    case A.too_big:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? n = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : n = "Invalid input";
      break;
    case A.custom:
      n = "Invalid input";
      break;
    case A.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case A.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case A.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = t.defaultError, ie.assertNever(e);
  }
  return { message: n };
};
let yd = Co;
function bd() {
  return yd;
}
const wd = (e) => {
  const { data: t, path: n, errorMaps: r, issueData: o } = e, s = [...n, ...o.path || []], a = {
    ...o,
    path: s
  };
  if (o.message !== void 0)
    return {
      ...o,
      path: s,
      message: o.message
    };
  let i = "";
  const u = r.filter((l) => !!l).slice().reverse();
  for (const l of u)
    i = l(a, { data: t, defaultError: i }).message;
  return {
    ...o,
    path: s,
    message: i
  };
};
function D(e, t) {
  const n = bd(), r = wd({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      n,
      // then global override map
      n === Co ? void 0 : Co
      // then global default map
    ].filter((o) => !!o)
  });
  e.common.issues.push(r);
}
class Ie {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, n) {
    const r = [];
    for (const o of n) {
      if (o.status === "aborted")
        return X;
      o.status === "dirty" && t.dirty(), r.push(o.value);
    }
    return { status: t.value, value: r };
  }
  static async mergeObjectAsync(t, n) {
    const r = [];
    for (const o of n) {
      const s = await o.key, a = await o.value;
      r.push({
        key: s,
        value: a
      });
    }
    return Ie.mergeObjectSync(t, r);
  }
  static mergeObjectSync(t, n) {
    const r = {};
    for (const o of n) {
      const { key: s, value: a } = o;
      if (s.status === "aborted" || a.status === "aborted")
        return X;
      s.status === "dirty" && t.dirty(), a.status === "dirty" && t.dirty(), s.value !== "__proto__" && (typeof a.value < "u" || o.alwaysSet) && (r[s.value] = a.value);
    }
    return { status: t.value, value: r };
  }
}
const X = Object.freeze({
  status: "aborted"
}), Rn = (e) => ({ status: "dirty", value: e }), Ve = (e) => ({ status: "valid", value: e }), qs = (e) => e.status === "aborted", Ys = (e) => e.status === "dirty", fn = (e) => e.status === "valid", mr = (e) => typeof Promise < "u" && e instanceof Promise;
var W;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t?.message;
})(W || (W = {}));
class Qe {
  constructor(t, n, r, o) {
    this._cachedPath = [], this.parent = t, this.data = n, this._path = r, this._key = o;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Qs = (e, t) => {
  if (fn(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new st(e.common.issues);
      return this._error = n, this._error;
    }
  };
};
function ne(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: n, required_error: r, description: o } = e;
  if (t && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: o } : { errorMap: (a, i) => {
    const { message: u } = e;
    return a.code === "invalid_enum_value" ? { message: u ?? i.defaultError } : typeof i.data > "u" ? { message: u ?? r ?? i.defaultError } : a.code !== "invalid_type" ? { message: i.defaultError } : { message: u ?? n ?? i.defaultError };
  }, description: o };
}
class ae {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return mt(t.data);
  }
  _getOrReturnCtx(t, n) {
    return n || {
      common: t.parent.common,
      data: t.data,
      parsedType: mt(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new Ie(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: mt(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const n = this._parse(t);
    if (mr(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(t) {
    const n = this._parse(t);
    return Promise.resolve(n);
  }
  parse(t, n) {
    const r = this.safeParse(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(t, n) {
    const r = {
      common: {
        issues: [],
        async: n?.async ?? !1,
        contextualErrorMap: n?.errorMap
      },
      path: n?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: mt(t)
    }, o = this._parseSync({ data: t, path: r.path, parent: r });
    return Qs(r, o);
  }
  "~validate"(t) {
    const n = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: mt(t)
    };
    if (!this["~standard"].async)
      try {
        const r = this._parseSync({ data: t, path: [], parent: n });
        return fn(r) ? {
          value: r.value
        } : {
          issues: n.common.issues
        };
      } catch (r) {
        r?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = !0), n.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: n }).then((r) => fn(r) ? {
      value: r.value
    } : {
      issues: n.common.issues
    });
  }
  async parseAsync(t, n) {
    const r = await this.safeParseAsync(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(t, n) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: n?.errorMap,
        async: !0
      },
      path: n?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: mt(t)
    }, o = this._parse({ data: t, path: r.path, parent: r }), s = await (mr(o) ? o : Promise.resolve(o));
    return Qs(r, s);
  }
  refine(t, n) {
    const r = (o) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(o) : n;
    return this._refinement((o, s) => {
      const a = t(o), i = () => s.addIssue({
        code: A.custom,
        ...r(o)
      });
      return typeof Promise < "u" && a instanceof Promise ? a.then((u) => u ? !0 : (i(), !1)) : a ? !0 : (i(), !1);
    });
  }
  refinement(t, n) {
    return this._refinement((r, o) => t(r) ? !0 : (o.addIssue(typeof n == "function" ? n(r, o) : n), !1));
  }
  _refinement(t) {
    return new mn({
      schema: this,
      typeName: Y.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (n) => this["~validate"](n)
    };
  }
  optional() {
    return Ct.create(this, this._def);
  }
  nullable() {
    return gn.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return qe.create(this);
  }
  promise() {
    return wr.create(this, this._def);
  }
  or(t) {
    return vr.create([this, t], this._def);
  }
  and(t) {
    return yr.create(this, t, this._def);
  }
  transform(t) {
    return new mn({
      ...ne(this._def),
      schema: this,
      typeName: Y.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const n = typeof t == "function" ? t : () => t;
    return new To({
      ...ne(this._def),
      innerType: this,
      defaultValue: n,
      typeName: Y.ZodDefault
    });
  }
  brand() {
    return new zd({
      typeName: Y.ZodBranded,
      type: this,
      ...ne(this._def)
    });
  }
  catch(t) {
    const n = typeof t == "function" ? t : () => t;
    return new No({
      ...ne(this._def),
      innerType: this,
      catchValue: n,
      typeName: Y.ZodCatch
    });
  }
  describe(t) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return as.create(this, t);
  }
  readonly() {
    return ko.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const xd = /^c[^\s-]{8,}$/i, _d = /^[0-9a-z]+$/, Sd = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Cd = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Ed = /^[a-z0-9_-]{21}$/i, Rd = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Td = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Nd = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, kd = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let no;
const Ad = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Id = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Od = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Pd = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Md = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Dd = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, ci = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Ld = new RegExp(`^${ci}$`);
function li(e) {
  let t = "[0-5]\\d";
  e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`);
  const n = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${n}`;
}
function Fd(e) {
  return new RegExp(`^${li(e)}$`);
}
function $d(e) {
  let t = `${ci}T${li(e)}`;
  const n = [];
  return n.push(e.local ? "Z?" : "Z"), e.offset && n.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${n.join("|")})`, new RegExp(`^${t}$`);
}
function jd(e, t) {
  return !!((t === "v4" || !t) && Ad.test(e) || (t === "v6" || !t) && Od.test(e));
}
function Vd(e, t) {
  if (!Rd.test(e))
    return !1;
  try {
    const [n] = e.split(".");
    if (!n)
      return !1;
    const r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), o = JSON.parse(atob(r));
    return !(typeof o != "object" || o === null || "typ" in o && o?.typ !== "JWT" || !o.alg || t && o.alg !== t);
  } catch {
    return !1;
  }
}
function Bd(e, t) {
  return !!((t === "v4" || !t) && Id.test(e) || (t === "v6" || !t) && Pd.test(e));
}
class rt extends ae {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== V.string) {
      const s = this._getOrReturnCtx(t);
      return D(s, {
        code: A.invalid_type,
        expected: V.string,
        received: s.parsedType
      }), X;
    }
    const r = new Ie();
    let o;
    for (const s of this._def.checks)
      if (s.kind === "min")
        t.data.length < s.value && (o = this._getOrReturnCtx(t, o), D(o, {
          code: A.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), r.dirty());
      else if (s.kind === "max")
        t.data.length > s.value && (o = this._getOrReturnCtx(t, o), D(o, {
          code: A.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), r.dirty());
      else if (s.kind === "length") {
        const a = t.data.length > s.value, i = t.data.length < s.value;
        (a || i) && (o = this._getOrReturnCtx(t, o), a ? D(o, {
          code: A.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : i && D(o, {
          code: A.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), r.dirty());
      } else if (s.kind === "email")
        Nd.test(t.data) || (o = this._getOrReturnCtx(t, o), D(o, {
          validation: "email",
          code: A.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "emoji")
        no || (no = new RegExp(kd, "u")), no.test(t.data) || (o = this._getOrReturnCtx(t, o), D(o, {
          validation: "emoji",
          code: A.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "uuid")
        Cd.test(t.data) || (o = this._getOrReturnCtx(t, o), D(o, {
          validation: "uuid",
          code: A.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "nanoid")
        Ed.test(t.data) || (o = this._getOrReturnCtx(t, o), D(o, {
          validation: "nanoid",
          code: A.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "cuid")
        xd.test(t.data) || (o = this._getOrReturnCtx(t, o), D(o, {
          validation: "cuid",
          code: A.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "cuid2")
        _d.test(t.data) || (o = this._getOrReturnCtx(t, o), D(o, {
          validation: "cuid2",
          code: A.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "ulid")
        Sd.test(t.data) || (o = this._getOrReturnCtx(t, o), D(o, {
          validation: "ulid",
          code: A.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "url")
        try {
          new URL(t.data);
        } catch {
          o = this._getOrReturnCtx(t, o), D(o, {
            validation: "url",
            code: A.invalid_string,
            message: s.message
          }), r.dirty();
        }
      else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(t.data) || (o = this._getOrReturnCtx(t, o), D(o, {
        validation: "regex",
        code: A.invalid_string,
        message: s.message
      }), r.dirty())) : s.kind === "trim" ? t.data = t.data.trim() : s.kind === "includes" ? t.data.includes(s.value, s.position) || (o = this._getOrReturnCtx(t, o), D(o, {
        code: A.invalid_string,
        validation: { includes: s.value, position: s.position },
        message: s.message
      }), r.dirty()) : s.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : s.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : s.kind === "startsWith" ? t.data.startsWith(s.value) || (o = this._getOrReturnCtx(t, o), D(o, {
        code: A.invalid_string,
        validation: { startsWith: s.value },
        message: s.message
      }), r.dirty()) : s.kind === "endsWith" ? t.data.endsWith(s.value) || (o = this._getOrReturnCtx(t, o), D(o, {
        code: A.invalid_string,
        validation: { endsWith: s.value },
        message: s.message
      }), r.dirty()) : s.kind === "datetime" ? $d(s).test(t.data) || (o = this._getOrReturnCtx(t, o), D(o, {
        code: A.invalid_string,
        validation: "datetime",
        message: s.message
      }), r.dirty()) : s.kind === "date" ? Ld.test(t.data) || (o = this._getOrReturnCtx(t, o), D(o, {
        code: A.invalid_string,
        validation: "date",
        message: s.message
      }), r.dirty()) : s.kind === "time" ? Fd(s).test(t.data) || (o = this._getOrReturnCtx(t, o), D(o, {
        code: A.invalid_string,
        validation: "time",
        message: s.message
      }), r.dirty()) : s.kind === "duration" ? Td.test(t.data) || (o = this._getOrReturnCtx(t, o), D(o, {
        validation: "duration",
        code: A.invalid_string,
        message: s.message
      }), r.dirty()) : s.kind === "ip" ? jd(t.data, s.version) || (o = this._getOrReturnCtx(t, o), D(o, {
        validation: "ip",
        code: A.invalid_string,
        message: s.message
      }), r.dirty()) : s.kind === "jwt" ? Vd(t.data, s.alg) || (o = this._getOrReturnCtx(t, o), D(o, {
        validation: "jwt",
        code: A.invalid_string,
        message: s.message
      }), r.dirty()) : s.kind === "cidr" ? Bd(t.data, s.version) || (o = this._getOrReturnCtx(t, o), D(o, {
        validation: "cidr",
        code: A.invalid_string,
        message: s.message
      }), r.dirty()) : s.kind === "base64" ? Md.test(t.data) || (o = this._getOrReturnCtx(t, o), D(o, {
        validation: "base64",
        code: A.invalid_string,
        message: s.message
      }), r.dirty()) : s.kind === "base64url" ? Dd.test(t.data) || (o = this._getOrReturnCtx(t, o), D(o, {
        validation: "base64url",
        code: A.invalid_string,
        message: s.message
      }), r.dirty()) : ie.assertNever(s);
    return { status: r.value, value: t.data };
  }
  _regex(t, n, r) {
    return this.refinement((o) => t.test(o), {
      validation: n,
      code: A.invalid_string,
      ...W.errToObj(r)
    });
  }
  _addCheck(t) {
    return new rt({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...W.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...W.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...W.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...W.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...W.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...W.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...W.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...W.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...W.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...W.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...W.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...W.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...W.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof t?.precision > "u" ? null : t?.precision,
      offset: t?.offset ?? !1,
      local: t?.local ?? !1,
      ...W.errToObj(t?.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof t?.precision > "u" ? null : t?.precision,
      ...W.errToObj(t?.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...W.errToObj(t) });
  }
  regex(t, n) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...W.errToObj(n)
    });
  }
  includes(t, n) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: n?.position,
      ...W.errToObj(n?.message)
    });
  }
  startsWith(t, n) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...W.errToObj(n)
    });
  }
  endsWith(t, n) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...W.errToObj(n)
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...W.errToObj(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...W.errToObj(n)
    });
  }
  length(t, n) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...W.errToObj(n)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, W.errToObj(t));
  }
  trim() {
    return new rt({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new rt({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new rt({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
rt.create = (e) => new rt({
  checks: [],
  typeName: Y.ZodString,
  coerce: e?.coerce ?? !1,
  ...ne(e)
});
function Ud(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, o = n > r ? n : r, s = Number.parseInt(e.toFixed(o).replace(".", "")), a = Number.parseInt(t.toFixed(o).replace(".", ""));
  return s % a / 10 ** o;
}
class pn extends ae {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== V.number) {
      const s = this._getOrReturnCtx(t);
      return D(s, {
        code: A.invalid_type,
        expected: V.number,
        received: s.parsedType
      }), X;
    }
    let r;
    const o = new Ie();
    for (const s of this._def.checks)
      s.kind === "int" ? ie.isInteger(t.data) || (r = this._getOrReturnCtx(t, r), D(r, {
        code: A.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), o.dirty()) : s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (r = this._getOrReturnCtx(t, r), D(r, {
        code: A.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), o.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (r = this._getOrReturnCtx(t, r), D(r, {
        code: A.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), o.dirty()) : s.kind === "multipleOf" ? Ud(t.data, s.value) !== 0 && (r = this._getOrReturnCtx(t, r), D(r, {
        code: A.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), o.dirty()) : s.kind === "finite" ? Number.isFinite(t.data) || (r = this._getOrReturnCtx(t, r), D(r, {
        code: A.not_finite,
        message: s.message
      }), o.dirty()) : ie.assertNever(s);
    return { status: o.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, W.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, W.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, W.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, W.toString(n));
  }
  setLimit(t, n, r, o) {
    return new pn({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: W.toString(o)
        }
      ]
    });
  }
  _addCheck(t) {
    return new pn({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: W.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: W.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: W.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: W.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: W.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: W.toString(n)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: W.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: W.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: W.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && ie.isInteger(t.value));
  }
  get isFinite() {
    let t = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(t);
  }
}
pn.create = (e) => new pn({
  checks: [],
  typeName: Y.ZodNumber,
  coerce: e?.coerce || !1,
  ...ne(e)
});
class Mn extends ae {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== V.bigint)
      return this._getInvalidInput(t);
    let r;
    const o = new Ie();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (r = this._getOrReturnCtx(t, r), D(r, {
        code: A.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), o.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (r = this._getOrReturnCtx(t, r), D(r, {
        code: A.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), o.dirty()) : s.kind === "multipleOf" ? t.data % s.value !== BigInt(0) && (r = this._getOrReturnCtx(t, r), D(r, {
        code: A.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), o.dirty()) : ie.assertNever(s);
    return { status: o.value, value: t.data };
  }
  _getInvalidInput(t) {
    const n = this._getOrReturnCtx(t);
    return D(n, {
      code: A.invalid_type,
      expected: V.bigint,
      received: n.parsedType
    }), X;
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, W.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, W.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, W.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, W.toString(n));
  }
  setLimit(t, n, r, o) {
    return new Mn({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: W.toString(o)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Mn({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: W.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: W.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: W.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: W.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: W.toString(n)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
Mn.create = (e) => new Mn({
  checks: [],
  typeName: Y.ZodBigInt,
  coerce: e?.coerce ?? !1,
  ...ne(e)
});
class Eo extends ae {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== V.boolean) {
      const r = this._getOrReturnCtx(t);
      return D(r, {
        code: A.invalid_type,
        expected: V.boolean,
        received: r.parsedType
      }), X;
    }
    return Ve(t.data);
  }
}
Eo.create = (e) => new Eo({
  typeName: Y.ZodBoolean,
  coerce: e?.coerce || !1,
  ...ne(e)
});
class gr extends ae {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== V.date) {
      const s = this._getOrReturnCtx(t);
      return D(s, {
        code: A.invalid_type,
        expected: V.date,
        received: s.parsedType
      }), X;
    }
    if (Number.isNaN(t.data.getTime())) {
      const s = this._getOrReturnCtx(t);
      return D(s, {
        code: A.invalid_date
      }), X;
    }
    const r = new Ie();
    let o;
    for (const s of this._def.checks)
      s.kind === "min" ? t.data.getTime() < s.value && (o = this._getOrReturnCtx(t, o), D(o, {
        code: A.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), r.dirty()) : s.kind === "max" ? t.data.getTime() > s.value && (o = this._getOrReturnCtx(t, o), D(o, {
        code: A.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), r.dirty()) : ie.assertNever(s);
    return {
      status: r.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new gr({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: W.toString(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: W.toString(n)
    });
  }
  get minDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
}
gr.create = (e) => new gr({
  checks: [],
  coerce: e?.coerce || !1,
  typeName: Y.ZodDate,
  ...ne(e)
});
class Xs extends ae {
  _parse(t) {
    if (this._getType(t) !== V.symbol) {
      const r = this._getOrReturnCtx(t);
      return D(r, {
        code: A.invalid_type,
        expected: V.symbol,
        received: r.parsedType
      }), X;
    }
    return Ve(t.data);
  }
}
Xs.create = (e) => new Xs({
  typeName: Y.ZodSymbol,
  ...ne(e)
});
class Js extends ae {
  _parse(t) {
    if (this._getType(t) !== V.undefined) {
      const r = this._getOrReturnCtx(t);
      return D(r, {
        code: A.invalid_type,
        expected: V.undefined,
        received: r.parsedType
      }), X;
    }
    return Ve(t.data);
  }
}
Js.create = (e) => new Js({
  typeName: Y.ZodUndefined,
  ...ne(e)
});
class ea extends ae {
  _parse(t) {
    if (this._getType(t) !== V.null) {
      const r = this._getOrReturnCtx(t);
      return D(r, {
        code: A.invalid_type,
        expected: V.null,
        received: r.parsedType
      }), X;
    }
    return Ve(t.data);
  }
}
ea.create = (e) => new ea({
  typeName: Y.ZodNull,
  ...ne(e)
});
class Dn extends ae {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return Ve(t.data);
  }
}
Dn.create = (e) => new Dn({
  typeName: Y.ZodAny,
  ...ne(e)
});
class ta extends ae {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return Ve(t.data);
  }
}
ta.create = (e) => new ta({
  typeName: Y.ZodUnknown,
  ...ne(e)
});
class Et extends ae {
  _parse(t) {
    const n = this._getOrReturnCtx(t);
    return D(n, {
      code: A.invalid_type,
      expected: V.never,
      received: n.parsedType
    }), X;
  }
}
Et.create = (e) => new Et({
  typeName: Y.ZodNever,
  ...ne(e)
});
class na extends ae {
  _parse(t) {
    if (this._getType(t) !== V.undefined) {
      const r = this._getOrReturnCtx(t);
      return D(r, {
        code: A.invalid_type,
        expected: V.void,
        received: r.parsedType
      }), X;
    }
    return Ve(t.data);
  }
}
na.create = (e) => new na({
  typeName: Y.ZodVoid,
  ...ne(e)
});
class qe extends ae {
  _parse(t) {
    const { ctx: n, status: r } = this._processInputParams(t), o = this._def;
    if (n.parsedType !== V.array)
      return D(n, {
        code: A.invalid_type,
        expected: V.array,
        received: n.parsedType
      }), X;
    if (o.exactLength !== null) {
      const a = n.data.length > o.exactLength.value, i = n.data.length < o.exactLength.value;
      (a || i) && (D(n, {
        code: a ? A.too_big : A.too_small,
        minimum: i ? o.exactLength.value : void 0,
        maximum: a ? o.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: o.exactLength.message
      }), r.dirty());
    }
    if (o.minLength !== null && n.data.length < o.minLength.value && (D(n, {
      code: A.too_small,
      minimum: o.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.minLength.message
    }), r.dirty()), o.maxLength !== null && n.data.length > o.maxLength.value && (D(n, {
      code: A.too_big,
      maximum: o.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((a, i) => o.type._parseAsync(new Qe(n, a, n.path, i)))).then((a) => Ie.mergeArray(r, a));
    const s = [...n.data].map((a, i) => o.type._parseSync(new Qe(n, a, n.path, i)));
    return Ie.mergeArray(r, s);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new qe({
      ...this._def,
      minLength: { value: t, message: W.toString(n) }
    });
  }
  max(t, n) {
    return new qe({
      ...this._def,
      maxLength: { value: t, message: W.toString(n) }
    });
  }
  length(t, n) {
    return new qe({
      ...this._def,
      exactLength: { value: t, message: W.toString(n) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
qe.create = (e, t) => new qe({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Y.ZodArray,
  ...ne(t)
});
function Xt(e) {
  if (e instanceof Ce) {
    const t = {};
    for (const n in e.shape) {
      const r = e.shape[n];
      t[n] = Ct.create(Xt(r));
    }
    return new Ce({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof qe ? new qe({
    ...e._def,
    type: Xt(e.element)
  }) : e instanceof Ct ? Ct.create(Xt(e.unwrap())) : e instanceof gn ? gn.create(Xt(e.unwrap())) : e instanceof jt ? jt.create(e.items.map((t) => Xt(t))) : e;
}
class Ce extends ae {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), n = ie.objectKeys(t);
    return this._cached = { shape: t, keys: n }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== V.object) {
      const l = this._getOrReturnCtx(t);
      return D(l, {
        code: A.invalid_type,
        expected: V.object,
        received: l.parsedType
      }), X;
    }
    const { status: r, ctx: o } = this._processInputParams(t), { shape: s, keys: a } = this._getCached(), i = [];
    if (!(this._def.catchall instanceof Et && this._def.unknownKeys === "strip"))
      for (const l in o.data)
        a.includes(l) || i.push(l);
    const u = [];
    for (const l of a) {
      const d = s[l], f = o.data[l];
      u.push({
        key: { status: "valid", value: l },
        value: d._parse(new Qe(o, f, o.path, l)),
        alwaysSet: l in o.data
      });
    }
    if (this._def.catchall instanceof Et) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const d of i)
          u.push({
            key: { status: "valid", value: d },
            value: { status: "valid", value: o.data[d] }
          });
      else if (l === "strict")
        i.length > 0 && (D(o, {
          code: A.unrecognized_keys,
          keys: i
        }), r.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const d of i) {
        const f = o.data[d];
        u.push({
          key: { status: "valid", value: d },
          value: l._parse(
            new Qe(o, f, o.path, d)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: d in o.data
        });
      }
    }
    return o.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const d of u) {
        const f = await d.key, g = await d.value;
        l.push({
          key: f,
          value: g,
          alwaysSet: d.alwaysSet
        });
      }
      return l;
    }).then((l) => Ie.mergeObjectSync(r, l)) : Ie.mergeObjectSync(r, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return W.errToObj, new Ce({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (n, r) => {
          const o = this._def.errorMap?.(n, r).message ?? r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: W.errToObj(t).message ?? o
          } : {
            message: o
          };
        }
      } : {}
    });
  }
  strip() {
    return new Ce({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Ce({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new Ce({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new Ce({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: Y.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, n) {
    return this.augment({ [t]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new Ce({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const n = {};
    for (const r of ie.objectKeys(t))
      t[r] && this.shape[r] && (n[r] = this.shape[r]);
    return new Ce({
      ...this._def,
      shape: () => n
    });
  }
  omit(t) {
    const n = {};
    for (const r of ie.objectKeys(this.shape))
      t[r] || (n[r] = this.shape[r]);
    return new Ce({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return Xt(this);
  }
  partial(t) {
    const n = {};
    for (const r of ie.objectKeys(this.shape)) {
      const o = this.shape[r];
      t && !t[r] ? n[r] = o : n[r] = o.optional();
    }
    return new Ce({
      ...this._def,
      shape: () => n
    });
  }
  required(t) {
    const n = {};
    for (const r of ie.objectKeys(this.shape))
      if (t && !t[r])
        n[r] = this.shape[r];
      else {
        let s = this.shape[r];
        for (; s instanceof Ct; )
          s = s._def.innerType;
        n[r] = s;
      }
    return new Ce({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return ui(ie.objectKeys(this.shape));
  }
}
Ce.create = (e, t) => new Ce({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Et.create(),
  typeName: Y.ZodObject,
  ...ne(t)
});
Ce.strictCreate = (e, t) => new Ce({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Et.create(),
  typeName: Y.ZodObject,
  ...ne(t)
});
Ce.lazycreate = (e, t) => new Ce({
  shape: e,
  unknownKeys: "strip",
  catchall: Et.create(),
  typeName: Y.ZodObject,
  ...ne(t)
});
class vr extends ae {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = this._def.options;
    function o(s) {
      for (const i of s)
        if (i.result.status === "valid")
          return i.result;
      for (const i of s)
        if (i.result.status === "dirty")
          return n.common.issues.push(...i.ctx.common.issues), i.result;
      const a = s.map((i) => new st(i.ctx.common.issues));
      return D(n, {
        code: A.invalid_union,
        unionErrors: a
      }), X;
    }
    if (n.common.async)
      return Promise.all(r.map(async (s) => {
        const a = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: n.data,
            path: n.path,
            parent: a
          }),
          ctx: a
        };
      })).then(o);
    {
      let s;
      const a = [];
      for (const u of r) {
        const l = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, d = u._parseSync({
          data: n.data,
          path: n.path,
          parent: l
        });
        if (d.status === "valid")
          return d;
        d.status === "dirty" && !s && (s = { result: d, ctx: l }), l.common.issues.length && a.push(l.common.issues);
      }
      if (s)
        return n.common.issues.push(...s.ctx.common.issues), s.result;
      const i = a.map((u) => new st(u));
      return D(n, {
        code: A.invalid_union,
        unionErrors: i
      }), X;
    }
  }
  get options() {
    return this._def.options;
  }
}
vr.create = (e, t) => new vr({
  options: e,
  typeName: Y.ZodUnion,
  ...ne(t)
});
function Ro(e, t) {
  const n = mt(e), r = mt(t);
  if (e === t)
    return { valid: !0, data: e };
  if (n === V.object && r === V.object) {
    const o = ie.objectKeys(t), s = ie.objectKeys(e).filter((i) => o.indexOf(i) !== -1), a = { ...e, ...t };
    for (const i of s) {
      const u = Ro(e[i], t[i]);
      if (!u.valid)
        return { valid: !1 };
      a[i] = u.data;
    }
    return { valid: !0, data: a };
  } else if (n === V.array && r === V.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const o = [];
    for (let s = 0; s < e.length; s++) {
      const a = e[s], i = t[s], u = Ro(a, i);
      if (!u.valid)
        return { valid: !1 };
      o.push(u.data);
    }
    return { valid: !0, data: o };
  } else return n === V.date && r === V.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class yr extends ae {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), o = (s, a) => {
      if (qs(s) || qs(a))
        return X;
      const i = Ro(s.value, a.value);
      return i.valid ? ((Ys(s) || Ys(a)) && n.dirty(), { status: n.value, value: i.data }) : (D(r, {
        code: A.invalid_intersection_types
      }), X);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([s, a]) => o(s, a)) : o(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
yr.create = (e, t, n) => new yr({
  left: e,
  right: t,
  typeName: Y.ZodIntersection,
  ...ne(n)
});
class jt extends ae {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== V.array)
      return D(r, {
        code: A.invalid_type,
        expected: V.array,
        received: r.parsedType
      }), X;
    if (r.data.length < this._def.items.length)
      return D(r, {
        code: A.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), X;
    !this._def.rest && r.data.length > this._def.items.length && (D(r, {
      code: A.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const s = [...r.data].map((a, i) => {
      const u = this._def.items[i] || this._def.rest;
      return u ? u._parse(new Qe(r, a, r.path, i)) : null;
    }).filter((a) => !!a);
    return r.common.async ? Promise.all(s).then((a) => Ie.mergeArray(n, a)) : Ie.mergeArray(n, s);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new jt({
      ...this._def,
      rest: t
    });
  }
}
jt.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new jt({
    items: e,
    typeName: Y.ZodTuple,
    rest: null,
    ...ne(t)
  });
};
class br extends ae {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== V.object)
      return D(r, {
        code: A.invalid_type,
        expected: V.object,
        received: r.parsedType
      }), X;
    const o = [], s = this._def.keyType, a = this._def.valueType;
    for (const i in r.data)
      o.push({
        key: s._parse(new Qe(r, i, r.path, i)),
        value: a._parse(new Qe(r, r.data[i], r.path, i)),
        alwaysSet: i in r.data
      });
    return r.common.async ? Ie.mergeObjectAsync(n, o) : Ie.mergeObjectSync(n, o);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, n, r) {
    return n instanceof ae ? new br({
      keyType: t,
      valueType: n,
      typeName: Y.ZodRecord,
      ...ne(r)
    }) : new br({
      keyType: rt.create(),
      valueType: t,
      typeName: Y.ZodRecord,
      ...ne(n)
    });
  }
}
class ra extends ae {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== V.map)
      return D(r, {
        code: A.invalid_type,
        expected: V.map,
        received: r.parsedType
      }), X;
    const o = this._def.keyType, s = this._def.valueType, a = [...r.data.entries()].map(([i, u], l) => ({
      key: o._parse(new Qe(r, i, r.path, [l, "key"])),
      value: s._parse(new Qe(r, u, r.path, [l, "value"]))
    }));
    if (r.common.async) {
      const i = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of a) {
          const l = await u.key, d = await u.value;
          if (l.status === "aborted" || d.status === "aborted")
            return X;
          (l.status === "dirty" || d.status === "dirty") && n.dirty(), i.set(l.value, d.value);
        }
        return { status: n.value, value: i };
      });
    } else {
      const i = /* @__PURE__ */ new Map();
      for (const u of a) {
        const l = u.key, d = u.value;
        if (l.status === "aborted" || d.status === "aborted")
          return X;
        (l.status === "dirty" || d.status === "dirty") && n.dirty(), i.set(l.value, d.value);
      }
      return { status: n.value, value: i };
    }
  }
}
ra.create = (e, t, n) => new ra({
  valueType: t,
  keyType: e,
  typeName: Y.ZodMap,
  ...ne(n)
});
class Ln extends ae {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== V.set)
      return D(r, {
        code: A.invalid_type,
        expected: V.set,
        received: r.parsedType
      }), X;
    const o = this._def;
    o.minSize !== null && r.data.size < o.minSize.value && (D(r, {
      code: A.too_small,
      minimum: o.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.minSize.message
    }), n.dirty()), o.maxSize !== null && r.data.size > o.maxSize.value && (D(r, {
      code: A.too_big,
      maximum: o.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.maxSize.message
    }), n.dirty());
    const s = this._def.valueType;
    function a(u) {
      const l = /* @__PURE__ */ new Set();
      for (const d of u) {
        if (d.status === "aborted")
          return X;
        d.status === "dirty" && n.dirty(), l.add(d.value);
      }
      return { status: n.value, value: l };
    }
    const i = [...r.data.values()].map((u, l) => s._parse(new Qe(r, u, r.path, l)));
    return r.common.async ? Promise.all(i).then((u) => a(u)) : a(i);
  }
  min(t, n) {
    return new Ln({
      ...this._def,
      minSize: { value: t, message: W.toString(n) }
    });
  }
  max(t, n) {
    return new Ln({
      ...this._def,
      maxSize: { value: t, message: W.toString(n) }
    });
  }
  size(t, n) {
    return this.min(t, n).max(t, n);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Ln.create = (e, t) => new Ln({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: Y.ZodSet,
  ...ne(t)
});
class oa extends ae {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
oa.create = (e, t) => new oa({
  getter: e,
  typeName: Y.ZodLazy,
  ...ne(t)
});
class sa extends ae {
  _parse(t) {
    if (t.data !== this._def.value) {
      const n = this._getOrReturnCtx(t);
      return D(n, {
        received: n.data,
        code: A.invalid_literal,
        expected: this._def.value
      }), X;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
sa.create = (e, t) => new sa({
  value: e,
  typeName: Y.ZodLiteral,
  ...ne(t)
});
function ui(e, t) {
  return new hn({
    values: e,
    typeName: Y.ZodEnum,
    ...ne(t)
  });
}
class hn extends ae {
  _parse(t) {
    if (typeof t.data != "string") {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return D(n, {
        expected: ie.joinValues(r),
        received: n.parsedType,
        code: A.invalid_type
      }), X;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(t.data)) {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return D(n, {
        received: n.data,
        code: A.invalid_enum_value,
        options: r
      }), X;
    }
    return Ve(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Values() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  extract(t, n = this._def) {
    return hn.create(t, {
      ...this._def,
      ...n
    });
  }
  exclude(t, n = this._def) {
    return hn.create(this.options.filter((r) => !t.includes(r)), {
      ...this._def,
      ...n
    });
  }
}
hn.create = ui;
class aa extends ae {
  _parse(t) {
    const n = ie.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(t);
    if (r.parsedType !== V.string && r.parsedType !== V.number) {
      const o = ie.objectValues(n);
      return D(r, {
        expected: ie.joinValues(o),
        received: r.parsedType,
        code: A.invalid_type
      }), X;
    }
    if (this._cache || (this._cache = new Set(ie.getValidEnumValues(this._def.values))), !this._cache.has(t.data)) {
      const o = ie.objectValues(n);
      return D(r, {
        received: r.data,
        code: A.invalid_enum_value,
        options: o
      }), X;
    }
    return Ve(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
aa.create = (e, t) => new aa({
  values: e,
  typeName: Y.ZodNativeEnum,
  ...ne(t)
});
class wr extends ae {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== V.promise && n.common.async === !1)
      return D(n, {
        code: A.invalid_type,
        expected: V.promise,
        received: n.parsedType
      }), X;
    const r = n.parsedType === V.promise ? n.data : Promise.resolve(n.data);
    return Ve(r.then((o) => this._def.type.parseAsync(o, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
wr.create = (e, t) => new wr({
  type: e,
  typeName: Y.ZodPromise,
  ...ne(t)
});
class mn extends ae {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Y.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), o = this._def.effect || null, s = {
      addIssue: (a) => {
        D(r, a), a.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), o.type === "preprocess") {
      const a = o.transform(r.data, s);
      if (r.common.async)
        return Promise.resolve(a).then(async (i) => {
          if (n.value === "aborted")
            return X;
          const u = await this._def.schema._parseAsync({
            data: i,
            path: r.path,
            parent: r
          });
          return u.status === "aborted" ? X : u.status === "dirty" || n.value === "dirty" ? Rn(u.value) : u;
        });
      {
        if (n.value === "aborted")
          return X;
        const i = this._def.schema._parseSync({
          data: a,
          path: r.path,
          parent: r
        });
        return i.status === "aborted" ? X : i.status === "dirty" || n.value === "dirty" ? Rn(i.value) : i;
      }
    }
    if (o.type === "refinement") {
      const a = (i) => {
        const u = o.refinement(i, s);
        if (r.common.async)
          return Promise.resolve(u);
        if (u instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return i;
      };
      if (r.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return i.status === "aborted" ? X : (i.status === "dirty" && n.dirty(), a(i.value), { status: n.value, value: i.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((i) => i.status === "aborted" ? X : (i.status === "dirty" && n.dirty(), a(i.value).then(() => ({ status: n.value, value: i.value }))));
    }
    if (o.type === "transform")
      if (r.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!fn(a))
          return X;
        const i = o.transform(a.value, s);
        if (i instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: i };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((a) => fn(a) ? Promise.resolve(o.transform(a.value, s)).then((i) => ({
          status: n.value,
          value: i
        })) : X);
    ie.assertNever(o);
  }
}
mn.create = (e, t, n) => new mn({
  schema: e,
  typeName: Y.ZodEffects,
  effect: t,
  ...ne(n)
});
mn.createWithPreprocess = (e, t, n) => new mn({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: Y.ZodEffects,
  ...ne(n)
});
class Ct extends ae {
  _parse(t) {
    return this._getType(t) === V.undefined ? Ve(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ct.create = (e, t) => new Ct({
  innerType: e,
  typeName: Y.ZodOptional,
  ...ne(t)
});
class gn extends ae {
  _parse(t) {
    return this._getType(t) === V.null ? Ve(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
gn.create = (e, t) => new gn({
  innerType: e,
  typeName: Y.ZodNullable,
  ...ne(t)
});
class To extends ae {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    let r = n.data;
    return n.parsedType === V.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
To.create = (e, t) => new To({
  innerType: e,
  typeName: Y.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...ne(t)
});
class No extends ae {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, o = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return mr(o) ? o.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new st(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new st(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
No.create = (e, t) => new No({
  innerType: e,
  typeName: Y.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...ne(t)
});
class ia extends ae {
  _parse(t) {
    if (this._getType(t) !== V.nan) {
      const r = this._getOrReturnCtx(t);
      return D(r, {
        code: A.invalid_type,
        expected: V.nan,
        received: r.parsedType
      }), X;
    }
    return { status: "valid", value: t.data };
  }
}
ia.create = (e) => new ia({
  typeName: Y.ZodNaN,
  ...ne(e)
});
class zd extends ae {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class as extends ae {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return s.status === "aborted" ? X : s.status === "dirty" ? (n.dirty(), Rn(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const o = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return o.status === "aborted" ? X : o.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: o.value
      }) : this._def.out._parseSync({
        data: o.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(t, n) {
    return new as({
      in: t,
      out: n,
      typeName: Y.ZodPipeline
    });
  }
}
class ko extends ae {
  _parse(t) {
    const n = this._def.innerType._parse(t), r = (o) => (fn(o) && (o.value = Object.freeze(o.value)), o);
    return mr(n) ? n.then((o) => r(o)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ko.create = (e, t) => new ko({
  innerType: e,
  typeName: Y.ZodReadonly,
  ...ne(t)
});
function ca(e, t) {
  const n = typeof e == "function" ? e(t) : typeof e == "string" ? { message: e } : e;
  return typeof n == "string" ? { message: n } : n;
}
function Wd(e, t = {}, n) {
  return e ? Dn.create().superRefine((r, o) => {
    const s = e(r);
    if (s instanceof Promise)
      return s.then((a) => {
        if (!a) {
          const i = ca(t, r), u = i.fatal ?? n ?? !0;
          o.addIssue({ code: "custom", ...i, fatal: u });
        }
      });
    if (!s) {
      const a = ca(t, r), i = a.fatal ?? n ?? !0;
      o.addIssue({ code: "custom", ...a, fatal: i });
    }
  }) : Dn.create();
}
var Y;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(Y || (Y = {}));
const Hd = (e, t = {
  message: `Input not instance of ${e.name}`
}) => Wd((n) => n instanceof e, t), T = rt.create, vn = pn.create, Fn = Eo.create, di = Dn.create;
Et.create;
const ze = qe.create, xe = Ce.create;
vr.create;
yr.create;
jt.create;
const Kd = br.create, Me = hn.create;
wr.create;
Ct.create;
gn.create;
const Zd = xe({
  id: T().uuid(),
  email: T().email(),
  name: T(),
  role: Me(["admin", "agent", "customer"]),
  tenant_id: T().uuid(),
  created_at: T(),
  updated_at: T()
}), Ww = xe({
  id: T().uuid(),
  name: T(),
  slug: T(),
  status: Me(["active", "inactive", "suspended"]),
  created_at: T(),
  updated_at: T()
}), Gd = xe({
  id: T().uuid(),
  name: T(),
  description: T().optional(),
  tenant_id: T().uuid(),
  status: Me(["active", "inactive"]),
  created_at: T(),
  updated_at: T()
}), qd = xe({
  id: T().uuid(),
  name: T(),
  email: T().email(),
  phone: T().optional(),
  tenant_id: T().uuid(),
  created_at: T(),
  updated_at: T()
}), Yd = xe({
  id: T().uuid(),
  name: T(),
  email: T().email(),
  role: Me(["agent", "admin"]),
  tenant_id: T().uuid(),
  is_active: Fn(),
  created_at: T(),
  updated_at: T()
}), Hw = xe({
  email: T().email(),
  password: T().min(1)
}), Kw = xe({
  access_token: T(),
  refresh_token: T(),
  token_type: T(),
  expires_in: vn(),
  user: Zd
}), is = Me(["open", "in_progress", "resolved", "closed", "pending"]), Ir = Me(["low", "normal", "high", "urgent"]), cs = Me(["question", "incident", "problem", "task"]), fi = Me(["email", "web", "api", "chat", "phone"]), Zw = xe({
  id: T().uuid(),
  number: vn(),
  tenant_id: T().uuid(),
  project_id: T().uuid(),
  subject: T(),
  status: is,
  priority: Ir,
  type: cs,
  source: fi,
  customer_id: T().uuid(),
  assignee_agent_id: T().uuid().nullable(),
  created_at: T(),
  updated_at: T(),
  tags: ze(T()).optional(),
  customer: qd.optional(),
  assigned_agent: Yd.optional(),
  project: Gd.optional()
}), Qd = Me(["customer", "agent", "system"]), Gw = xe({
  id: T().uuid(),
  ticket_id: T().uuid(),
  sender_type: Qd,
  sender_id: T().uuid(),
  content: T(),
  created_at: T(),
  updated_at: T(),
  attachments: ze(xe({
    id: T().uuid(),
    filename: T(),
    original_filename: T(),
    content_type: T(),
    size: vn(),
    storage_path: T()
  })).optional()
}), Xd = Me(["email", "webhook", "api", "chat"]), Jd = Me(["active", "inactive", "error"]), qw = xe({
  id: T().uuid(),
  name: T(),
  type: Xd,
  status: Jd,
  config: Kd(di()),
  tenant_id: T().uuid(),
  project_id: T().uuid(),
  created_at: T(),
  updated_at: T()
}), ef = Me(["info", "warning", "error", "success"]), Yw = xe({
  id: T().uuid(),
  title: T(),
  message: T(),
  type: ef,
  recipient_type: Me(["user", "tenant", "system"]),
  recipient_id: T().uuid(),
  is_read: Fn(),
  tenant_id: T().uuid(),
  created_at: T()
}), Qw = xe({
  data: di(),
  message: T().optional(),
  success: Fn()
}), Xw = xe({
  error: T(),
  details: T().optional(),
  code: T().optional(),
  field: T().optional()
}), tf = xe({
  hasNextPage: Fn(),
  hasPreviousPage: Fn(),
  startCursor: T().nullable(),
  endCursor: T().nullable()
}), Jw = (e) => xe({
  edges: ze(xe({
    node: e,
    cursor: T()
  })),
  pageInfo: tf,
  totalCount: vn()
}), ex = xe({
  subject: T().min(1),
  description: T().optional(),
  priority: Ir.default("normal"),
  type: cs.default("question"),
  customer_id: T().uuid(),
  project_id: T().uuid(),
  tags: ze(T()).optional()
}), tx = xe({
  subject: T().optional(),
  status: is.optional(),
  priority: Ir.optional(),
  assignee_agent_id: T().uuid().nullable().optional(),
  tags: ze(T()).optional()
}), nx = xe({
  content: T().min(1),
  attachments: ze(Hd(File)).optional()
}), rx = xe({
  first: vn().int().positive().max(100).optional(),
  after: T().optional(),
  last: vn().int().positive().max(100).optional(),
  before: T().optional(),
  search: T().optional(),
  sort: T().optional(),
  order: Me(["asc", "desc"]).optional()
}), ox = xe({
  status: ze(is).optional(),
  priority: ze(Ir).optional(),
  type: ze(cs).optional(),
  source: ze(fi).optional(),
  assignee_agent_id: T().uuid().optional(),
  customer_id: T().uuid().optional(),
  project_id: T().uuid().optional(),
  created_after: T().datetime().optional(),
  created_before: T().datetime().optional(),
  updated_after: T().datetime().optional(),
  updated_before: T().datetime().optional(),
  tags: ze(T()).optional()
}), sx = xe({
  startDate: T().datetime().optional(),
  endDate: T().datetime().optional()
});
class nf extends Error {
  constructor(n) {
    super(n.error);
    dt(this, "status");
    dt(this, "code");
    dt(this, "field");
    dt(this, "details");
    this.name = "ApiClientError", this.status = n.status, this.code = n.code, this.field = n.field, this.details = n.details;
  }
}
class rf {
  constructor(t, n = {}, r) {
    dt(this, "baseURL");
    dt(this, "defaultHeaders");
    dt(this, "tenantContext");
    this.baseURL = t.replace(/\/$/, ""), this.defaultHeaders = {
      "Content-Type": "application/json",
      ...n
    }, this.tenantContext = r;
  }
  setAuthToken(t) {
    this.defaultHeaders.Authorization = `Bearer ${t}`;
  }
  setTenantContext(t) {
    this.tenantContext = t;
  }
  buildUrl(t, n) {
    const r = new URL(`${this.baseURL}${t}`);
    return this.tenantContext?.tenantId && r.searchParams.set("tenant_id", this.tenantContext.tenantId), this.tenantContext?.projectId && r.searchParams.set("project_id", this.tenantContext.projectId), n && Object.entries(n).forEach(([o, s]) => {
      s != null && (Array.isArray(s) ? s.forEach((a) => r.searchParams.append(o, String(a))) : r.searchParams.set(o, String(s)));
    }), r.toString();
  }
  async handleResponse(t) {
    const r = t.headers.get("content-type")?.includes("application/json");
    if (!t.ok) {
      let o;
      throw r ? o = await t.json() : o = {
        error: t.statusText || "An error occurred",
        details: `HTTP ${t.status}`
      }, new nf({
        ...o,
        status: t.status
      });
    }
    return r ? await t.json() : {
      data: await t.text(),
      success: !0
    };
  }
  async get(t, n) {
    const r = this.buildUrl(t, n?.params), o = await fetch(r, {
      method: "GET",
      headers: {
        ...this.defaultHeaders,
        ...n?.headers
      },
      signal: n?.signal
    });
    return this.handleResponse(o);
  }
  async post(t, n, r) {
    const o = this.buildUrl(t, r?.params), s = await fetch(o, {
      method: "POST",
      headers: {
        ...this.defaultHeaders,
        ...r?.headers
      },
      body: n ? JSON.stringify(n) : void 0,
      signal: r?.signal
    });
    return this.handleResponse(s);
  }
  async put(t, n, r) {
    const o = this.buildUrl(t, r?.params), s = await fetch(o, {
      method: "PUT",
      headers: {
        ...this.defaultHeaders,
        ...r?.headers
      },
      body: n ? JSON.stringify(n) : void 0,
      signal: r?.signal
    });
    return this.handleResponse(s);
  }
  async patch(t, n, r) {
    const o = this.buildUrl(t, r?.params), s = await fetch(o, {
      method: "PATCH",
      headers: {
        ...this.defaultHeaders,
        ...r?.headers
      },
      body: n ? JSON.stringify(n) : void 0,
      signal: r?.signal
    });
    return this.handleResponse(s);
  }
  async delete(t, n) {
    const r = this.buildUrl(t, n?.params), o = await fetch(r, {
      method: "DELETE",
      headers: {
        ...this.defaultHeaders,
        ...n?.headers
      },
      signal: n?.signal
    });
    return this.handleResponse(o);
  }
}
const of = () => typeof globalThis < "u" && globalThis.__ENV__?.VITE_API_BASE_URL ? globalThis.__ENV__.VITE_API_BASE_URL : "http://localhost:8080/api/v1", Te = new rf(of());
var Or = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, $n = typeof window > "u" || "Deno" in globalThis;
function xr() {
}
function la(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function sf(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function On(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ue(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ua(e) {
  return JSON.stringify(
    e,
    (t, n) => Io(n) ? Object.keys(n).sort().reduce((r, o) => (r[o] = n[o], r), {}) : n
  );
}
function Ao(e, t) {
  if (e === t)
    return e;
  const n = da(e) && da(t);
  if (n || Io(e) && Io(t)) {
    const r = n ? e : Object.keys(e), o = r.length, s = n ? t : Object.keys(t), a = s.length, i = n ? [] : {}, u = new Set(r);
    let l = 0;
    for (let d = 0; d < a; d++) {
      const f = n ? d : s[d];
      (!n && u.has(f) || n) && e[f] === void 0 && t[f] === void 0 ? (i[f] = void 0, l++) : (i[f] = Ao(e[f], t[f]), i[f] === e[f] && e[f] !== void 0 && l++);
    }
    return o === a && l === o ? e : i;
  }
  return t;
}
function _r(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function da(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function Io(e) {
  if (!fa(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(!fa(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function fa(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function pa(e, t, n) {
  if (typeof n.structuralSharing == "function")
    return n.structuralSharing(e, t);
  if (n.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return Ao(e, t);
      } catch (r) {
        throw console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${n.queryHash}]: ${r}`
        ), r;
      }
    return Ao(e, t);
  }
  return t;
}
function pi(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
var Mt, gt, on, ni, af = (ni = class extends Or {
  constructor() {
    super();
    me(this, Mt);
    me(this, gt);
    me(this, on);
    oe(this, on, (t) => {
      if (!$n && window.addEventListener) {
        const n = () => t();
        return window.addEventListener("visibilitychange", n, !1), () => {
          window.removeEventListener("visibilitychange", n);
        };
      }
    });
  }
  onSubscribe() {
    S(this, gt) || this.setEventListener(S(this, on));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = S(this, gt)) == null || t.call(this), oe(this, gt, void 0));
  }
  setEventListener(t) {
    var n;
    oe(this, on, t), (n = S(this, gt)) == null || n.call(this), oe(this, gt, t((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    }));
  }
  setFocused(t) {
    S(this, Mt) !== t && (oe(this, Mt, t), this.onFocus());
  }
  onFocus() {
    const t = this.isFocused();
    this.listeners.forEach((n) => {
      n(t);
    });
  }
  isFocused() {
    return typeof S(this, Mt) == "boolean" ? S(this, Mt) : globalThis.document?.visibilityState !== "hidden";
  }
}, Mt = new WeakMap(), gt = new WeakMap(), on = new WeakMap(), ni), cf = new af(), sn, vt, an, ri, lf = (ri = class extends Or {
  constructor() {
    super();
    me(this, sn, !0);
    me(this, vt);
    me(this, an);
    oe(this, an, (t) => {
      if (!$n && window.addEventListener) {
        const n = () => t(!0), r = () => t(!1);
        return window.addEventListener("online", n, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", n), window.removeEventListener("offline", r);
        };
      }
    });
  }
  onSubscribe() {
    S(this, vt) || this.setEventListener(S(this, an));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = S(this, vt)) == null || t.call(this), oe(this, vt, void 0));
  }
  setEventListener(t) {
    var n;
    oe(this, an, t), (n = S(this, vt)) == null || n.call(this), oe(this, vt, t(this.setOnline.bind(this)));
  }
  setOnline(t) {
    S(this, sn) !== t && (oe(this, sn, t), this.listeners.forEach((r) => {
      r(t);
    }));
  }
  isOnline() {
    return S(this, sn);
  }
}, sn = new WeakMap(), vt = new WeakMap(), an = new WeakMap(), ri), uf = new lf();
function ha() {
  let e, t;
  const n = new Promise((o, s) => {
    e = o, t = s;
  });
  n.status = "pending", n.catch(() => {
  });
  function r(o) {
    Object.assign(n, o), delete n.resolve, delete n.reject;
  }
  return n.resolve = (o) => {
    r({
      status: "fulfilled",
      value: o
    }), e(o);
  }, n.reject = (o) => {
    r({
      status: "rejected",
      reason: o
    }), t(o);
  }, n;
}
function df(e) {
  return (e ?? "online") === "online" ? uf.isOnline() : !0;
}
var ff = (e) => setTimeout(e, 0);
function pf() {
  let e = [], t = 0, n = (i) => {
    i();
  }, r = (i) => {
    i();
  }, o = ff;
  const s = (i) => {
    t ? e.push(i) : o(() => {
      n(i);
    });
  }, a = () => {
    const i = e;
    e = [], i.length && o(() => {
      r(() => {
        i.forEach((u) => {
          n(u);
        });
      });
    });
  };
  return {
    batch: (i) => {
      let u;
      t++;
      try {
        u = i();
      } finally {
        t--, t || a();
      }
      return u;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (i) => (...u) => {
      s(() => {
        i(...u);
      });
    },
    schedule: s,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (i) => {
      n = i;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (i) => {
      r = i;
    },
    setScheduler: (i) => {
      o = i;
    }
  };
}
var Pr = pf();
function hf(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: df(t.networkMode) ? "fetching" : "paused",
    ...e === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function mf() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var Oe, se, zn, Ae, Dt, cn, yt, bt, Wn, ln, un, Lt, Ft, wt, dn, de, Tn, Oo, Po, Mo, Do, Lo, Fo, $o, hi, oi, gf = (oi = class extends Or {
  constructor(t, n) {
    super();
    me(this, de);
    me(this, Oe);
    me(this, se);
    me(this, zn);
    me(this, Ae);
    me(this, Dt);
    me(this, cn);
    me(this, yt);
    me(this, bt);
    me(this, Wn);
    me(this, ln);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    me(this, un);
    me(this, Lt);
    me(this, Ft);
    me(this, wt);
    me(this, dn, /* @__PURE__ */ new Set());
    this.options = n, oe(this, Oe, t), oe(this, bt, null), oe(this, yt, ha()), this.options.experimental_prefetchInRender || S(this, yt).reject(
      new Error("experimental_prefetchInRender feature flag is not enabled")
    ), this.bindMethods(), this.setOptions(n);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (S(this, se).addObserver(this), ma(S(this, se), this.options) ? ye(this, de, Tn).call(this) : this.updateResult(), ye(this, de, Do).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return jo(
      S(this, se),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return jo(
      S(this, se),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), ye(this, de, Lo).call(this), ye(this, de, Fo).call(this), S(this, se).removeObserver(this);
  }
  setOptions(t) {
    const n = this.options, r = S(this, se);
    if (this.options = S(this, Oe).defaultQueryOptions(t), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof Ue(this.options.enabled, S(this, se)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    ye(this, de, $o).call(this), S(this, se).setOptions(this.options), n._defaulted && !_r(this.options, n) && S(this, Oe).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: S(this, se),
      observer: this
    });
    const o = this.hasListeners();
    o && ga(
      S(this, se),
      r,
      this.options,
      n
    ) && ye(this, de, Tn).call(this), this.updateResult(), o && (S(this, se) !== r || Ue(this.options.enabled, S(this, se)) !== Ue(n.enabled, S(this, se)) || On(this.options.staleTime, S(this, se)) !== On(n.staleTime, S(this, se))) && ye(this, de, Oo).call(this);
    const s = ye(this, de, Po).call(this);
    o && (S(this, se) !== r || Ue(this.options.enabled, S(this, se)) !== Ue(n.enabled, S(this, se)) || s !== S(this, wt)) && ye(this, de, Mo).call(this, s);
  }
  getOptimisticResult(t) {
    const n = S(this, Oe).getQueryCache().build(S(this, Oe), t), r = this.createResult(n, t);
    return yf(this, r) && (oe(this, Ae, r), oe(this, cn, this.options), oe(this, Dt, S(this, se).state)), r;
  }
  getCurrentResult() {
    return S(this, Ae);
  }
  trackResult(t, n) {
    return new Proxy(t, {
      get: (r, o) => (this.trackProp(o), n?.(o), Reflect.get(r, o))
    });
  }
  trackProp(t) {
    S(this, dn).add(t);
  }
  getCurrentQuery() {
    return S(this, se);
  }
  refetch({ ...t } = {}) {
    return this.fetch({
      ...t
    });
  }
  fetchOptimistic(t) {
    const n = S(this, Oe).defaultQueryOptions(t), r = S(this, Oe).getQueryCache().build(S(this, Oe), n);
    return r.fetch().then(() => this.createResult(r, n));
  }
  fetch(t) {
    return ye(this, de, Tn).call(this, {
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), S(this, Ae)));
  }
  createResult(t, n) {
    const r = S(this, se), o = this.options, s = S(this, Ae), a = S(this, Dt), i = S(this, cn), l = t !== r ? t.state : S(this, zn), { state: d } = t;
    let f = { ...d }, g = !1, v;
    if (n._optimisticResults) {
      const M = this.hasListeners(), F = !M && ma(t, n), H = M && ga(t, r, n, o);
      (F || H) && (f = {
        ...f,
        ...hf(d.data, t.options)
      }), n._optimisticResults === "isRestoring" && (f.fetchStatus = "idle");
    }
    let { error: y, errorUpdatedAt: h, status: m } = f;
    v = f.data;
    let b = !1;
    if (n.placeholderData !== void 0 && v === void 0 && m === "pending") {
      let M;
      s?.isPlaceholderData && n.placeholderData === i?.placeholderData ? (M = s.data, b = !0) : M = typeof n.placeholderData == "function" ? n.placeholderData(
        S(this, un)?.state.data,
        S(this, un)
      ) : n.placeholderData, M !== void 0 && (m = "success", v = pa(
        s?.data,
        M,
        n
      ), g = !0);
    }
    if (n.select && v !== void 0 && !b)
      if (s && v === a?.data && n.select === S(this, Wn))
        v = S(this, ln);
      else
        try {
          oe(this, Wn, n.select), v = n.select(v), v = pa(s?.data, v, n), oe(this, ln, v), oe(this, bt, null);
        } catch (M) {
          oe(this, bt, M);
        }
    S(this, bt) && (y = S(this, bt), v = S(this, ln), h = Date.now(), m = "error");
    const w = f.fetchStatus === "fetching", x = m === "pending", _ = m === "error", C = x && w, N = v !== void 0, k = {
      status: m,
      fetchStatus: f.fetchStatus,
      isPending: x,
      isSuccess: m === "success",
      isError: _,
      isInitialLoading: C,
      isLoading: C,
      data: v,
      dataUpdatedAt: f.dataUpdatedAt,
      error: y,
      errorUpdatedAt: h,
      failureCount: f.fetchFailureCount,
      failureReason: f.fetchFailureReason,
      errorUpdateCount: f.errorUpdateCount,
      isFetched: f.dataUpdateCount > 0 || f.errorUpdateCount > 0,
      isFetchedAfterMount: f.dataUpdateCount > l.dataUpdateCount || f.errorUpdateCount > l.errorUpdateCount,
      isFetching: w,
      isRefetching: w && !x,
      isLoadingError: _ && !N,
      isPaused: f.fetchStatus === "paused",
      isPlaceholderData: g,
      isRefetchError: _ && N,
      isStale: ls(t, n),
      refetch: this.refetch,
      promise: S(this, yt),
      isEnabled: Ue(n.enabled, t) !== !1
    };
    if (this.options.experimental_prefetchInRender) {
      const M = (L) => {
        k.status === "error" ? L.reject(k.error) : k.data !== void 0 && L.resolve(k.data);
      }, F = () => {
        const L = oe(this, yt, k.promise = ha());
        M(L);
      }, H = S(this, yt);
      switch (H.status) {
        case "pending":
          t.queryHash === r.queryHash && M(H);
          break;
        case "fulfilled":
          (k.status === "error" || k.data !== H.value) && F();
          break;
        case "rejected":
          (k.status !== "error" || k.error !== H.reason) && F();
          break;
      }
    }
    return k;
  }
  updateResult() {
    const t = S(this, Ae), n = this.createResult(S(this, se), this.options);
    if (oe(this, Dt, S(this, se).state), oe(this, cn, this.options), S(this, Dt).data !== void 0 && oe(this, un, S(this, se)), _r(n, t))
      return;
    oe(this, Ae, n);
    const r = () => {
      if (!t)
        return !0;
      const { notifyOnChangeProps: o } = this.options, s = typeof o == "function" ? o() : o;
      if (s === "all" || !s && !S(this, dn).size)
        return !0;
      const a = new Set(
        s ?? S(this, dn)
      );
      return this.options.throwOnError && a.add("error"), Object.keys(S(this, Ae)).some((i) => {
        const u = i;
        return S(this, Ae)[u] !== t[u] && a.has(u);
      });
    };
    ye(this, de, hi).call(this, { listeners: r() });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && ye(this, de, Do).call(this);
  }
}, Oe = new WeakMap(), se = new WeakMap(), zn = new WeakMap(), Ae = new WeakMap(), Dt = new WeakMap(), cn = new WeakMap(), yt = new WeakMap(), bt = new WeakMap(), Wn = new WeakMap(), ln = new WeakMap(), un = new WeakMap(), Lt = new WeakMap(), Ft = new WeakMap(), wt = new WeakMap(), dn = new WeakMap(), de = new WeakSet(), Tn = function(t) {
  ye(this, de, $o).call(this);
  let n = S(this, se).fetch(
    this.options,
    t
  );
  return t?.throwOnError || (n = n.catch(xr)), n;
}, Oo = function() {
  ye(this, de, Lo).call(this);
  const t = On(
    this.options.staleTime,
    S(this, se)
  );
  if ($n || S(this, Ae).isStale || !la(t))
    return;
  const r = sf(S(this, Ae).dataUpdatedAt, t) + 1;
  oe(this, Lt, setTimeout(() => {
    S(this, Ae).isStale || this.updateResult();
  }, r));
}, Po = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(S(this, se)) : this.options.refetchInterval) ?? !1;
}, Mo = function(t) {
  ye(this, de, Fo).call(this), oe(this, wt, t), !($n || Ue(this.options.enabled, S(this, se)) === !1 || !la(S(this, wt)) || S(this, wt) === 0) && oe(this, Ft, setInterval(() => {
    (this.options.refetchIntervalInBackground || cf.isFocused()) && ye(this, de, Tn).call(this);
  }, S(this, wt)));
}, Do = function() {
  ye(this, de, Oo).call(this), ye(this, de, Mo).call(this, ye(this, de, Po).call(this));
}, Lo = function() {
  S(this, Lt) && (clearTimeout(S(this, Lt)), oe(this, Lt, void 0));
}, Fo = function() {
  S(this, Ft) && (clearInterval(S(this, Ft)), oe(this, Ft, void 0));
}, $o = function() {
  const t = S(this, Oe).getQueryCache().build(S(this, Oe), this.options);
  if (t === S(this, se))
    return;
  const n = S(this, se);
  oe(this, se, t), oe(this, zn, t.state), this.hasListeners() && (n?.removeObserver(this), t.addObserver(this));
}, hi = function(t) {
  Pr.batch(() => {
    t.listeners && this.listeners.forEach((n) => {
      n(S(this, Ae));
    }), S(this, Oe).getQueryCache().notify({
      query: S(this, se),
      type: "observerResultsUpdated"
    });
  });
}, oi);
function vf(e, t) {
  return Ue(t.enabled, e) !== !1 && e.state.data === void 0 && !(e.state.status === "error" && t.retryOnMount === !1);
}
function ma(e, t) {
  return vf(e, t) || e.state.data !== void 0 && jo(e, t, t.refetchOnMount);
}
function jo(e, t, n) {
  if (Ue(t.enabled, e) !== !1 && On(t.staleTime, e) !== "static") {
    const r = typeof n == "function" ? n(e) : n;
    return r === "always" || r !== !1 && ls(e, t);
  }
  return !1;
}
function ga(e, t, n, r) {
  return (e !== t || Ue(r.enabled, e) === !1) && (!n.suspense || e.state.status !== "error") && ls(e, n);
}
function ls(e, t) {
  return Ue(t.enabled, e) !== !1 && e.isStaleByTime(On(t.staleTime, e));
}
function yf(e, t) {
  return !_r(e.getCurrentResult(), t);
}
var xt, _t, Pe, nt, ot, lr, Vo, si, bf = (si = class extends Or {
  constructor(n, r) {
    super();
    me(this, ot);
    me(this, xt);
    me(this, _t);
    me(this, Pe);
    me(this, nt);
    oe(this, xt, n), this.setOptions(r), this.bindMethods(), ye(this, ot, lr).call(this);
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(n) {
    const r = this.options;
    this.options = S(this, xt).defaultMutationOptions(n), _r(this.options, r) || S(this, xt).getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: S(this, Pe),
      observer: this
    }), r?.mutationKey && this.options.mutationKey && ua(r.mutationKey) !== ua(this.options.mutationKey) ? this.reset() : S(this, Pe)?.state.status === "pending" && S(this, Pe).setOptions(this.options);
  }
  onUnsubscribe() {
    this.hasListeners() || S(this, Pe)?.removeObserver(this);
  }
  onMutationUpdate(n) {
    ye(this, ot, lr).call(this), ye(this, ot, Vo).call(this, n);
  }
  getCurrentResult() {
    return S(this, _t);
  }
  reset() {
    S(this, Pe)?.removeObserver(this), oe(this, Pe, void 0), ye(this, ot, lr).call(this), ye(this, ot, Vo).call(this);
  }
  mutate(n, r) {
    return oe(this, nt, r), S(this, Pe)?.removeObserver(this), oe(this, Pe, S(this, xt).getMutationCache().build(S(this, xt), this.options)), S(this, Pe).addObserver(this), S(this, Pe).execute(n);
  }
}, xt = new WeakMap(), _t = new WeakMap(), Pe = new WeakMap(), nt = new WeakMap(), ot = new WeakSet(), lr = function() {
  const n = S(this, Pe)?.state ?? mf();
  oe(this, _t, {
    ...n,
    isPending: n.status === "pending",
    isSuccess: n.status === "success",
    isError: n.status === "error",
    isIdle: n.status === "idle",
    mutate: this.mutate,
    reset: this.reset
  });
}, Vo = function(n) {
  Pr.batch(() => {
    if (S(this, nt) && this.hasListeners()) {
      const r = S(this, _t).variables, o = S(this, _t).context;
      n?.type === "success" ? (S(this, nt).onSuccess?.(n.data, r, o), S(this, nt).onSettled?.(n.data, null, r, o)) : n?.type === "error" && (S(this, nt).onError?.(n.error, r, o), S(this, nt).onSettled?.(
        void 0,
        n.error,
        r,
        o
      ));
    }
    this.listeners.forEach((r) => {
      r(S(this, _t));
    });
  });
}, si), wf = c.createContext(
  void 0
), kt = (e) => {
  const t = c.useContext(wf);
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, mi = c.createContext(!1), xf = () => c.useContext(mi);
mi.Provider;
function _f() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
var Sf = c.createContext(_f()), Cf = () => c.useContext(Sf), Ef = (e, t) => {
  (e.suspense || e.throwOnError || e.experimental_prefetchInRender) && (t.isReset() || (e.retryOnMount = !1));
}, Rf = (e) => {
  c.useEffect(() => {
    e.clearReset();
  }, [e]);
}, Tf = ({
  result: e,
  errorResetBoundary: t,
  throwOnError: n,
  query: r,
  suspense: o
}) => e.isError && !t.isReset() && !e.isFetching && r && (o && e.data === void 0 || pi(n, [e.error, r])), Nf = (e) => {
  if (e.suspense) {
    const t = (r) => r === "static" ? r : Math.max(r ?? 1e3, 1e3), n = e.staleTime;
    e.staleTime = typeof n == "function" ? (...r) => t(n(...r)) : t(n), typeof e.gcTime == "number" && (e.gcTime = Math.max(e.gcTime, 1e3));
  }
}, kf = (e, t) => e.isLoading && e.isFetching && !t, Af = (e, t) => e?.suspense && t.isPending, va = (e, t, n) => t.fetchOptimistic(e).catch(() => {
  n.clearReset();
});
function If(e, t, n) {
  if (process.env.NODE_ENV !== "production" && (typeof e != "object" || Array.isArray(e)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const r = xf(), o = Cf(), s = kt(), a = s.defaultQueryOptions(e);
  s.getDefaultOptions().queries?._experimental_beforeQuery?.(
    a
  ), process.env.NODE_ENV !== "production" && (a.queryFn || console.error(
    `[${a.queryHash}]: No queryFn was passed as an option, and no default queryFn was found. The queryFn parameter is only optional when using a default queryFn. More info here: https://tanstack.com/query/latest/docs/framework/react/guides/default-query-function`
  )), a._optimisticResults = r ? "isRestoring" : "optimistic", Nf(a), Ef(a, o), Rf(o);
  const i = !s.getQueryCache().get(a.queryHash), [u] = c.useState(
    () => new t(
      s,
      a
    )
  ), l = u.getOptimisticResult(a), d = !r && e.subscribed !== !1;
  if (c.useSyncExternalStore(
    c.useCallback(
      (f) => {
        const g = d ? u.subscribe(Pr.batchCalls(f)) : xr;
        return u.updateResult(), g;
      },
      [u, d]
    ),
    () => u.getCurrentResult(),
    () => u.getCurrentResult()
  ), c.useEffect(() => {
    u.setOptions(a);
  }, [a, u]), Af(a, l))
    throw va(a, u, o);
  if (Tf({
    result: l,
    errorResetBoundary: o,
    throwOnError: a.throwOnError,
    query: s.getQueryCache().get(a.queryHash),
    suspense: a.suspense
  }))
    throw l.error;
  return s.getDefaultOptions().queries?._experimental_afterQuery?.(
    a,
    l
  ), a.experimental_prefetchInRender && !$n && kf(l, r) && (i ? (
    // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
    va(a, u, o)
  ) : (
    // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
    s.getQueryCache().get(a.queryHash)?.promise
  ))?.catch(xr).finally(() => {
    u.updateResult();
  }), a.notifyOnChangeProps ? l : u.trackResult(l);
}
function Je(e, t) {
  return If(e, gf);
}
function Kn(e, t) {
  const n = kt(), [r] = c.useState(
    () => new bf(
      n,
      e
    )
  );
  c.useEffect(() => {
    r.setOptions(e);
  }, [r, e]);
  const o = c.useSyncExternalStore(
    c.useCallback(
      (a) => r.subscribe(Pr.batchCalls(a)),
      [r]
    ),
    () => r.getCurrentResult(),
    () => r.getCurrentResult()
  ), s = c.useCallback(
    (a, i) => {
      r.mutate(a, i).catch(xr);
    },
    [r]
  );
  if (o.error && pi(r.options.throwOnError, [o.error]))
    throw o.error;
  return { ...o, mutate: s, mutateAsync: o.mutate };
}
const pe = {
  // Auth
  auth: ["auth"],
  me: () => [...pe.auth, "me"],
  // Tickets
  tickets: ["tickets"],
  ticketsList: (e) => [...pe.tickets, "list", e],
  ticketDetail: (e) => [...pe.tickets, "detail", e],
  ticketMessages: (e, t) => [...pe.tickets, e, "messages", t],
  // Users & Agents
  users: ["users"],
  agents: ["agents"],
  agentsList: (e) => [...pe.agents, "list", e],
  // Customers
  customers: ["customers"],
  customersList: (e) => [...pe.customers, "list", e],
  customerDetail: (e) => [...pe.customers, "detail", e],
  // Integrations
  integrations: ["integrations"],
  integrationsList: (e) => [...pe.integrations, "list", e],
  integrationDetail: (e) => [...pe.integrations, "detail", e],
  // Notifications
  notifications: ["notifications"],
  notificationsList: (e) => [...pe.notifications, "list", e],
  unreadCount: () => [...pe.notifications, "unread-count"]
};
function ix(e) {
  const t = kt();
  return Kn({
    mutationFn: async (n) => (await Te.post("/auth/login", n)).data,
    onSuccess: (n) => {
      Te.setAuthToken(n.access_token), t.setQueryData(pe.me(), n.user), t.invalidateQueries({ queryKey: pe.auth });
    },
    ...e
  });
}
function cx(e) {
  const t = kt();
  return Kn({
    mutationFn: async () => {
      await Te.post("/auth/logout");
    },
    onSuccess: () => {
      t.clear();
    },
    ...e
  });
}
function lx(e) {
  return Je({
    queryKey: pe.me(),
    queryFn: async () => (await Te.get("/auth/me")).data,
    staleTime: 5 * 60 * 1e3,
    // 5 minutes
    ...e
  });
}
function ux(e, t) {
  return Je({
    queryKey: pe.ticketsList(e),
    queryFn: async () => (await Te.get("/tickets", {
      params: e
    })).data,
    staleTime: 30 * 1e3,
    // 30 seconds
    ...t
  });
}
function dx(e, t) {
  return Je({
    queryKey: pe.ticketDetail(e),
    queryFn: async () => (await Te.get(`/tickets/${e}`)).data,
    enabled: !!e,
    staleTime: 60 * 1e3,
    // 1 minute
    ...t
  });
}
function fx(e) {
  const t = kt();
  return Kn({
    mutationFn: async (n) => (await Te.post("/tickets", n)).data,
    onSuccess: () => {
      t.invalidateQueries({ queryKey: pe.tickets });
    },
    ...e
  });
}
function px(e) {
  const t = kt();
  return Kn({
    mutationFn: async ({ id: n, data: r }) => (await Te.patch(`/tickets/${n}`, r)).data,
    onSuccess: (n) => {
      t.setQueryData(pe.ticketDetail(n.id), n), t.invalidateQueries({ queryKey: pe.tickets });
    },
    ...e
  });
}
function hx(e, t) {
  return Je({
    queryKey: pe.agentsList(e),
    queryFn: async () => (await Te.get("/agents", {
      params: e
    })).data,
    staleTime: 5 * 60 * 1e3,
    // 5 minutes
    ...t
  });
}
function mx(e, t) {
  return Je({
    queryKey: pe.customersList(e),
    queryFn: async () => (await Te.get("/customers", {
      params: e
    })).data,
    staleTime: 2 * 60 * 1e3,
    // 2 minutes
    ...t
  });
}
function gx(e, t) {
  return Je({
    queryKey: pe.customerDetail(e),
    queryFn: async () => (await Te.get(`/customers/${e}`)).data,
    enabled: !!e,
    staleTime: 5 * 60 * 1e3,
    // 5 minutes
    ...t
  });
}
function vx(e, t) {
  return Je({
    queryKey: pe.integrationsList(e),
    queryFn: async () => (await Te.get("/integrations", {
      params: e
    })).data,
    staleTime: 5 * 60 * 1e3,
    // 5 minutes
    ...t
  });
}
function yx(e, t) {
  return Je({
    queryKey: pe.integrationDetail(e),
    queryFn: async () => (await Te.get(`/integrations/${e}`)).data,
    enabled: !!e,
    staleTime: 5 * 60 * 1e3,
    // 5 minutes
    ...t
  });
}
function bx(e, t) {
  return Je({
    queryKey: pe.notificationsList(e),
    queryFn: async () => (await Te.get("/notifications", {
      params: e
    })).data,
    staleTime: 30 * 1e3,
    // 30 seconds
    ...t
  });
}
function wx(e) {
  return Je({
    queryKey: pe.unreadCount(),
    queryFn: async () => (await Te.get("/notifications/unread-count")).data.count,
    staleTime: 30 * 1e3,
    // 30 seconds
    refetchInterval: 60 * 1e3,
    // Refetch every minute
    ...e
  });
}
function xx(e) {
  const t = kt();
  return Kn({
    mutationFn: async (n) => {
      await Te.patch(`/notifications/${n}/read`);
    },
    onSuccess: () => {
      t.invalidateQueries({ queryKey: pe.notifications }), t.invalidateQueries({ queryKey: pe.unreadCount() });
    },
    ...e
  });
}
function _x() {
  const e = kt();
  return (t) => {
    e.prefetchQuery({
      queryKey: pe.ticketDetail(t),
      queryFn: async () => (await Te.get(`/tickets/${t}`)).data,
      staleTime: 60 * 1e3
    });
  };
}
function gi(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = gi(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function us() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = gi(e)) && (r && (r += " "), r += t);
  return r;
}
const ds = "-", Of = (e) => {
  const t = Mf(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      const i = a.split(ds);
      return i[0] === "" && i.length !== 1 && i.shift(), vi(i, t) || Pf(a);
    },
    getConflictingClassGroupIds: (a, i) => {
      const u = n[a] || [];
      return i && r[a] ? [...u, ...r[a]] : u;
    }
  };
}, vi = (e, t) => {
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? vi(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const s = e.join(ds);
  return t.validators.find(({
    validator: a
  }) => a(s))?.classGroupId;
}, ya = /^\[(.+)\]$/, Pf = (e) => {
  if (ya.test(e)) {
    const t = ya.exec(e)[1], n = t?.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, Mf = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Lf(Object.entries(e.classGroups), n).forEach(([s, a]) => {
    Bo(a, r, s, t);
  }), r;
}, Bo = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const s = o === "" ? t : ba(t, o);
      s.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (Df(o)) {
        Bo(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([s, a]) => {
      Bo(a, ba(t, s), n, r);
    });
  });
}, ba = (e, t) => {
  let n = e;
  return t.split(ds).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, Df = (e) => e.isThemeGetter, Lf = (e, t) => t ? e.map(([n, r]) => {
  const o = r.map((s) => typeof s == "string" ? t + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(([a, i]) => [t + a, i])) : s);
  return [n, o];
}) : e, Ff = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (s, a) => {
    n.set(s, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(s) {
      let a = n.get(s);
      if (a !== void 0)
        return a;
      if ((a = r.get(s)) !== void 0)
        return o(s, a), a;
    },
    set(s, a) {
      n.has(s) ? n.set(s, a) : o(s, a);
    }
  };
}, yi = "!", $f = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, o = t[0], s = t.length, a = (i) => {
    const u = [];
    let l = 0, d = 0, f;
    for (let m = 0; m < i.length; m++) {
      let b = i[m];
      if (l === 0) {
        if (b === o && (r || i.slice(m, m + s) === t)) {
          u.push(i.slice(d, m)), d = m + s;
          continue;
        }
        if (b === "/") {
          f = m;
          continue;
        }
      }
      b === "[" ? l++ : b === "]" && l--;
    }
    const g = u.length === 0 ? i : i.substring(d), v = g.startsWith(yi), y = v ? g.substring(1) : g, h = f && f > d ? f - d : void 0;
    return {
      modifiers: u,
      hasImportantModifier: v,
      baseClassName: y,
      maybePostfixModifierPosition: h
    };
  };
  return n ? (i) => n({
    className: i,
    parseClassName: a
  }) : a;
}, jf = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, Vf = (e) => ({
  cache: Ff(e.cacheSize),
  parseClassName: $f(e),
  ...Of(e)
}), Bf = /\s+/, Uf = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, s = [], a = e.trim().split(Bf);
  let i = "";
  for (let u = a.length - 1; u >= 0; u -= 1) {
    const l = a[u], {
      modifiers: d,
      hasImportantModifier: f,
      baseClassName: g,
      maybePostfixModifierPosition: v
    } = n(l);
    let y = !!v, h = r(y ? g.substring(0, v) : g);
    if (!h) {
      if (!y) {
        i = l + (i.length > 0 ? " " + i : i);
        continue;
      }
      if (h = r(g), !h) {
        i = l + (i.length > 0 ? " " + i : i);
        continue;
      }
      y = !1;
    }
    const m = jf(d).join(":"), b = f ? m + yi : m, w = b + h;
    if (s.includes(w))
      continue;
    s.push(w);
    const x = o(h, y);
    for (let _ = 0; _ < x.length; ++_) {
      const C = x[_];
      s.push(b + C);
    }
    i = l + (i.length > 0 ? " " + i : i);
  }
  return i;
};
function zf() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = bi(t)) && (r && (r += " "), r += n);
  return r;
}
const bi = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = bi(e[r])) && (n && (n += " "), n += t);
  return n;
};
function Wf(e, ...t) {
  let n, r, o, s = a;
  function a(u) {
    const l = t.reduce((d, f) => f(d), e());
    return n = Vf(l), r = n.cache.get, o = n.cache.set, s = i, i(u);
  }
  function i(u) {
    const l = r(u);
    if (l)
      return l;
    const d = Uf(u, n);
    return o(u, d), d;
  }
  return function() {
    return s(zf.apply(null, arguments));
  };
}
const be = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, wi = /^\[(?:([a-z-]+):)?(.+)\]$/i, Hf = /^\d+\/\d+$/, Kf = /* @__PURE__ */ new Set(["px", "full", "screen"]), Zf = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Gf = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, qf = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Yf = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Qf = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, tt = (e) => tn(e) || Kf.has(e) || Hf.test(e), ft = (e) => bn(e, "length", sp), tn = (e) => !!e && !Number.isNaN(Number(e)), ro = (e) => bn(e, "number", tn), Sn = (e) => !!e && Number.isInteger(Number(e)), Xf = (e) => e.endsWith("%") && tn(e.slice(0, -1)), te = (e) => wi.test(e), pt = (e) => Zf.test(e), Jf = /* @__PURE__ */ new Set(["length", "size", "percentage"]), ep = (e) => bn(e, Jf, xi), tp = (e) => bn(e, "position", xi), np = /* @__PURE__ */ new Set(["image", "url"]), rp = (e) => bn(e, np, ip), op = (e) => bn(e, "", ap), Cn = () => !0, bn = (e, t, n) => {
  const r = wi.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, sp = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Gf.test(e) && !qf.test(e)
), xi = () => !1, ap = (e) => Yf.test(e), ip = (e) => Qf.test(e), cp = () => {
  const e = be("colors"), t = be("spacing"), n = be("blur"), r = be("brightness"), o = be("borderColor"), s = be("borderRadius"), a = be("borderSpacing"), i = be("borderWidth"), u = be("contrast"), l = be("grayscale"), d = be("hueRotate"), f = be("invert"), g = be("gap"), v = be("gradientColorStops"), y = be("gradientColorStopPositions"), h = be("inset"), m = be("margin"), b = be("opacity"), w = be("padding"), x = be("saturate"), _ = be("scale"), C = be("sepia"), N = be("skew"), E = be("space"), k = be("translate"), M = () => ["auto", "contain", "none"], F = () => ["auto", "hidden", "clip", "visible", "scroll"], H = () => ["auto", te, t], L = () => [te, t], J = () => ["", tt, ft], O = () => ["auto", tn, te], q = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], B = () => ["solid", "dashed", "dotted", "double", "none"], Q = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], j = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], P = () => ["", "0", te], fe = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], le = () => [tn, te];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Cn],
      spacing: [tt, ft],
      blur: ["none", "", pt, te],
      brightness: le(),
      borderColor: [e],
      borderRadius: ["none", "", "full", pt, te],
      borderSpacing: L(),
      borderWidth: J(),
      contrast: le(),
      grayscale: P(),
      hueRotate: le(),
      invert: P(),
      gap: L(),
      gradientColorStops: [e],
      gradientColorStopPositions: [Xf, ft],
      inset: H(),
      margin: H(),
      opacity: le(),
      padding: L(),
      saturate: le(),
      scale: le(),
      sepia: P(),
      skew: le(),
      space: L(),
      translate: L()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", te]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [pt]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": fe()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": fe()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...q(), te]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: F()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": F()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": F()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: M()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": M()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": M()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [h]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [h]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [h]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [h]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [h]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [h]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [h]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [h]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [h]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Sn, te]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: H()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", te]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: P()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: P()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Sn, te]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Cn]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Sn, te]
        }, te]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": O()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": O()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Cn]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Sn, te]
        }, te]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": O()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": O()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", te]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", te]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [g]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [g]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [g]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...j()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...j(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...j(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [w]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [w]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [w]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [w]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [w]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [w]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [w]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [w]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [w]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [E]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [E]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", te, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [te, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [te, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [pt]
        }, pt]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [te, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [te, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [te, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [te, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", pt, ft]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", ro]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Cn]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", te]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", tn, ro]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", tt, te]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", te]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", te]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...B(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", tt, ft]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", tt, te]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: L()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", te]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", te]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...q(), tp]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", ep]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, rp]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [y]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [y]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [y]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [v]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [s]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [s]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [s]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [s]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [s]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [s]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [s]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [s]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [s]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [s]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [s]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [s]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [s]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [s]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [s]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [i]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [i]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [i]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [i]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [i]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [i]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [i]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [i]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [i]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...B(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [i]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [i]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: B()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...B()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [tt, te]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [tt, ft]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: J()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [tt, ft]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", pt, op]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Cn]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Q(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Q()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [u]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", pt, te]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [l]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [C]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [u]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [l]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [C]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", te]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: le()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", te]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: le()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", te]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [_]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [_]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [_]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Sn, te]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [k]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [k]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [N]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [N]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", te]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", te]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": L()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": L()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": L()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": L()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": L()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": L()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": L()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": L()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": L()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": L()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": L()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": L()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": L()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": L()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": L()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": L()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": L()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": L()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", te]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [tt, ft, ro]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, _i = /* @__PURE__ */ Wf(cp);
function U(...e) {
  return _i(us(e));
}
function lp(e, t = {
  year: "numeric",
  month: "short",
  day: "numeric"
}) {
  return new Intl.DateTimeFormat("en-US", t).format(new Date(e));
}
function Sx(e) {
  const t = /* @__PURE__ */ new Date(), n = new Date(e), r = Math.floor((t.getTime() - n.getTime()) / 1e3);
  if (r < 60)
    return "just now";
  if (r < 3600) {
    const o = Math.floor(r / 60);
    return `${o} minute${o === 1 ? "" : "s"} ago`;
  }
  if (r < 86400) {
    const o = Math.floor(r / 3600);
    return `${o} hour${o === 1 ? "" : "s"} ago`;
  }
  if (r < 604800) {
    const o = Math.floor(r / 86400);
    return `${o} day${o === 1 ? "" : "s"} ago`;
  }
  return lp(e);
}
function Cx(e, t) {
  return e.length <= t ? e : e.slice(0, t) + "...";
}
function Ex(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Rx(e) {
  return e.replace(
    /\w\S*/g,
    (t) => t.charAt(0).toUpperCase() + t.substr(1).toLowerCase()
  );
}
function Tx(e) {
  return e.split(" ").map((t) => t.charAt(0)).join("").toUpperCase().slice(0, 2);
}
function Nx(e) {
  if (e === 0) return "0 B";
  const t = 1024, n = ["B", "KB", "MB", "GB", "TB"], r = Math.floor(Math.log(e) / Math.log(t));
  return `${parseFloat((e / Math.pow(t, r)).toFixed(1))} ${n[r]}`;
}
function kx(e, t) {
  let n = null;
  return (...r) => {
    n && clearTimeout(n), n = setTimeout(() => e(...r), t);
  };
}
function Ax(e) {
  return new Promise((t) => setTimeout(t, e));
}
function Ix() {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
}
function Ox(e) {
  return e == null ? !0 : typeof e == "string" ? e.trim() === "" : Array.isArray(e) ? e.length === 0 : typeof e == "object" ? Object.keys(e).length === 0 : !1;
}
function up(e, t) {
  const n = { ...e };
  for (const r in t)
    if (Object.prototype.hasOwnProperty.call(t, r)) {
      const o = t[r], s = n[r];
      o && typeof o == "object" && !Array.isArray(o) && s && typeof s == "object" && !Array.isArray(s) ? n[r] = up(s, o) : o !== void 0 && (n[r] = o);
    }
  return n;
}
function Px(e, t = "asc") {
  return (n, r) => {
    const o = n[e], s = r[e];
    return o < s ? t === "asc" ? -1 : 1 : o > s ? t === "asc" ? 1 : -1 : 0;
  };
}
async function Mx(e) {
  try {
    if (navigator.clipboard && window.isSecureContext)
      return await navigator.clipboard.writeText(e), !0;
    {
      const t = document.createElement("textarea");
      t.value = e, t.style.position = "absolute", t.style.left = "-999999px", document.body.prepend(t), t.select();
      try {
        return document.execCommand("copy"), !0;
      } catch (n) {
        return console.error("Failed to copy text: ", n), !1;
      } finally {
        t.remove();
      }
    }
  } catch (t) {
    return console.error("Failed to copy text: ", t), !1;
  }
}
function dp(e, t) {
  const n = c.createContext(t), r = (s) => {
    const { children: a, ...i } = s, u = c.useMemo(() => i, Object.values(i));
    return /* @__PURE__ */ p(n.Provider, { value: u, children: a });
  };
  r.displayName = e + "Provider";
  function o(s) {
    const a = c.useContext(n);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${s}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function lt(e, t = []) {
  let n = [];
  function r(s, a) {
    const i = c.createContext(a), u = n.length;
    n = [...n, a];
    const l = (f) => {
      const { scope: g, children: v, ...y } = f, h = g?.[e]?.[u] || i, m = c.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ p(h.Provider, { value: m, children: v });
    };
    l.displayName = s + "Provider";
    function d(f, g) {
      const v = g?.[e]?.[u] || i, y = c.useContext(v);
      if (y) return y;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${s}\``);
    }
    return [l, d];
  }
  const o = () => {
    const s = n.map((a) => c.createContext(a));
    return function(i) {
      const u = i?.[e] || s;
      return c.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: u } }),
        [i, u]
      );
    };
  };
  return o.scopeName = e, [r, fp(o, ...t)];
}
function fp(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(s) {
      const a = r.reduce((i, { useScope: u, scopeName: l }) => {
        const f = u(s)[`__scope${l}`];
        return { ...i, ...f };
      }, {});
      return c.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Ne(e) {
  const t = c.useRef(e);
  return c.useEffect(() => {
    t.current = e;
  }), c.useMemo(() => (...n) => t.current?.(...n), []);
}
var Ee = globalThis?.document ? c.useLayoutEffect : () => {
};
function wa(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function at(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const s = wa(o, t);
      return !n && typeof s == "function" && (n = !0), s;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const s = r[o];
          typeof s == "function" ? s() : wa(e[o], null);
        }
      };
  };
}
function he(...e) {
  return c.useCallback(at(...e), e);
}
// @__NO_SIDE_EFFECTS__
function Vt(e) {
  const t = /* @__PURE__ */ hp(e), n = c.forwardRef((r, o) => {
    const { children: s, ...a } = r, i = c.Children.toArray(s), u = i.find(gp);
    if (u) {
      const l = u.props.children, d = i.map((f) => f === u ? c.Children.count(l) > 1 ? c.Children.only(null) : c.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ p(t, { ...a, ref: o, children: c.isValidElement(l) ? c.cloneElement(l, void 0, d) : null });
    }
    return /* @__PURE__ */ p(t, { ...a, ref: o, children: s });
  });
  return n.displayName = `${e}.Slot`, n;
}
var pp = /* @__PURE__ */ Vt("Slot");
// @__NO_SIDE_EFFECTS__
function hp(e) {
  const t = c.forwardRef((n, r) => {
    const { children: o, ...s } = n;
    if (c.isValidElement(o)) {
      const a = yp(o), i = vp(s, o.props);
      return o.type !== c.Fragment && (i.ref = r ? at(r, a) : a), c.cloneElement(o, i);
    }
    return c.Children.count(o) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var mp = Symbol("radix.slottable");
function gp(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === mp;
}
function vp(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...i) => {
      const u = s(...i);
      return o(...i), u;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function yp(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var bp = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Z = bp.reduce((e, t) => {
  const n = /* @__PURE__ */ Vt(`Primitive.${t}`), r = c.forwardRef((o, s) => {
    const { asChild: a, ...i } = o, u = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(u, { ...i, ref: s });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function fs(e, t) {
  e && Hn.flushSync(() => e.dispatchEvent(t));
}
var Uo = { exports: {} }, oo = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xa;
function wp() {
  if (xa) return oo;
  xa = 1;
  var e = ge;
  function t(f, g) {
    return f === g && (f !== 0 || 1 / f === 1 / g) || f !== f && g !== g;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, s = e.useLayoutEffect, a = e.useDebugValue;
  function i(f, g) {
    var v = g(), y = r({ inst: { value: v, getSnapshot: g } }), h = y[0].inst, m = y[1];
    return s(
      function() {
        h.value = v, h.getSnapshot = g, u(h) && m({ inst: h });
      },
      [f, v, g]
    ), o(
      function() {
        return u(h) && m({ inst: h }), f(function() {
          u(h) && m({ inst: h });
        });
      },
      [f]
    ), a(v), v;
  }
  function u(f) {
    var g = f.getSnapshot;
    f = f.value;
    try {
      var v = g();
      return !n(f, v);
    } catch {
      return !0;
    }
  }
  function l(f, g) {
    return g();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? l : i;
  return oo.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : d, oo;
}
var so = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _a;
function xp() {
  return _a || (_a = 1, process.env.NODE_ENV !== "production" && function() {
    function e(v, y) {
      return v === y && (v !== 0 || 1 / v === 1 / y) || v !== v && y !== y;
    }
    function t(v, y) {
      d || o.startTransition === void 0 || (d = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var h = y();
      if (!f) {
        var m = y();
        s(h, m) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), f = !0);
      }
      m = a({
        inst: { value: h, getSnapshot: y }
      });
      var b = m[0].inst, w = m[1];
      return u(
        function() {
          b.value = h, b.getSnapshot = y, n(b) && w({ inst: b });
        },
        [v, h, y]
      ), i(
        function() {
          return n(b) && w({ inst: b }), v(function() {
            n(b) && w({ inst: b });
          });
        },
        [v]
      ), l(h), h;
    }
    function n(v) {
      var y = v.getSnapshot;
      v = v.value;
      try {
        var h = y();
        return !s(v, h);
      } catch {
        return !0;
      }
    }
    function r(v, y) {
      return y();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = ge, s = typeof Object.is == "function" ? Object.is : e, a = o.useState, i = o.useEffect, u = o.useLayoutEffect, l = o.useDebugValue, d = !1, f = !1, g = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    so.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : g, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), so;
}
process.env.NODE_ENV === "production" ? Uo.exports = wp() : Uo.exports = xp();
var _p = Uo.exports;
function Sp() {
  return _p.useSyncExternalStore(
    Cp,
    () => !0,
    () => !1
  );
}
function Cp() {
  return () => {
  };
}
var ps = "Avatar", [Ep, Dx] = lt(ps), [Rp, Si] = Ep(ps), Ci = c.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, ...r } = e, [o, s] = c.useState("idle");
    return /* @__PURE__ */ p(
      Rp,
      {
        scope: n,
        imageLoadingStatus: o,
        onImageLoadingStatusChange: s,
        children: /* @__PURE__ */ p(Z.span, { ...r, ref: t })
      }
    );
  }
);
Ci.displayName = ps;
var Ei = "AvatarImage", Ri = c.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, src: r, onLoadingStatusChange: o = () => {
    }, ...s } = e, a = Si(Ei, n), i = Tp(r, s), u = Ne((l) => {
      o(l), a.onImageLoadingStatusChange(l);
    });
    return Ee(() => {
      i !== "idle" && u(i);
    }, [i, u]), i === "loaded" ? /* @__PURE__ */ p(Z.img, { ...s, ref: t, src: r }) : null;
  }
);
Ri.displayName = Ei;
var Ti = "AvatarFallback", Ni = c.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, delayMs: r, ...o } = e, s = Si(Ti, n), [a, i] = c.useState(r === void 0);
    return c.useEffect(() => {
      if (r !== void 0) {
        const u = window.setTimeout(() => i(!0), r);
        return () => window.clearTimeout(u);
      }
    }, [r]), a && s.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ p(Z.span, { ...o, ref: t }) : null;
  }
);
Ni.displayName = Ti;
function Sa(e, t) {
  return e ? t ? (e.src !== t && (e.src = t), e.complete && e.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function Tp(e, { referrerPolicy: t, crossOrigin: n }) {
  const r = Sp(), o = c.useRef(null), s = r ? (o.current || (o.current = new window.Image()), o.current) : null, [a, i] = c.useState(
    () => Sa(s, e)
  );
  return Ee(() => {
    i(Sa(s, e));
  }, [s, e]), Ee(() => {
    const u = (f) => () => {
      i(f);
    };
    if (!s) return;
    const l = u("loaded"), d = u("error");
    return s.addEventListener("load", l), s.addEventListener("error", d), t && (s.referrerPolicy = t), typeof n == "string" && (s.crossOrigin = n), () => {
      s.removeEventListener("load", l), s.removeEventListener("error", d);
    };
  }, [s, n, t]), a;
}
var ki = Ci, Ai = Ri, Ii = Ni;
const Np = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  ki,
  {
    ref: n,
    className: U(
      "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
      e
    ),
    ...t
  }
));
Np.displayName = ki.displayName;
const kp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Ai,
  {
    ref: n,
    className: U("aspect-square h-full w-full", e),
    ...t
  }
));
kp.displayName = Ai.displayName;
const Ap = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Ii,
  {
    ref: n,
    className: U(
      "flex h-full w-full items-center justify-center rounded-full bg-muted",
      e
    ),
    ...t
  }
));
Ap.displayName = Ii.displayName;
const Ca = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Ea = us, Mr = (e, t) => (n) => {
  var r;
  if (t?.variants == null) return Ea(e, n?.class, n?.className);
  const { variants: o, defaultVariants: s } = t, a = Object.keys(o).map((l) => {
    const d = n?.[l], f = s?.[l];
    if (d === null) return null;
    const g = Ca(d) || Ca(f);
    return o[l][g];
  }), i = n && Object.entries(n).reduce((l, d) => {
    let [f, g] = d;
    return g === void 0 || (l[f] = g), l;
  }, {}), u = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((l, d) => {
    let { class: f, className: g, ...v } = d;
    return Object.entries(v).every((y) => {
      let [h, m] = y;
      return Array.isArray(m) ? m.includes({
        ...s,
        ...i
      }[h]) : {
        ...s,
        ...i
      }[h] === m;
    }) ? [
      ...l,
      f,
      g
    ] : l;
  }, []);
  return Ea(e, a, u, n?.class, n?.className);
}, Ip = Mr(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        success: "border-transparent bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100",
        warning: "border-transparent bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-100"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function Op({ className: e, variant: t, ...n }) {
  return /* @__PURE__ */ p("div", { className: U(Ip({ variant: t }), e), ...n });
}
const Pp = Mr(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Mp = c.forwardRef(
  ({ className: e, variant: t, size: n, asChild: r = !1, loading: o = !1, disabled: s, children: a, ...i }, u) => /* @__PURE__ */ ve(
    r ? pp : "button",
    {
      className: U(Pp({ variant: t, size: n, className: e })),
      ref: u,
      disabled: s || o,
      "aria-disabled": s || o,
      ...i,
      children: [
        o && /* @__PURE__ */ ve(
          "svg",
          {
            className: "mr-2 h-4 w-4 animate-spin",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-hidden": "true",
            children: [
              /* @__PURE__ */ p(
                "circle",
                {
                  className: "opacity-25",
                  cx: "12",
                  cy: "12",
                  r: "10",
                  stroke: "currentColor",
                  strokeWidth: "4"
                }
              ),
              /* @__PURE__ */ p(
                "path",
                {
                  className: "opacity-75",
                  fill: "currentColor",
                  d: "m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                }
              )
            ]
          }
        ),
        a
      ]
    }
  )
);
Mp.displayName = "Button";
const Dp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "div",
  {
    ref: n,
    className: U(
      "rounded-lg border bg-card text-card-foreground shadow-sm",
      e
    ),
    ...t
  }
));
Dp.displayName = "Card";
const Lp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "div",
  {
    ref: n,
    className: U("flex flex-col space-y-1.5 p-6", e),
    ...t
  }
));
Lp.displayName = "CardHeader";
const Fp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "h3",
  {
    ref: n,
    className: U(
      "text-2xl font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
Fp.displayName = "CardTitle";
const $p = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "p",
  {
    ref: n,
    className: U("text-sm text-muted-foreground", e),
    ...t
  }
));
$p.displayName = "CardDescription";
const jp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p("div", { ref: n, className: U("p-6 pt-0", e), ...t }));
jp.displayName = "CardContent";
const Vp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "div",
  {
    ref: n,
    className: U("flex items-center p-6 pt-0", e),
    ...t
  }
));
Vp.displayName = "CardFooter";
var Ra = 1, Bp = 0.9, Up = 0.8, zp = 0.17, ao = 0.1, io = 0.999, Wp = 0.9999, Hp = 0.99, Kp = /[\\\/_+.#"@\[\(\{&]/, Zp = /[\\\/_+.#"@\[\(\{&]/g, Gp = /[\s-]/, Oi = /[\s-]/g;
function zo(e, t, n, r, o, s, a) {
  if (s === t.length) return o === e.length ? Ra : Hp;
  var i = `${o},${s}`;
  if (a[i] !== void 0) return a[i];
  for (var u = r.charAt(s), l = n.indexOf(u, o), d = 0, f, g, v, y; l >= 0; ) f = zo(e, t, n, r, l + 1, s + 1, a), f > d && (l === o ? f *= Ra : Kp.test(e.charAt(l - 1)) ? (f *= Up, v = e.slice(o, l - 1).match(Zp), v && o > 0 && (f *= Math.pow(io, v.length))) : Gp.test(e.charAt(l - 1)) ? (f *= Bp, y = e.slice(o, l - 1).match(Oi), y && o > 0 && (f *= Math.pow(io, y.length))) : (f *= zp, o > 0 && (f *= Math.pow(io, l - o))), e.charAt(l) !== t.charAt(s) && (f *= Wp)), (f < ao && n.charAt(l - 1) === r.charAt(s + 1) || r.charAt(s + 1) === r.charAt(s) && n.charAt(l - 1) !== r.charAt(s)) && (g = zo(e, t, n, r, l + 1, s + 2, a), g * ao > f && (f = g * ao)), f > d && (d = f), l = n.indexOf(u, l + 1);
  return a[i] = d, d;
}
function Ta(e) {
  return e.toLowerCase().replace(Oi, " ");
}
function qp(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, zo(e, t, Ta(e), Ta(t), 0, 0, {});
}
function $(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var Yp = c[" useId ".trim().toString()] || (() => {
}), Qp = 0;
function Re(e) {
  const [t, n] = c.useState(Yp());
  return Ee(() => {
    n((r) => r ?? String(Qp++));
  }, [e]), t ? `radix-${t}` : "";
}
var Xp = c[" useInsertionEffect ".trim().toString()] || Ee;
function Bt({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, s, a] = Jp({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, u = i ? e : o;
  {
    const d = c.useRef(e !== void 0);
    c.useEffect(() => {
      const f = d.current;
      f !== i && console.warn(
        `${r} is changing from ${f ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), d.current = i;
    }, [i, r]);
  }
  const l = c.useCallback(
    (d) => {
      if (i) {
        const f = eh(d) ? d(e) : d;
        f !== e && a.current?.(f);
      } else
        s(d);
    },
    [i, e, s, a]
  );
  return [u, l];
}
function Jp({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = c.useState(e), o = c.useRef(n), s = c.useRef(t);
  return Xp(() => {
    s.current = t;
  }, [t]), c.useEffect(() => {
    o.current !== n && (s.current?.(n), o.current = n);
  }, [n, o]), [n, r, s];
}
function eh(e) {
  return typeof e == "function";
}
function th(e, t = globalThis?.document) {
  const n = Ne(e);
  c.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var nh = "DismissableLayer", Wo = "dismissableLayer.update", rh = "dismissableLayer.pointerDownOutside", oh = "dismissableLayer.focusOutside", Na, Pi = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Zn = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: s,
      onInteractOutside: a,
      onDismiss: i,
      ...u
    } = e, l = c.useContext(Pi), [d, f] = c.useState(null), g = d?.ownerDocument ?? globalThis?.document, [, v] = c.useState({}), y = he(t, (E) => f(E)), h = Array.from(l.layers), [m] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), b = h.indexOf(m), w = d ? h.indexOf(d) : -1, x = l.layersWithOutsidePointerEventsDisabled.size > 0, _ = w >= b, C = ah((E) => {
      const k = E.target, M = [...l.branches].some((F) => F.contains(k));
      !_ || M || (o?.(E), a?.(E), E.defaultPrevented || i?.());
    }, g), N = ih((E) => {
      const k = E.target;
      [...l.branches].some((F) => F.contains(k)) || (s?.(E), a?.(E), E.defaultPrevented || i?.());
    }, g);
    return th((E) => {
      w === l.layers.size - 1 && (r?.(E), !E.defaultPrevented && i && (E.preventDefault(), i()));
    }, g), c.useEffect(() => {
      if (d)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Na = g.body.style.pointerEvents, g.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(d)), l.layers.add(d), ka(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (g.body.style.pointerEvents = Na);
        };
    }, [d, g, n, l]), c.useEffect(() => () => {
      d && (l.layers.delete(d), l.layersWithOutsidePointerEventsDisabled.delete(d), ka());
    }, [d, l]), c.useEffect(() => {
      const E = () => v({});
      return document.addEventListener(Wo, E), () => document.removeEventListener(Wo, E);
    }, []), /* @__PURE__ */ p(
      Z.div,
      {
        ...u,
        ref: y,
        style: {
          pointerEvents: x ? _ ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: $(e.onFocusCapture, N.onFocusCapture),
        onBlurCapture: $(e.onBlurCapture, N.onBlurCapture),
        onPointerDownCapture: $(
          e.onPointerDownCapture,
          C.onPointerDownCapture
        )
      }
    );
  }
);
Zn.displayName = nh;
var sh = "DismissableLayerBranch", Mi = c.forwardRef((e, t) => {
  const n = c.useContext(Pi), r = c.useRef(null), o = he(t, r);
  return c.useEffect(() => {
    const s = r.current;
    if (s)
      return n.branches.add(s), () => {
        n.branches.delete(s);
      };
  }, [n.branches]), /* @__PURE__ */ p(Z.div, { ...e, ref: o });
});
Mi.displayName = sh;
function ah(e, t = globalThis?.document) {
  const n = Ne(e), r = c.useRef(!1), o = c.useRef(() => {
  });
  return c.useEffect(() => {
    const s = (i) => {
      if (i.target && !r.current) {
        let u = function() {
          Di(
            rh,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = u, t.addEventListener("click", o.current, { once: !0 })) : u();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", s), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function ih(e, t = globalThis?.document) {
  const n = Ne(e), r = c.useRef(!1);
  return c.useEffect(() => {
    const o = (s) => {
      s.target && !r.current && Di(oh, n, { originalEvent: s }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function ka() {
  const e = new CustomEvent(Wo);
  document.dispatchEvent(e);
}
function Di(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? fs(o, s) : o.dispatchEvent(s);
}
var ch = Zn, lh = Mi, co = "focusScope.autoFocusOnMount", lo = "focusScope.autoFocusOnUnmount", Aa = { bubbles: !1, cancelable: !0 }, uh = "FocusScope", Dr = c.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: s,
    ...a
  } = e, [i, u] = c.useState(null), l = Ne(o), d = Ne(s), f = c.useRef(null), g = he(t, (h) => u(h)), v = c.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  c.useEffect(() => {
    if (r) {
      let h = function(x) {
        if (v.paused || !i) return;
        const _ = x.target;
        i.contains(_) ? f.current = _ : ht(f.current, { select: !0 });
      }, m = function(x) {
        if (v.paused || !i) return;
        const _ = x.relatedTarget;
        _ !== null && (i.contains(_) || ht(f.current, { select: !0 }));
      }, b = function(x) {
        if (document.activeElement === document.body)
          for (const C of x)
            C.removedNodes.length > 0 && ht(i);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", m);
      const w = new MutationObserver(b);
      return i && w.observe(i, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", m), w.disconnect();
      };
    }
  }, [r, i, v.paused]), c.useEffect(() => {
    if (i) {
      Oa.add(v);
      const h = document.activeElement;
      if (!i.contains(h)) {
        const b = new CustomEvent(co, Aa);
        i.addEventListener(co, l), i.dispatchEvent(b), b.defaultPrevented || (dh(gh(Li(i)), { select: !0 }), document.activeElement === h && ht(i));
      }
      return () => {
        i.removeEventListener(co, l), setTimeout(() => {
          const b = new CustomEvent(lo, Aa);
          i.addEventListener(lo, d), i.dispatchEvent(b), b.defaultPrevented || ht(h ?? document.body, { select: !0 }), i.removeEventListener(lo, d), Oa.remove(v);
        }, 0);
      };
    }
  }, [i, l, d, v]);
  const y = c.useCallback(
    (h) => {
      if (!n && !r || v.paused) return;
      const m = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, b = document.activeElement;
      if (m && b) {
        const w = h.currentTarget, [x, _] = fh(w);
        x && _ ? !h.shiftKey && b === _ ? (h.preventDefault(), n && ht(x, { select: !0 })) : h.shiftKey && b === x && (h.preventDefault(), n && ht(_, { select: !0 })) : b === w && h.preventDefault();
      }
    },
    [n, r, v.paused]
  );
  return /* @__PURE__ */ p(Z.div, { tabIndex: -1, ...a, ref: g, onKeyDown: y });
});
Dr.displayName = uh;
function dh(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (ht(r, { select: t }), document.activeElement !== n) return;
}
function fh(e) {
  const t = Li(e), n = Ia(t, e), r = Ia(t.reverse(), e);
  return [n, r];
}
function Li(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Ia(e, t) {
  for (const n of e)
    if (!ph(n, { upTo: t })) return n;
}
function ph(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function hh(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ht(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && hh(e) && t && e.select();
  }
}
var Oa = mh();
function mh() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = Pa(e, t), e.unshift(t);
    },
    remove(t) {
      e = Pa(e, t), e[0]?.resume();
    }
  };
}
function Pa(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function gh(e) {
  return e.filter((t) => t.tagName !== "A");
}
var vh = "Portal", Gn = c.forwardRef((e, t) => {
  const { container: n, ...r } = e, [o, s] = c.useState(!1);
  Ee(() => s(!0), []);
  const a = n || o && globalThis?.document?.body;
  return a ? gd.createPortal(/* @__PURE__ */ p(Z.div, { ...r, ref: t }), a) : null;
});
Gn.displayName = vh;
function yh(e, t) {
  return c.useReducer((n, r) => t[n][r] ?? n, e);
}
var ut = (e) => {
  const { present: t, children: n } = e, r = bh(t), o = typeof n == "function" ? n({ present: r.isPresent }) : c.Children.only(n), s = he(r.ref, wh(o));
  return typeof n == "function" || r.isPresent ? c.cloneElement(o, { ref: s }) : null;
};
ut.displayName = "Presence";
function bh(e) {
  const [t, n] = c.useState(), r = c.useRef(null), o = c.useRef(e), s = c.useRef("none"), a = e ? "mounted" : "unmounted", [i, u] = yh(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return c.useEffect(() => {
    const l = nr(r.current);
    s.current = i === "mounted" ? l : "none";
  }, [i]), Ee(() => {
    const l = r.current, d = o.current;
    if (d !== e) {
      const g = s.current, v = nr(l);
      e ? u("MOUNT") : v === "none" || l?.display === "none" ? u("UNMOUNT") : u(d && g !== v ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, u]), Ee(() => {
    if (t) {
      let l;
      const d = t.ownerDocument.defaultView ?? window, f = (v) => {
        const h = nr(r.current).includes(v.animationName);
        if (v.target === t && h && (u("ANIMATION_END"), !o.current)) {
          const m = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = m);
          });
        }
      }, g = (v) => {
        v.target === t && (s.current = nr(r.current));
      };
      return t.addEventListener("animationstart", g), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        d.clearTimeout(l), t.removeEventListener("animationstart", g), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      u("ANIMATION_END");
  }, [t, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: c.useCallback((l) => {
      r.current = l ? getComputedStyle(l) : null, n(l);
    }, [])
  };
}
function nr(e) {
  return e?.animationName || "none";
}
function wh(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var uo = 0;
function hs() {
  c.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Ma()), document.body.insertAdjacentElement("beforeend", e[1] ?? Ma()), uo++, () => {
      uo === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), uo--;
    };
  }, []);
}
function Ma() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Ze = function() {
  return Ze = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, Ze.apply(this, arguments);
};
function Fi(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function xh(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, s; r < o; r++)
    (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var ur = "right-scroll-bar-position", dr = "width-before-scroll-bar", _h = "with-scroll-bars-hidden", Sh = "--removed-body-scroll-bar-size";
function fo(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Ch(e, t) {
  var n = St(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Eh = typeof window < "u" ? c.useLayoutEffect : c.useEffect, Da = /* @__PURE__ */ new WeakMap();
function Rh(e, t) {
  var n = Ch(null, function(r) {
    return e.forEach(function(o) {
      return fo(o, r);
    });
  });
  return Eh(function() {
    var r = Da.get(n);
    if (r) {
      var o = new Set(r), s = new Set(e), a = n.current;
      o.forEach(function(i) {
        s.has(i) || fo(i, null);
      }), s.forEach(function(i) {
        o.has(i) || fo(i, a);
      });
    }
    Da.set(n, e);
  }, [e]), n;
}
function Th(e) {
  return e;
}
function Nh(e, t) {
  t === void 0 && (t = Th);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(s) {
      var a = t(s, r);
      return n.push(a), function() {
        n = n.filter(function(i) {
          return i !== a;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(s);
      }
      n = {
        push: function(i) {
          return s(i);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(s) {
      r = !0;
      var a = [];
      if (n.length) {
        var i = n;
        n = [], i.forEach(s), a = n;
      }
      var u = function() {
        var d = a;
        a = [], d.forEach(s);
      }, l = function() {
        return Promise.resolve().then(u);
      };
      l(), n = {
        push: function(d) {
          a.push(d), l();
        },
        filter: function(d) {
          return a = a.filter(d), n;
        }
      };
    }
  };
  return o;
}
function kh(e) {
  e === void 0 && (e = {});
  var t = Nh(null);
  return t.options = Ze({ async: !0, ssr: !1 }, e), t;
}
var $i = function(e) {
  var t = e.sideCar, n = Fi(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return c.createElement(r, Ze({}, n));
};
$i.isSideCarExport = !0;
function Ah(e, t) {
  return e.useMedium(t), $i;
}
var ji = kh(), po = function() {
}, Lr = c.forwardRef(function(e, t) {
  var n = c.useRef(null), r = c.useState({
    onScrollCapture: po,
    onWheelCapture: po,
    onTouchMoveCapture: po
  }), o = r[0], s = r[1], a = e.forwardProps, i = e.children, u = e.className, l = e.removeScrollBar, d = e.enabled, f = e.shards, g = e.sideCar, v = e.noRelative, y = e.noIsolation, h = e.inert, m = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, x = e.gapMode, _ = Fi(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), C = g, N = Rh([n, t]), E = Ze(Ze({}, _), o);
  return c.createElement(
    c.Fragment,
    null,
    d && c.createElement(C, { sideCar: ji, removeScrollBar: l, shards: f, noRelative: v, noIsolation: y, inert: h, setCallbacks: s, allowPinchZoom: !!m, lockRef: n, gapMode: x }),
    a ? c.cloneElement(c.Children.only(i), Ze(Ze({}, E), { ref: N })) : c.createElement(w, Ze({}, E, { className: u, ref: N }), i)
  );
});
Lr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Lr.classNames = {
  fullWidth: dr,
  zeroRight: ur
};
var Ih = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Oh() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Ih();
  return t && e.setAttribute("nonce", t), e;
}
function Ph(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Mh(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Dh = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Oh()) && (Ph(t, n), Mh(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Lh = function() {
  var e = Dh();
  return function(t, n) {
    c.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Vi = function() {
  var e = Lh(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, Fh = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, ho = function(e) {
  return parseInt(e || "", 10) || 0;
}, $h = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [ho(n), ho(r), ho(o)];
}, jh = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Fh;
  var t = $h(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Vh = Vi(), nn = "data-scroll-locked", Bh = function(e, t, n, r) {
  var o = e.left, s = e.top, a = e.right, i = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(_h, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(i, "px ").concat(r, `;
  }
  body[`).concat(nn, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(i, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ur, ` {
    right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(dr, ` {
    margin-right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(ur, " .").concat(ur, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(dr, " .").concat(dr, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(nn, `] {
    `).concat(Sh, ": ").concat(i, `px;
  }
`);
}, La = function() {
  var e = parseInt(document.body.getAttribute(nn) || "0", 10);
  return isFinite(e) ? e : 0;
}, Uh = function() {
  c.useEffect(function() {
    return document.body.setAttribute(nn, (La() + 1).toString()), function() {
      var e = La() - 1;
      e <= 0 ? document.body.removeAttribute(nn) : document.body.setAttribute(nn, e.toString());
    };
  }, []);
}, zh = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  Uh();
  var s = c.useMemo(function() {
    return jh(o);
  }, [o]);
  return c.createElement(Vh, { styles: Bh(s, !t, o, n ? "" : "!important") });
}, Ho = !1;
if (typeof window < "u")
  try {
    var rr = Object.defineProperty({}, "passive", {
      get: function() {
        return Ho = !0, !0;
      }
    });
    window.addEventListener("test", rr, rr), window.removeEventListener("test", rr, rr);
  } catch {
    Ho = !1;
  }
var qt = Ho ? { passive: !1 } : !1, Wh = function(e) {
  return e.tagName === "TEXTAREA";
}, Bi = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Wh(e) && n[t] === "visible")
  );
}, Hh = function(e) {
  return Bi(e, "overflowY");
}, Kh = function(e) {
  return Bi(e, "overflowX");
}, Fa = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Ui(e, r);
    if (o) {
      var s = zi(e, r), a = s[1], i = s[2];
      if (a > i)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Zh = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Gh = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Ui = function(e, t) {
  return e === "v" ? Hh(t) : Kh(t);
}, zi = function(e, t) {
  return e === "v" ? Zh(t) : Gh(t);
}, qh = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Yh = function(e, t, n, r, o) {
  var s = qh(e, window.getComputedStyle(t).direction), a = s * r, i = n.target, u = t.contains(i), l = !1, d = a > 0, f = 0, g = 0;
  do {
    if (!i)
      break;
    var v = zi(e, i), y = v[0], h = v[1], m = v[2], b = h - m - s * y;
    (y || b) && Ui(e, i) && (f += b, g += y);
    var w = i.parentNode;
    i = w && w.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? w.host : w;
  } while (
    // portaled content
    !u && i !== document.body || // self content
    u && (t.contains(i) || t === i)
  );
  return (d && Math.abs(f) < 1 || !d && Math.abs(g) < 1) && (l = !0), l;
}, or = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, $a = function(e) {
  return [e.deltaX, e.deltaY];
}, ja = function(e) {
  return e && "current" in e ? e.current : e;
}, Qh = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Xh = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Jh = 0, Yt = [];
function em(e) {
  var t = c.useRef([]), n = c.useRef([0, 0]), r = c.useRef(), o = c.useState(Jh++)[0], s = c.useState(Vi)[0], a = c.useRef(e);
  c.useEffect(function() {
    a.current = e;
  }, [e]), c.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = xh([e.lockRef.current], (e.shards || []).map(ja), !0).filter(Boolean);
      return h.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = c.useCallback(function(h, m) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !a.current.allowPinchZoom;
    var b = or(h), w = n.current, x = "deltaX" in h ? h.deltaX : w[0] - b[0], _ = "deltaY" in h ? h.deltaY : w[1] - b[1], C, N = h.target, E = Math.abs(x) > Math.abs(_) ? "h" : "v";
    if ("touches" in h && E === "h" && N.type === "range")
      return !1;
    var k = Fa(E, N);
    if (!k)
      return !0;
    if (k ? C = E : (C = E === "v" ? "h" : "v", k = Fa(E, N)), !k)
      return !1;
    if (!r.current && "changedTouches" in h && (x || _) && (r.current = C), !C)
      return !0;
    var M = r.current || C;
    return Yh(M, m, h, M === "h" ? x : _);
  }, []), u = c.useCallback(function(h) {
    var m = h;
    if (!(!Yt.length || Yt[Yt.length - 1] !== s)) {
      var b = "deltaY" in m ? $a(m) : or(m), w = t.current.filter(function(C) {
        return C.name === m.type && (C.target === m.target || m.target === C.shadowParent) && Qh(C.delta, b);
      })[0];
      if (w && w.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!w) {
        var x = (a.current.shards || []).map(ja).filter(Boolean).filter(function(C) {
          return C.contains(m.target);
        }), _ = x.length > 0 ? i(m, x[0]) : !a.current.noIsolation;
        _ && m.cancelable && m.preventDefault();
      }
    }
  }, []), l = c.useCallback(function(h, m, b, w) {
    var x = { name: h, delta: m, target: b, should: w, shadowParent: tm(b) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(_) {
        return _ !== x;
      });
    }, 1);
  }, []), d = c.useCallback(function(h) {
    n.current = or(h), r.current = void 0;
  }, []), f = c.useCallback(function(h) {
    l(h.type, $a(h), h.target, i(h, e.lockRef.current));
  }, []), g = c.useCallback(function(h) {
    l(h.type, or(h), h.target, i(h, e.lockRef.current));
  }, []);
  c.useEffect(function() {
    return Yt.push(s), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: g
    }), document.addEventListener("wheel", u, qt), document.addEventListener("touchmove", u, qt), document.addEventListener("touchstart", d, qt), function() {
      Yt = Yt.filter(function(h) {
        return h !== s;
      }), document.removeEventListener("wheel", u, qt), document.removeEventListener("touchmove", u, qt), document.removeEventListener("touchstart", d, qt);
    };
  }, []);
  var v = e.removeScrollBar, y = e.inert;
  return c.createElement(
    c.Fragment,
    null,
    y ? c.createElement(s, { styles: Xh(o) }) : null,
    v ? c.createElement(zh, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function tm(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const nm = Ah(ji, em);
var Fr = c.forwardRef(function(e, t) {
  return c.createElement(Lr, Ze({}, e, { ref: t, sideCar: nm }));
});
Fr.classNames = Lr.classNames;
var rm = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Qt = /* @__PURE__ */ new WeakMap(), sr = /* @__PURE__ */ new WeakMap(), ar = {}, mo = 0, Wi = function(e) {
  return e && (e.host || Wi(e.parentNode));
}, om = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Wi(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, sm = function(e, t, n, r) {
  var o = om(t, Array.isArray(e) ? e : [e]);
  ar[n] || (ar[n] = /* @__PURE__ */ new WeakMap());
  var s = ar[n], a = [], i = /* @__PURE__ */ new Set(), u = new Set(o), l = function(f) {
    !f || i.has(f) || (i.add(f), l(f.parentNode));
  };
  o.forEach(l);
  var d = function(f) {
    !f || u.has(f) || Array.prototype.forEach.call(f.children, function(g) {
      if (i.has(g))
        d(g);
      else
        try {
          var v = g.getAttribute(r), y = v !== null && v !== "false", h = (Qt.get(g) || 0) + 1, m = (s.get(g) || 0) + 1;
          Qt.set(g, h), s.set(g, m), a.push(g), h === 1 && y && sr.set(g, !0), m === 1 && g.setAttribute(n, "true"), y || g.setAttribute(r, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", g, b);
        }
    });
  };
  return d(t), i.clear(), mo++, function() {
    a.forEach(function(f) {
      var g = Qt.get(f) - 1, v = s.get(f) - 1;
      Qt.set(f, g), s.set(f, v), g || (sr.has(f) || f.removeAttribute(r), sr.delete(f)), v || f.removeAttribute(n);
    }), mo--, mo || (Qt = /* @__PURE__ */ new WeakMap(), Qt = /* @__PURE__ */ new WeakMap(), sr = /* @__PURE__ */ new WeakMap(), ar = {});
  };
}, ms = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = rm(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), sm(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, $r = "Dialog", [Hi, Lx] = lt($r), [am, Ke] = Hi($r), Ki = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: s,
    modal: a = !0
  } = e, i = c.useRef(null), u = c.useRef(null), [l, d] = Bt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: s,
    caller: $r
  });
  return /* @__PURE__ */ p(
    am,
    {
      scope: t,
      triggerRef: i,
      contentRef: u,
      contentId: Re(),
      titleId: Re(),
      descriptionId: Re(),
      open: l,
      onOpenChange: d,
      onOpenToggle: c.useCallback(() => d((f) => !f), [d]),
      modal: a,
      children: n
    }
  );
};
Ki.displayName = $r;
var Zi = "DialogTrigger", Gi = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ke(Zi, n), s = he(t, o.triggerRef);
    return /* @__PURE__ */ p(
      Z.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": ys(o.open),
        ...r,
        ref: s,
        onClick: $(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Gi.displayName = Zi;
var gs = "DialogPortal", [im, qi] = Hi(gs, {
  forceMount: void 0
}), Yi = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, s = Ke(gs, t);
  return /* @__PURE__ */ p(im, { scope: t, forceMount: n, children: c.Children.map(r, (a) => /* @__PURE__ */ p(ut, { present: n || s.open, children: /* @__PURE__ */ p(Gn, { asChild: !0, container: o, children: a }) })) });
};
Yi.displayName = gs;
var Sr = "DialogOverlay", Qi = c.forwardRef(
  (e, t) => {
    const n = qi(Sr, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, s = Ke(Sr, e.__scopeDialog);
    return s.modal ? /* @__PURE__ */ p(ut, { present: r || s.open, children: /* @__PURE__ */ p(lm, { ...o, ref: t }) }) : null;
  }
);
Qi.displayName = Sr;
var cm = /* @__PURE__ */ Vt("DialogOverlay.RemoveScroll"), lm = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ke(Sr, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ p(Fr, { as: cm, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ p(
        Z.div,
        {
          "data-state": ys(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Ut = "DialogContent", Xi = c.forwardRef(
  (e, t) => {
    const n = qi(Ut, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, s = Ke(Ut, e.__scopeDialog);
    return /* @__PURE__ */ p(ut, { present: r || s.open, children: s.modal ? /* @__PURE__ */ p(um, { ...o, ref: t }) : /* @__PURE__ */ p(dm, { ...o, ref: t }) });
  }
);
Xi.displayName = Ut;
var um = c.forwardRef(
  (e, t) => {
    const n = Ke(Ut, e.__scopeDialog), r = c.useRef(null), o = he(t, n.contentRef, r);
    return c.useEffect(() => {
      const s = r.current;
      if (s) return ms(s);
    }, []), /* @__PURE__ */ p(
      Ji,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: $(e.onCloseAutoFocus, (s) => {
          s.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: $(e.onPointerDownOutside, (s) => {
          const a = s.detail.originalEvent, i = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || i) && s.preventDefault();
        }),
        onFocusOutside: $(
          e.onFocusOutside,
          (s) => s.preventDefault()
        )
      }
    );
  }
), dm = c.forwardRef(
  (e, t) => {
    const n = Ke(Ut, e.__scopeDialog), r = c.useRef(!1), o = c.useRef(!1);
    return /* @__PURE__ */ p(
      Ji,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          e.onCloseAutoFocus?.(s), s.defaultPrevented || (r.current || n.triggerRef.current?.focus(), s.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (s) => {
          e.onInteractOutside?.(s), s.defaultPrevented || (r.current = !0, s.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const a = s.target;
          n.triggerRef.current?.contains(a) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && o.current && s.preventDefault();
        }
      }
    );
  }
), Ji = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: s, ...a } = e, i = Ke(Ut, n), u = c.useRef(null), l = he(t, u);
    return hs(), /* @__PURE__ */ ve($t, { children: [
      /* @__PURE__ */ p(
        Dr,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: s,
          children: /* @__PURE__ */ p(
            Zn,
            {
              role: "dialog",
              id: i.contentId,
              "aria-describedby": i.descriptionId,
              "aria-labelledby": i.titleId,
              "data-state": ys(i.open),
              ...a,
              ref: l,
              onDismiss: () => i.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ ve($t, { children: [
        /* @__PURE__ */ p(fm, { titleId: i.titleId }),
        /* @__PURE__ */ p(hm, { contentRef: u, descriptionId: i.descriptionId })
      ] })
    ] });
  }
), vs = "DialogTitle", ec = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ke(vs, n);
    return /* @__PURE__ */ p(Z.h2, { id: o.titleId, ...r, ref: t });
  }
);
ec.displayName = vs;
var tc = "DialogDescription", nc = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ke(tc, n);
    return /* @__PURE__ */ p(Z.p, { id: o.descriptionId, ...r, ref: t });
  }
);
nc.displayName = tc;
var rc = "DialogClose", oc = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ke(rc, n);
    return /* @__PURE__ */ p(
      Z.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: $(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
oc.displayName = rc;
function ys(e) {
  return e ? "open" : "closed";
}
var sc = "DialogTitleWarning", [Fx, ac] = dp(sc, {
  contentName: Ut,
  titleName: vs,
  docsSlug: "dialog"
}), fm = ({ titleId: e }) => {
  const t = ac(sc), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return c.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, pm = "DialogDescriptionWarning", hm = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${ac(pm).contentName}}.`;
  return c.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, ic = Ki, mm = Gi, cc = Yi, bs = Qi, ws = Xi, lc = ec, uc = nc, dc = oc, En = '[cmdk-group=""]', go = '[cmdk-group-items=""]', gm = '[cmdk-group-heading=""]', fc = '[cmdk-item=""]', Va = `${fc}:not([aria-disabled="true"])`, Ko = "cmdk-item-select", Jt = "data-value", vm = (e, t, n) => qp(e, t, n), pc = c.createContext(void 0), qn = () => c.useContext(pc), hc = c.createContext(void 0), xs = () => c.useContext(hc), mc = c.createContext(void 0), gc = c.forwardRef((e, t) => {
  let n = en(() => {
    var R, K;
    return { search: "", value: (K = (R = e.value) != null ? R : e.defaultValue) != null ? K : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = en(() => /* @__PURE__ */ new Set()), o = en(() => /* @__PURE__ */ new Map()), s = en(() => /* @__PURE__ */ new Map()), a = en(() => /* @__PURE__ */ new Set()), i = vc(e), { label: u, children: l, value: d, onValueChange: f, filter: g, shouldFilter: v, loop: y, disablePointerSelection: h = !1, vimBindings: m = !0, ...b } = e, w = Re(), x = Re(), _ = Re(), C = c.useRef(null), N = Nm();
  zt(() => {
    if (d !== void 0) {
      let R = d.trim();
      n.current.value = R, E.emit();
    }
  }, [d]), zt(() => {
    N(6, J);
  }, []);
  let E = c.useMemo(() => ({ subscribe: (R) => (a.current.add(R), () => a.current.delete(R)), snapshot: () => n.current, setState: (R, K, G) => {
    var z, ee, I, re;
    if (!Object.is(n.current[R], K)) {
      if (n.current[R] = K, R === "search") L(), F(), N(1, H);
      else if (R === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let ce = document.getElementById(_);
          ce ? ce.focus() : (z = document.getElementById(w)) == null || z.focus();
        }
        if (N(7, () => {
          var ce;
          n.current.selectedItemId = (ce = O()) == null ? void 0 : ce.id, E.emit();
        }), G || N(5, J), ((ee = i.current) == null ? void 0 : ee.value) !== void 0) {
          let ce = K ?? "";
          (re = (I = i.current).onValueChange) == null || re.call(I, ce);
          return;
        }
      }
      E.emit();
    }
  }, emit: () => {
    a.current.forEach((R) => R());
  } }), []), k = c.useMemo(() => ({ value: (R, K, G) => {
    var z;
    K !== ((z = s.current.get(R)) == null ? void 0 : z.value) && (s.current.set(R, { value: K, keywords: G }), n.current.filtered.items.set(R, M(K, G)), N(2, () => {
      F(), E.emit();
    }));
  }, item: (R, K) => (r.current.add(R), K && (o.current.has(K) ? o.current.get(K).add(R) : o.current.set(K, /* @__PURE__ */ new Set([R]))), N(3, () => {
    L(), F(), n.current.value || H(), E.emit();
  }), () => {
    s.current.delete(R), r.current.delete(R), n.current.filtered.items.delete(R);
    let G = O();
    N(4, () => {
      L(), G?.getAttribute("id") === R && H(), E.emit();
    });
  }), group: (R) => (o.current.has(R) || o.current.set(R, /* @__PURE__ */ new Set()), () => {
    s.current.delete(R), o.current.delete(R);
  }), filter: () => i.current.shouldFilter, label: u || e["aria-label"], getDisablePointerSelection: () => i.current.disablePointerSelection, listId: w, inputId: _, labelId: x, listInnerRef: C }), []);
  function M(R, K) {
    var G, z;
    let ee = (z = (G = i.current) == null ? void 0 : G.filter) != null ? z : vm;
    return R ? ee(R, n.current.search, K) : 0;
  }
  function F() {
    if (!n.current.search || i.current.shouldFilter === !1) return;
    let R = n.current.filtered.items, K = [];
    n.current.filtered.groups.forEach((z) => {
      let ee = o.current.get(z), I = 0;
      ee.forEach((re) => {
        let ce = R.get(re);
        I = Math.max(ce, I);
      }), K.push([z, I]);
    });
    let G = C.current;
    q().sort((z, ee) => {
      var I, re;
      let ce = z.getAttribute("id"), ue = ee.getAttribute("id");
      return ((I = R.get(ue)) != null ? I : 0) - ((re = R.get(ce)) != null ? re : 0);
    }).forEach((z) => {
      let ee = z.closest(go);
      ee ? ee.appendChild(z.parentElement === ee ? z : z.closest(`${go} > *`)) : G.appendChild(z.parentElement === G ? z : z.closest(`${go} > *`));
    }), K.sort((z, ee) => ee[1] - z[1]).forEach((z) => {
      var ee;
      let I = (ee = C.current) == null ? void 0 : ee.querySelector(`${En}[${Jt}="${encodeURIComponent(z[0])}"]`);
      I?.parentElement.appendChild(I);
    });
  }
  function H() {
    let R = q().find((G) => G.getAttribute("aria-disabled") !== "true"), K = R?.getAttribute(Jt);
    E.setState("value", K || void 0);
  }
  function L() {
    var R, K, G, z;
    if (!n.current.search || i.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let ee = 0;
    for (let I of r.current) {
      let re = (K = (R = s.current.get(I)) == null ? void 0 : R.value) != null ? K : "", ce = (z = (G = s.current.get(I)) == null ? void 0 : G.keywords) != null ? z : [], ue = M(re, ce);
      n.current.filtered.items.set(I, ue), ue > 0 && ee++;
    }
    for (let [I, re] of o.current) for (let ce of re) if (n.current.filtered.items.get(ce) > 0) {
      n.current.filtered.groups.add(I);
      break;
    }
    n.current.filtered.count = ee;
  }
  function J() {
    var R, K, G;
    let z = O();
    z && (((R = z.parentElement) == null ? void 0 : R.firstChild) === z && ((G = (K = z.closest(En)) == null ? void 0 : K.querySelector(gm)) == null || G.scrollIntoView({ block: "nearest" })), z.scrollIntoView({ block: "nearest" }));
  }
  function O() {
    var R;
    return (R = C.current) == null ? void 0 : R.querySelector(`${fc}[aria-selected="true"]`);
  }
  function q() {
    var R;
    return Array.from(((R = C.current) == null ? void 0 : R.querySelectorAll(Va)) || []);
  }
  function B(R) {
    let K = q()[R];
    K && E.setState("value", K.getAttribute(Jt));
  }
  function Q(R) {
    var K;
    let G = O(), z = q(), ee = z.findIndex((re) => re === G), I = z[ee + R];
    (K = i.current) != null && K.loop && (I = ee + R < 0 ? z[z.length - 1] : ee + R === z.length ? z[0] : z[ee + R]), I && E.setState("value", I.getAttribute(Jt));
  }
  function j(R) {
    let K = O(), G = K?.closest(En), z;
    for (; G && !z; ) G = R > 0 ? Rm(G, En) : Tm(G, En), z = G?.querySelector(Va);
    z ? E.setState("value", z.getAttribute(Jt)) : Q(R);
  }
  let P = () => B(q().length - 1), fe = (R) => {
    R.preventDefault(), R.metaKey ? P() : R.altKey ? j(1) : Q(1);
  }, le = (R) => {
    R.preventDefault(), R.metaKey ? B(0) : R.altKey ? j(-1) : Q(-1);
  };
  return c.createElement(Z.div, { ref: t, tabIndex: -1, ...b, "cmdk-root": "", onKeyDown: (R) => {
    var K;
    (K = b.onKeyDown) == null || K.call(b, R);
    let G = R.nativeEvent.isComposing || R.keyCode === 229;
    if (!(R.defaultPrevented || G)) switch (R.key) {
      case "n":
      case "j": {
        m && R.ctrlKey && fe(R);
        break;
      }
      case "ArrowDown": {
        fe(R);
        break;
      }
      case "p":
      case "k": {
        m && R.ctrlKey && le(R);
        break;
      }
      case "ArrowUp": {
        le(R);
        break;
      }
      case "Home": {
        R.preventDefault(), B(0);
        break;
      }
      case "End": {
        R.preventDefault(), P();
        break;
      }
      case "Enter": {
        R.preventDefault();
        let z = O();
        if (z) {
          let ee = new Event(Ko);
          z.dispatchEvent(ee);
        }
      }
    }
  } }, c.createElement("label", { "cmdk-label": "", htmlFor: k.inputId, id: k.labelId, style: Am }, u), jr(e, (R) => c.createElement(hc.Provider, { value: E }, c.createElement(pc.Provider, { value: k }, R))));
}), ym = c.forwardRef((e, t) => {
  var n, r;
  let o = Re(), s = c.useRef(null), a = c.useContext(mc), i = qn(), u = vc(e), l = (r = (n = u.current) == null ? void 0 : n.forceMount) != null ? r : a?.forceMount;
  zt(() => {
    if (!l) return i.item(o, a?.id);
  }, [l]);
  let d = yc(o, s, [e.value, e.children, s], e.keywords), f = xs(), g = Rt((N) => N.value && N.value === d.current), v = Rt((N) => l || i.filter() === !1 ? !0 : N.search ? N.filtered.items.get(o) > 0 : !0);
  c.useEffect(() => {
    let N = s.current;
    if (!(!N || e.disabled)) return N.addEventListener(Ko, y), () => N.removeEventListener(Ko, y);
  }, [v, e.onSelect, e.disabled]);
  function y() {
    var N, E;
    h(), (E = (N = u.current).onSelect) == null || E.call(N, d.current);
  }
  function h() {
    f.setState("value", d.current, !0);
  }
  if (!v) return null;
  let { disabled: m, value: b, onSelect: w, forceMount: x, keywords: _, ...C } = e;
  return c.createElement(Z.div, { ref: at(s, t), ...C, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!m, "aria-selected": !!g, "data-disabled": !!m, "data-selected": !!g, onPointerMove: m || i.getDisablePointerSelection() ? void 0 : h, onClick: m ? void 0 : y }, e.children);
}), bm = c.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: o, ...s } = e, a = Re(), i = c.useRef(null), u = c.useRef(null), l = Re(), d = qn(), f = Rt((v) => o || d.filter() === !1 ? !0 : v.search ? v.filtered.groups.has(a) : !0);
  zt(() => d.group(a), []), yc(a, i, [e.value, e.heading, u]);
  let g = c.useMemo(() => ({ id: a, forceMount: o }), [o]);
  return c.createElement(Z.div, { ref: at(i, t), ...s, "cmdk-group": "", role: "presentation", hidden: f ? void 0 : !0 }, n && c.createElement("div", { ref: u, "cmdk-group-heading": "", "aria-hidden": !0, id: l }, n), jr(e, (v) => c.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? l : void 0 }, c.createElement(mc.Provider, { value: g }, v))));
}), wm = c.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, o = c.useRef(null), s = Rt((a) => !a.search);
  return !n && !s ? null : c.createElement(Z.div, { ref: at(o, t), ...r, "cmdk-separator": "", role: "separator" });
}), xm = c.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, o = e.value != null, s = xs(), a = Rt((l) => l.search), i = Rt((l) => l.selectedItemId), u = qn();
  return c.useEffect(() => {
    e.value != null && s.setState("search", e.value);
  }, [e.value]), c.createElement(Z.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": u.listId, "aria-labelledby": u.labelId, "aria-activedescendant": i, id: u.inputId, type: "text", value: o ? e.value : a, onChange: (l) => {
    o || s.setState("search", l.target.value), n?.(l.target.value);
  } });
}), _m = c.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...o } = e, s = c.useRef(null), a = c.useRef(null), i = Rt((l) => l.selectedItemId), u = qn();
  return c.useEffect(() => {
    if (a.current && s.current) {
      let l = a.current, d = s.current, f, g = new ResizeObserver(() => {
        f = requestAnimationFrame(() => {
          let v = l.offsetHeight;
          d.style.setProperty("--cmdk-list-height", v.toFixed(1) + "px");
        });
      });
      return g.observe(l), () => {
        cancelAnimationFrame(f), g.unobserve(l);
      };
    }
  }, []), c.createElement(Z.div, { ref: at(s, t), ...o, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": i, "aria-label": r, id: u.listId }, jr(e, (l) => c.createElement("div", { ref: at(a, u.listInnerRef), "cmdk-list-sizer": "" }, l)));
}), Sm = c.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: o, contentClassName: s, container: a, ...i } = e;
  return c.createElement(ic, { open: n, onOpenChange: r }, c.createElement(cc, { container: a }, c.createElement(bs, { "cmdk-overlay": "", className: o }), c.createElement(ws, { "aria-label": e.label, "cmdk-dialog": "", className: s }, c.createElement(gc, { ref: t, ...i }))));
}), Cm = c.forwardRef((e, t) => Rt((n) => n.filtered.count === 0) ? c.createElement(Z.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), Em = c.forwardRef((e, t) => {
  let { progress: n, children: r, label: o = "Loading...", ...s } = e;
  return c.createElement(Z.div, { ref: t, ...s, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, jr(e, (a) => c.createElement("div", { "aria-hidden": !0 }, a)));
}), De = Object.assign(gc, { List: _m, Item: ym, Input: xm, Group: bm, Separator: wm, Dialog: Sm, Empty: Cm, Loading: Em });
function Rm(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function Tm(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function vc(e) {
  let t = c.useRef(e);
  return zt(() => {
    t.current = e;
  }), t;
}
var zt = typeof window > "u" ? c.useEffect : c.useLayoutEffect;
function en(e) {
  let t = c.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function Rt(e) {
  let t = xs(), n = () => e(t.snapshot());
  return c.useSyncExternalStore(t.subscribe, n, n);
}
function yc(e, t, n, r = []) {
  let o = c.useRef(), s = qn();
  return zt(() => {
    var a;
    let i = (() => {
      var l;
      for (let d of n) {
        if (typeof d == "string") return d.trim();
        if (typeof d == "object" && "current" in d) return d.current ? (l = d.current.textContent) == null ? void 0 : l.trim() : o.current;
      }
    })(), u = r.map((l) => l.trim());
    s.value(e, i, u), (a = t.current) == null || a.setAttribute(Jt, i), o.current = i;
  }), o;
}
var Nm = () => {
  let [e, t] = c.useState(), n = en(() => /* @__PURE__ */ new Map());
  return zt(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, o) => {
    n.current.set(r, o), t({});
  };
};
function km(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function jr({ asChild: e, children: t }, n) {
  return e && c.isValidElement(t) ? c.cloneElement(km(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var Am = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
/**
 * @license lucide-react v0.427.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Im = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), bc = (...e) => e.filter((t, n, r) => !!t && r.indexOf(t) === n).join(" ");
/**
 * @license lucide-react v0.427.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Om = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.427.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pm = ai(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: o = "",
    children: s,
    iconNode: a,
    ...i
  }, u) => So(
    "svg",
    {
      ref: u,
      ...Om,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: bc("lucide", o),
      ...i
    },
    [
      ...a.map(([l, d]) => So(l, d)),
      ...Array.isArray(s) ? s : [s]
    ]
  )
);
/**
 * @license lucide-react v0.427.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zt = (e, t) => {
  const n = ai(
    ({ className: r, ...o }, s) => So(Pm, {
      ref: s,
      iconNode: t,
      className: bc(`lucide-${Im(e)}`, r),
      ...o
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.427.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wc = Zt("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.427.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xc = Zt("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.427.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mm = Zt("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.427.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dm = Zt("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
/**
 * @license lucide-react v0.427.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lm = Zt("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.427.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fm = Zt("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.427.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _c = Zt("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), $m = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  De,
  {
    ref: n,
    className: U(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
      e
    ),
    ...t
  }
));
$m.displayName = De.displayName;
const jm = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ ve("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
  /* @__PURE__ */ p(Fm, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
  /* @__PURE__ */ p(
    De.Input,
    {
      ref: n,
      className: U(
        "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...t
    }
  )
] }));
jm.displayName = De.Input.displayName;
const Vm = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  De.List,
  {
    ref: n,
    className: U("max-h-[300px] overflow-y-auto overflow-x-hidden", e),
    ...t
  }
));
Vm.displayName = De.List.displayName;
const Bm = c.forwardRef((e, t) => /* @__PURE__ */ p(
  De.Empty,
  {
    ref: t,
    className: "py-6 text-center text-sm",
    ...e
  }
));
Bm.displayName = De.Empty.displayName;
const Um = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  De.Group,
  {
    ref: n,
    className: U(
      "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
      e
    ),
    ...t
  }
));
Um.displayName = De.Group.displayName;
const zm = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  De.Separator,
  {
    ref: n,
    className: U("-mx-1 h-px bg-border", e),
    ...t
  }
));
zm.displayName = De.Separator.displayName;
const Wm = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  De.Item,
  {
    ref: n,
    className: U(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none aria-selected:bg-accent aria-selected:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...t
  }
));
Wm.displayName = De.Item.displayName;
const Hm = ({
  className: e,
  ...t
}) => /* @__PURE__ */ p(
  "span",
  {
    className: U(
      "ml-auto text-xs tracking-widest text-muted-foreground",
      e
    ),
    ...t
  }
);
Hm.displayName = "CommandShortcut";
function _e(...e) {
  return _i(us(e));
}
const Km = ge.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ p(
    "div",
    {
      ref: r,
      className: _e(
        "rounded-lg border border-border/50 bg-card shadow-sm transition-shadow hover:shadow-md",
        t
      ),
      ...n,
      children: e
    }
  )
);
Km.displayName = "DataCard";
const Zm = ge.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ p(
    "div",
    {
      ref: r,
      className: _e(
        "flex items-center justify-between p-6 pb-4",
        t
      ),
      ...n,
      children: e
    }
  )
);
Zm.displayName = "DataCardHeader";
const Gm = ge.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ p(
    "h3",
    {
      ref: r,
      className: _e(
        "text-lg font-semibold text-card-foreground",
        t
      ),
      ...n,
      children: e
    }
  )
);
Gm.displayName = "DataCardTitle";
const qm = ge.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ p(
    "div",
    {
      ref: r,
      className: _e("px-6 pb-6", t),
      ...n,
      children: e
    }
  )
);
qm.displayName = "DataCardContent";
const Ym = ge.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ p(
    "div",
    {
      ref: r,
      className: _e(
        "flex items-center justify-end gap-2 px-6 py-4 border-t border-border/50 bg-muted/30",
        t
      ),
      ...n,
      children: e
    }
  )
);
Ym.displayName = "DataCardActions";
const Qm = ge.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ p(
    "div",
    {
      ref: r,
      className: _e("space-y-6", t),
      ...n,
      children: e
    }
  )
);
Qm.displayName = "DetailSection";
const Xm = ge.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ p(
    "div",
    {
      ref: r,
      className: _e("border-b border-border/40 pb-4", t),
      ...n,
      children: e
    }
  )
);
Xm.displayName = "DetailSectionHeader";
const Jm = ge.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ p(
    "h2",
    {
      ref: r,
      className: _e(
        "text-xl font-semibold tracking-tight text-foreground",
        t
      ),
      ...n,
      children: e
    }
  )
);
Jm.displayName = "DetailSectionTitle";
const eg = ge.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ p(
    "div",
    {
      ref: r,
      className: _e("space-y-4", t),
      ...n,
      children: e
    }
  )
);
eg.displayName = "DetailSectionContent";
const tg = ge.forwardRef(
  ({ label: e, value: t, className: n, vertical: r = !1, ...o }, s) => /* @__PURE__ */ ve(
    "div",
    {
      ref: s,
      className: _e(
        "group",
        r ? "space-y-2" : "flex items-center justify-between",
        n
      ),
      ...o,
      children: [
        /* @__PURE__ */ p("dt", { className: _e(
          "text-sm font-medium text-muted-foreground",
          r ? "block" : "flex-shrink-0"
        ), children: e }),
        /* @__PURE__ */ p("dd", { className: _e(
          "text-sm text-foreground",
          r ? "block" : "text-right"
        ), children: t })
      ]
    }
  )
);
tg.displayName = "DetailItem";
const $x = ic, jx = mm, ng = cc, Vx = dc, Sc = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  bs,
  {
    ref: n,
    className: U(
      "fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
Sc.displayName = bs.displayName;
const rg = c.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ ve(ng, { children: [
  /* @__PURE__ */ p(Sc, {}),
  /* @__PURE__ */ ve(
    ws,
    {
      ref: r,
      className: U(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...n,
      children: [
        t,
        /* @__PURE__ */ ve(dc, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ p(_c, { className: "h-4 w-4" }),
          /* @__PURE__ */ p("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
rg.displayName = ws.displayName;
const og = ({
  className: e,
  ...t
}) => /* @__PURE__ */ p(
  "div",
  {
    className: U(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      e
    ),
    ...t
  }
);
og.displayName = "DialogHeader";
const sg = ({
  className: e,
  ...t
}) => /* @__PURE__ */ p(
  "div",
  {
    className: U(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
sg.displayName = "DialogFooter";
const ag = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  lc,
  {
    ref: n,
    className: U(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
ag.displayName = lc.displayName;
const ig = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  uc,
  {
    ref: n,
    className: U("text-sm text-muted-foreground", e),
    ...t
  }
));
ig.displayName = uc.displayName;
function Vr(e) {
  const t = e + "CollectionProvider", [n, r] = lt(t), [o, s] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (h) => {
    const { scope: m, children: b } = h, w = ge.useRef(null), x = ge.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ p(o, { scope: m, itemMap: x, collectionRef: w, children: b });
  };
  a.displayName = t;
  const i = e + "CollectionSlot", u = /* @__PURE__ */ Vt(i), l = ge.forwardRef(
    (h, m) => {
      const { scope: b, children: w } = h, x = s(i, b), _ = he(m, x.collectionRef);
      return /* @__PURE__ */ p(u, { ref: _, children: w });
    }
  );
  l.displayName = i;
  const d = e + "CollectionItemSlot", f = "data-radix-collection-item", g = /* @__PURE__ */ Vt(d), v = ge.forwardRef(
    (h, m) => {
      const { scope: b, children: w, ...x } = h, _ = ge.useRef(null), C = he(m, _), N = s(d, b);
      return ge.useEffect(() => (N.itemMap.set(_, { ref: _, ...x }), () => void N.itemMap.delete(_))), /* @__PURE__ */ p(g, { [f]: "", ref: C, children: w });
    }
  );
  v.displayName = d;
  function y(h) {
    const m = s(e + "CollectionConsumer", h);
    return ge.useCallback(() => {
      const w = m.collectionRef.current;
      if (!w) return [];
      const x = Array.from(w.querySelectorAll(`[${f}]`));
      return Array.from(m.itemMap.values()).sort(
        (N, E) => x.indexOf(N.ref.current) - x.indexOf(E.ref.current)
      );
    }, [m.collectionRef, m.itemMap]);
  }
  return [
    { Provider: a, Slot: l, ItemSlot: v },
    y,
    r
  ];
}
var cg = c.createContext(void 0);
function _s(e) {
  const t = c.useContext(cg);
  return e || t || "ltr";
}
const lg = ["top", "right", "bottom", "left"], Tt = Math.min, Le = Math.max, Cr = Math.round, ir = Math.floor, Ye = (e) => ({
  x: e,
  y: e
}), ug = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, dg = {
  start: "end",
  end: "start"
};
function Zo(e, t, n) {
  return Le(e, Tt(t, n));
}
function it(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ct(e) {
  return e.split("-")[0];
}
function wn(e) {
  return e.split("-")[1];
}
function Ss(e) {
  return e === "x" ? "y" : "x";
}
function Cs(e) {
  return e === "y" ? "height" : "width";
}
const fg = /* @__PURE__ */ new Set(["top", "bottom"]);
function Ge(e) {
  return fg.has(ct(e)) ? "y" : "x";
}
function Es(e) {
  return Ss(Ge(e));
}
function pg(e, t, n) {
  n === void 0 && (n = !1);
  const r = wn(e), o = Es(e), s = Cs(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (a = Er(a)), [a, Er(a)];
}
function hg(e) {
  const t = Er(e);
  return [Go(e), t, Go(t)];
}
function Go(e) {
  return e.replace(/start|end/g, (t) => dg[t]);
}
const Ba = ["left", "right"], Ua = ["right", "left"], mg = ["top", "bottom"], gg = ["bottom", "top"];
function vg(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Ua : Ba : t ? Ba : Ua;
    case "left":
    case "right":
      return t ? mg : gg;
    default:
      return [];
  }
}
function yg(e, t, n, r) {
  const o = wn(e);
  let s = vg(ct(e), n === "start", r);
  return o && (s = s.map((a) => a + "-" + o), t && (s = s.concat(s.map(Go)))), s;
}
function Er(e) {
  return e.replace(/left|right|bottom|top/g, (t) => ug[t]);
}
function bg(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Cc(e) {
  return typeof e != "number" ? bg(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Rr(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function za(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const s = Ge(t), a = Es(t), i = Cs(a), u = ct(t), l = s === "y", d = r.x + r.width / 2 - o.width / 2, f = r.y + r.height / 2 - o.height / 2, g = r[i] / 2 - o[i] / 2;
  let v;
  switch (u) {
    case "top":
      v = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      v = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      v = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      v = {
        x: r.x - o.width,
        y: f
      };
      break;
    default:
      v = {
        x: r.x,
        y: r.y
      };
  }
  switch (wn(t)) {
    case "start":
      v[a] -= g * (n && l ? -1 : 1);
      break;
    case "end":
      v[a] += g * (n && l ? -1 : 1);
      break;
  }
  return v;
}
const wg = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: s = [],
    platform: a
  } = n, i = s.filter(Boolean), u = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let l = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: d,
    y: f
  } = za(l, r, u), g = r, v = {}, y = 0;
  for (let h = 0; h < i.length; h++) {
    const {
      name: m,
      fn: b
    } = i[h], {
      x: w,
      y: x,
      data: _,
      reset: C
    } = await b({
      x: d,
      y: f,
      initialPlacement: r,
      placement: g,
      strategy: o,
      middlewareData: v,
      rects: l,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = w ?? d, f = x ?? f, v = {
      ...v,
      [m]: {
        ...v[m],
        ..._
      }
    }, C && y <= 50 && (y++, typeof C == "object" && (C.placement && (g = C.placement), C.rects && (l = C.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : C.rects), {
      x: d,
      y: f
    } = za(l, g, u)), h = -1);
  }
  return {
    x: d,
    y: f,
    placement: g,
    strategy: o,
    middlewareData: v
  };
};
async function jn(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: s,
    rects: a,
    elements: i,
    strategy: u
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: g = !1,
    padding: v = 0
  } = it(t, e), y = Cc(v), m = i[g ? f === "floating" ? "reference" : "floating" : f], b = Rr(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(m))) == null || n ? m : m.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(i.floating)),
    boundary: l,
    rootBoundary: d,
    strategy: u
  })), w = f === "floating" ? {
    x: r,
    y: o,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, x = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(i.floating)), _ = await (s.isElement == null ? void 0 : s.isElement(x)) ? await (s.getScale == null ? void 0 : s.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, C = Rr(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: w,
    offsetParent: x,
    strategy: u
  }) : w);
  return {
    top: (b.top - C.top + y.top) / _.y,
    bottom: (C.bottom - b.bottom + y.bottom) / _.y,
    left: (b.left - C.left + y.left) / _.x,
    right: (C.right - b.right + y.right) / _.x
  };
}
const xg = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: s,
      platform: a,
      elements: i,
      middlewareData: u
    } = t, {
      element: l,
      padding: d = 0
    } = it(e, t) || {};
    if (l == null)
      return {};
    const f = Cc(d), g = {
      x: n,
      y: r
    }, v = Es(o), y = Cs(v), h = await a.getDimensions(l), m = v === "y", b = m ? "top" : "left", w = m ? "bottom" : "right", x = m ? "clientHeight" : "clientWidth", _ = s.reference[y] + s.reference[v] - g[v] - s.floating[y], C = g[v] - s.reference[v], N = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l));
    let E = N ? N[x] : 0;
    (!E || !await (a.isElement == null ? void 0 : a.isElement(N))) && (E = i.floating[x] || s.floating[y]);
    const k = _ / 2 - C / 2, M = E / 2 - h[y] / 2 - 1, F = Tt(f[b], M), H = Tt(f[w], M), L = F, J = E - h[y] - H, O = E / 2 - h[y] / 2 + k, q = Zo(L, O, J), B = !u.arrow && wn(o) != null && O !== q && s.reference[y] / 2 - (O < L ? F : H) - h[y] / 2 < 0, Q = B ? O < L ? O - L : O - J : 0;
    return {
      [v]: g[v] + Q,
      data: {
        [v]: q,
        centerOffset: O - q - Q,
        ...B && {
          alignmentOffset: Q
        }
      },
      reset: B
    };
  }
}), _g = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: s,
        rects: a,
        initialPlacement: i,
        platform: u,
        elements: l
      } = t, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: g,
        fallbackStrategy: v = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: h = !0,
        ...m
      } = it(e, t);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const b = ct(o), w = Ge(i), x = ct(i) === i, _ = await (u.isRTL == null ? void 0 : u.isRTL(l.floating)), C = g || (x || !h ? [Er(i)] : hg(i)), N = y !== "none";
      !g && N && C.push(...yg(i, h, y, _));
      const E = [i, ...C], k = await jn(t, m), M = [];
      let F = ((r = s.flip) == null ? void 0 : r.overflows) || [];
      if (d && M.push(k[b]), f) {
        const O = pg(o, a, _);
        M.push(k[O[0]], k[O[1]]);
      }
      if (F = [...F, {
        placement: o,
        overflows: M
      }], !M.every((O) => O <= 0)) {
        var H, L;
        const O = (((H = s.flip) == null ? void 0 : H.index) || 0) + 1, q = E[O];
        if (q && (!(f === "alignment" ? w !== Ge(q) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        F.every((j) => Ge(j.placement) === w ? j.overflows[0] > 0 : !0)))
          return {
            data: {
              index: O,
              overflows: F
            },
            reset: {
              placement: q
            }
          };
        let B = (L = F.filter((Q) => Q.overflows[0] <= 0).sort((Q, j) => Q.overflows[1] - j.overflows[1])[0]) == null ? void 0 : L.placement;
        if (!B)
          switch (v) {
            case "bestFit": {
              var J;
              const Q = (J = F.filter((j) => {
                if (N) {
                  const P = Ge(j.placement);
                  return P === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  P === "y";
                }
                return !0;
              }).map((j) => [j.placement, j.overflows.filter((P) => P > 0).reduce((P, fe) => P + fe, 0)]).sort((j, P) => j[1] - P[1])[0]) == null ? void 0 : J[0];
              Q && (B = Q);
              break;
            }
            case "initialPlacement":
              B = i;
              break;
          }
        if (o !== B)
          return {
            reset: {
              placement: B
            }
          };
      }
      return {};
    }
  };
};
function Wa(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Ha(e) {
  return lg.some((t) => e[t] >= 0);
}
const Sg = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = it(e, t);
      switch (r) {
        case "referenceHidden": {
          const s = await jn(t, {
            ...o,
            elementContext: "reference"
          }), a = Wa(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: Ha(a)
            }
          };
        }
        case "escaped": {
          const s = await jn(t, {
            ...o,
            altBoundary: !0
          }), a = Wa(s, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: Ha(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, Ec = /* @__PURE__ */ new Set(["left", "top"]);
async function Cg(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, s = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = ct(n), i = wn(n), u = Ge(n) === "y", l = Ec.has(a) ? -1 : 1, d = s && u ? -1 : 1, f = it(t, e);
  let {
    mainAxis: g,
    crossAxis: v,
    alignmentAxis: y
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return i && typeof y == "number" && (v = i === "end" ? y * -1 : y), u ? {
    x: v * d,
    y: g * l
  } : {
    x: g * l,
    y: v * d
  };
}
const Eg = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: s,
        placement: a,
        middlewareData: i
      } = t, u = await Cg(t, e);
      return a === ((n = i.offset) == null ? void 0 : n.placement) && (r = i.arrow) != null && r.alignmentOffset ? {} : {
        x: o + u.x,
        y: s + u.y,
        data: {
          ...u,
          placement: a
        }
      };
    }
  };
}, Rg = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: s = !0,
        crossAxis: a = !1,
        limiter: i = {
          fn: (m) => {
            let {
              x: b,
              y: w
            } = m;
            return {
              x: b,
              y: w
            };
          }
        },
        ...u
      } = it(e, t), l = {
        x: n,
        y: r
      }, d = await jn(t, u), f = Ge(ct(o)), g = Ss(f);
      let v = l[g], y = l[f];
      if (s) {
        const m = g === "y" ? "top" : "left", b = g === "y" ? "bottom" : "right", w = v + d[m], x = v - d[b];
        v = Zo(w, v, x);
      }
      if (a) {
        const m = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", w = y + d[m], x = y - d[b];
        y = Zo(w, y, x);
      }
      const h = i.fn({
        ...t,
        [g]: v,
        [f]: y
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - r,
          enabled: {
            [g]: s,
            [f]: a
          }
        }
      };
    }
  };
}, Tg = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: s,
        middlewareData: a
      } = t, {
        offset: i = 0,
        mainAxis: u = !0,
        crossAxis: l = !0
      } = it(e, t), d = {
        x: n,
        y: r
      }, f = Ge(o), g = Ss(f);
      let v = d[g], y = d[f];
      const h = it(i, t), m = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (u) {
        const x = g === "y" ? "height" : "width", _ = s.reference[g] - s.floating[x] + m.mainAxis, C = s.reference[g] + s.reference[x] - m.mainAxis;
        v < _ ? v = _ : v > C && (v = C);
      }
      if (l) {
        var b, w;
        const x = g === "y" ? "width" : "height", _ = Ec.has(ct(o)), C = s.reference[f] - s.floating[x] + (_ && ((b = a.offset) == null ? void 0 : b[f]) || 0) + (_ ? 0 : m.crossAxis), N = s.reference[f] + s.reference[x] + (_ ? 0 : ((w = a.offset) == null ? void 0 : w[f]) || 0) - (_ ? m.crossAxis : 0);
        y < C ? y = C : y > N && (y = N);
      }
      return {
        [g]: v,
        [f]: y
      };
    }
  };
}, Ng = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: s,
        platform: a,
        elements: i
      } = t, {
        apply: u = () => {
        },
        ...l
      } = it(e, t), d = await jn(t, l), f = ct(o), g = wn(o), v = Ge(o) === "y", {
        width: y,
        height: h
      } = s.floating;
      let m, b;
      f === "top" || f === "bottom" ? (m = f, b = g === (await (a.isRTL == null ? void 0 : a.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (b = f, m = g === "end" ? "top" : "bottom");
      const w = h - d.top - d.bottom, x = y - d.left - d.right, _ = Tt(h - d[m], w), C = Tt(y - d[b], x), N = !t.middlewareData.shift;
      let E = _, k = C;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (k = x), (r = t.middlewareData.shift) != null && r.enabled.y && (E = w), N && !g) {
        const F = Le(d.left, 0), H = Le(d.right, 0), L = Le(d.top, 0), J = Le(d.bottom, 0);
        v ? k = y - 2 * (F !== 0 || H !== 0 ? F + H : Le(d.left, d.right)) : E = h - 2 * (L !== 0 || J !== 0 ? L + J : Le(d.top, d.bottom));
      }
      await u({
        ...t,
        availableWidth: k,
        availableHeight: E
      });
      const M = await a.getDimensions(i.floating);
      return y !== M.width || h !== M.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Br() {
  return typeof window < "u";
}
function xn(e) {
  return Rc(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Fe(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function et(e) {
  var t;
  return (t = (Rc(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Rc(e) {
  return Br() ? e instanceof Node || e instanceof Fe(e).Node : !1;
}
function We(e) {
  return Br() ? e instanceof Element || e instanceof Fe(e).Element : !1;
}
function Xe(e) {
  return Br() ? e instanceof HTMLElement || e instanceof Fe(e).HTMLElement : !1;
}
function Ka(e) {
  return !Br() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Fe(e).ShadowRoot;
}
const kg = /* @__PURE__ */ new Set(["inline", "contents"]);
function Yn(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = He(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !kg.has(o);
}
const Ag = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Ig(e) {
  return Ag.has(xn(e));
}
const Og = [":popover-open", ":modal"];
function Ur(e) {
  return Og.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const Pg = ["transform", "translate", "scale", "rotate", "perspective"], Mg = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Dg = ["paint", "layout", "strict", "content"];
function Rs(e) {
  const t = Ts(), n = We(e) ? He(e) : e;
  return Pg.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || Mg.some((r) => (n.willChange || "").includes(r)) || Dg.some((r) => (n.contain || "").includes(r));
}
function Lg(e) {
  let t = Nt(e);
  for (; Xe(t) && !yn(t); ) {
    if (Rs(t))
      return t;
    if (Ur(t))
      return null;
    t = Nt(t);
  }
  return null;
}
function Ts() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const Fg = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function yn(e) {
  return Fg.has(xn(e));
}
function He(e) {
  return Fe(e).getComputedStyle(e);
}
function zr(e) {
  return We(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Nt(e) {
  if (xn(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ka(e) && e.host || // Fallback.
    et(e)
  );
  return Ka(t) ? t.host : t;
}
function Tc(e) {
  const t = Nt(e);
  return yn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Xe(t) && Yn(t) ? t : Tc(t);
}
function Vn(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Tc(e), s = o === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Fe(o);
  if (s) {
    const i = qo(a);
    return t.concat(a, a.visualViewport || [], Yn(o) ? o : [], i && n ? Vn(i) : []);
  }
  return t.concat(o, Vn(o, [], n));
}
function qo(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Nc(e) {
  const t = He(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Xe(e), s = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, i = Cr(n) !== s || Cr(r) !== a;
  return i && (n = s, r = a), {
    width: n,
    height: r,
    $: i
  };
}
function Ns(e) {
  return We(e) ? e : e.contextElement;
}
function rn(e) {
  const t = Ns(e);
  if (!Xe(t))
    return Ye(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: s
  } = Nc(t);
  let a = (s ? Cr(n.width) : n.width) / r, i = (s ? Cr(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: a,
    y: i
  };
}
const $g = /* @__PURE__ */ Ye(0);
function kc(e) {
  const t = Fe(e);
  return !Ts() || !t.visualViewport ? $g : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function jg(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Fe(e) ? !1 : t;
}
function Wt(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), s = Ns(e);
  let a = Ye(1);
  t && (r ? We(r) && (a = rn(r)) : a = rn(e));
  const i = jg(s, n, r) ? kc(s) : Ye(0);
  let u = (o.left + i.x) / a.x, l = (o.top + i.y) / a.y, d = o.width / a.x, f = o.height / a.y;
  if (s) {
    const g = Fe(s), v = r && We(r) ? Fe(r) : r;
    let y = g, h = qo(y);
    for (; h && r && v !== y; ) {
      const m = rn(h), b = h.getBoundingClientRect(), w = He(h), x = b.left + (h.clientLeft + parseFloat(w.paddingLeft)) * m.x, _ = b.top + (h.clientTop + parseFloat(w.paddingTop)) * m.y;
      u *= m.x, l *= m.y, d *= m.x, f *= m.y, u += x, l += _, y = Fe(h), h = qo(y);
    }
  }
  return Rr({
    width: d,
    height: f,
    x: u,
    y: l
  });
}
function ks(e, t) {
  const n = zr(e).scrollLeft;
  return t ? t.left + n : Wt(et(e)).left + n;
}
function Ac(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    ks(e, r)
  )), s = r.top + t.scrollTop;
  return {
    x: o,
    y: s
  };
}
function Vg(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const s = o === "fixed", a = et(r), i = t ? Ur(t.floating) : !1;
  if (r === a || i && s)
    return n;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = Ye(1);
  const d = Ye(0), f = Xe(r);
  if ((f || !f && !s) && ((xn(r) !== "body" || Yn(a)) && (u = zr(r)), Xe(r))) {
    const v = Wt(r);
    l = rn(r), d.x = v.x + r.clientLeft, d.y = v.y + r.clientTop;
  }
  const g = a && !f && !s ? Ac(a, u, !0) : Ye(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - u.scrollLeft * l.x + d.x + g.x,
    y: n.y * l.y - u.scrollTop * l.y + d.y + g.y
  };
}
function Bg(e) {
  return Array.from(e.getClientRects());
}
function Ug(e) {
  const t = et(e), n = zr(e), r = e.ownerDocument.body, o = Le(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), s = Le(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + ks(e);
  const i = -n.scrollTop;
  return He(r).direction === "rtl" && (a += Le(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: s,
    x: a,
    y: i
  };
}
function zg(e, t) {
  const n = Fe(e), r = et(e), o = n.visualViewport;
  let s = r.clientWidth, a = r.clientHeight, i = 0, u = 0;
  if (o) {
    s = o.width, a = o.height;
    const l = Ts();
    (!l || l && t === "fixed") && (i = o.offsetLeft, u = o.offsetTop);
  }
  return {
    width: s,
    height: a,
    x: i,
    y: u
  };
}
const Wg = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Hg(e, t) {
  const n = Wt(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, s = Xe(e) ? rn(e) : Ye(1), a = e.clientWidth * s.x, i = e.clientHeight * s.y, u = o * s.x, l = r * s.y;
  return {
    width: a,
    height: i,
    x: u,
    y: l
  };
}
function Za(e, t, n) {
  let r;
  if (t === "viewport")
    r = zg(e, n);
  else if (t === "document")
    r = Ug(et(e));
  else if (We(t))
    r = Hg(t, n);
  else {
    const o = kc(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Rr(r);
}
function Ic(e, t) {
  const n = Nt(e);
  return n === t || !We(n) || yn(n) ? !1 : He(n).position === "fixed" || Ic(n, t);
}
function Kg(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Vn(e, [], !1).filter((i) => We(i) && xn(i) !== "body"), o = null;
  const s = He(e).position === "fixed";
  let a = s ? Nt(e) : e;
  for (; We(a) && !yn(a); ) {
    const i = He(a), u = Rs(a);
    !u && i.position === "fixed" && (o = null), (s ? !u && !o : !u && i.position === "static" && !!o && Wg.has(o.position) || Yn(a) && !u && Ic(e, a)) ? r = r.filter((d) => d !== a) : o = i, a = Nt(a);
  }
  return t.set(e, r), r;
}
function Zg(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const a = [...n === "clippingAncestors" ? Ur(t) ? [] : Kg(t, this._c) : [].concat(n), r], i = a[0], u = a.reduce((l, d) => {
    const f = Za(t, d, o);
    return l.top = Le(f.top, l.top), l.right = Tt(f.right, l.right), l.bottom = Tt(f.bottom, l.bottom), l.left = Le(f.left, l.left), l;
  }, Za(t, i, o));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function Gg(e) {
  const {
    width: t,
    height: n
  } = Nc(e);
  return {
    width: t,
    height: n
  };
}
function qg(e, t, n) {
  const r = Xe(t), o = et(t), s = n === "fixed", a = Wt(e, !0, s, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = Ye(0);
  function l() {
    u.x = ks(o);
  }
  if (r || !r && !s)
    if ((xn(t) !== "body" || Yn(o)) && (i = zr(t)), r) {
      const v = Wt(t, !0, s, t);
      u.x = v.x + t.clientLeft, u.y = v.y + t.clientTop;
    } else o && l();
  s && !r && o && l();
  const d = o && !r && !s ? Ac(o, i) : Ye(0), f = a.left + i.scrollLeft - u.x - d.x, g = a.top + i.scrollTop - u.y - d.y;
  return {
    x: f,
    y: g,
    width: a.width,
    height: a.height
  };
}
function vo(e) {
  return He(e).position === "static";
}
function Ga(e, t) {
  if (!Xe(e) || He(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return et(e) === n && (n = n.ownerDocument.body), n;
}
function Oc(e, t) {
  const n = Fe(e);
  if (Ur(e))
    return n;
  if (!Xe(e)) {
    let o = Nt(e);
    for (; o && !yn(o); ) {
      if (We(o) && !vo(o))
        return o;
      o = Nt(o);
    }
    return n;
  }
  let r = Ga(e, t);
  for (; r && Ig(r) && vo(r); )
    r = Ga(r, t);
  return r && yn(r) && vo(r) && !Rs(r) ? n : r || Lg(e) || n;
}
const Yg = async function(e) {
  const t = this.getOffsetParent || Oc, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: qg(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Qg(e) {
  return He(e).direction === "rtl";
}
const Xg = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Vg,
  getDocumentElement: et,
  getClippingRect: Zg,
  getOffsetParent: Oc,
  getElementRects: Yg,
  getClientRects: Bg,
  getDimensions: Gg,
  getScale: rn,
  isElement: We,
  isRTL: Qg
};
function Pc(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Jg(e, t) {
  let n = null, r;
  const o = et(e);
  function s() {
    var i;
    clearTimeout(r), (i = n) == null || i.disconnect(), n = null;
  }
  function a(i, u) {
    i === void 0 && (i = !1), u === void 0 && (u = 1), s();
    const l = e.getBoundingClientRect(), {
      left: d,
      top: f,
      width: g,
      height: v
    } = l;
    if (i || t(), !g || !v)
      return;
    const y = ir(f), h = ir(o.clientWidth - (d + g)), m = ir(o.clientHeight - (f + v)), b = ir(d), x = {
      rootMargin: -y + "px " + -h + "px " + -m + "px " + -b + "px",
      threshold: Le(0, Tt(1, u)) || 1
    };
    let _ = !0;
    function C(N) {
      const E = N[0].intersectionRatio;
      if (E !== u) {
        if (!_)
          return a();
        E ? a(!1, E) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !Pc(l, e.getBoundingClientRect()) && a(), _ = !1;
    }
    try {
      n = new IntersectionObserver(C, {
        ...x,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(C, x);
    }
    n.observe(e);
  }
  return a(!0), s;
}
function ev(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: s = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, l = Ns(e), d = o || s ? [...l ? Vn(l) : [], ...Vn(t)] : [];
  d.forEach((b) => {
    o && b.addEventListener("scroll", n, {
      passive: !0
    }), s && b.addEventListener("resize", n);
  });
  const f = l && i ? Jg(l, n) : null;
  let g = -1, v = null;
  a && (v = new ResizeObserver((b) => {
    let [w] = b;
    w && w.target === l && v && (v.unobserve(t), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var x;
      (x = v) == null || x.observe(t);
    })), n();
  }), l && !u && v.observe(l), v.observe(t));
  let y, h = u ? Wt(e) : null;
  u && m();
  function m() {
    const b = Wt(e);
    h && !Pc(h, b) && n(), h = b, y = requestAnimationFrame(m);
  }
  return n(), () => {
    var b;
    d.forEach((w) => {
      o && w.removeEventListener("scroll", n), s && w.removeEventListener("resize", n);
    }), f?.(), (b = v) == null || b.disconnect(), v = null, u && cancelAnimationFrame(y);
  };
}
const tv = Eg, nv = Rg, rv = _g, ov = Ng, sv = Sg, qa = xg, av = Tg, iv = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: Xg,
    ...n
  }, s = {
    ...o.platform,
    _c: r
  };
  return wg(e, t, {
    ...o,
    platform: s
  });
};
var cv = typeof document < "u", lv = function() {
}, fr = cv ? md : lv;
function Tr(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!Tr(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const s = o[r];
      if (!(s === "_owner" && e.$$typeof) && !Tr(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Mc(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ya(e, t) {
  const n = Mc(e);
  return Math.round(t * n) / n;
}
function yo(e) {
  const t = c.useRef(e);
  return fr(() => {
    t.current = e;
  }), t;
}
function uv(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: s,
      floating: a
    } = {},
    transform: i = !0,
    whileElementsMounted: u,
    open: l
  } = e, [d, f] = c.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [g, v] = c.useState(r);
  Tr(g, r) || v(r);
  const [y, h] = c.useState(null), [m, b] = c.useState(null), w = c.useCallback((j) => {
    j !== N.current && (N.current = j, h(j));
  }, []), x = c.useCallback((j) => {
    j !== E.current && (E.current = j, b(j));
  }, []), _ = s || y, C = a || m, N = c.useRef(null), E = c.useRef(null), k = c.useRef(d), M = u != null, F = yo(u), H = yo(o), L = yo(l), J = c.useCallback(() => {
    if (!N.current || !E.current)
      return;
    const j = {
      placement: t,
      strategy: n,
      middleware: g
    };
    H.current && (j.platform = H.current), iv(N.current, E.current, j).then((P) => {
      const fe = {
        ...P,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: L.current !== !1
      };
      O.current && !Tr(k.current, fe) && (k.current = fe, Hn.flushSync(() => {
        f(fe);
      }));
    });
  }, [g, t, n, H, L]);
  fr(() => {
    l === !1 && k.current.isPositioned && (k.current.isPositioned = !1, f((j) => ({
      ...j,
      isPositioned: !1
    })));
  }, [l]);
  const O = c.useRef(!1);
  fr(() => (O.current = !0, () => {
    O.current = !1;
  }), []), fr(() => {
    if (_ && (N.current = _), C && (E.current = C), _ && C) {
      if (F.current)
        return F.current(_, C, J);
      J();
    }
  }, [_, C, J, F, M]);
  const q = c.useMemo(() => ({
    reference: N,
    floating: E,
    setReference: w,
    setFloating: x
  }), [w, x]), B = c.useMemo(() => ({
    reference: _,
    floating: C
  }), [_, C]), Q = c.useMemo(() => {
    const j = {
      position: n,
      left: 0,
      top: 0
    };
    if (!B.floating)
      return j;
    const P = Ya(B.floating, d.x), fe = Ya(B.floating, d.y);
    return i ? {
      ...j,
      transform: "translate(" + P + "px, " + fe + "px)",
      ...Mc(B.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: P,
      top: fe
    };
  }, [n, i, B.floating, d.x, d.y]);
  return c.useMemo(() => ({
    ...d,
    update: J,
    refs: q,
    elements: B,
    floatingStyles: Q
  }), [d, J, q, B, Q]);
}
const dv = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? qa({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? qa({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, fv = (e, t) => ({
  ...tv(e),
  options: [e, t]
}), pv = (e, t) => ({
  ...nv(e),
  options: [e, t]
}), hv = (e, t) => ({
  ...av(e),
  options: [e, t]
}), mv = (e, t) => ({
  ...rv(e),
  options: [e, t]
}), gv = (e, t) => ({
  ...ov(e),
  options: [e, t]
}), vv = (e, t) => ({
  ...sv(e),
  options: [e, t]
}), yv = (e, t) => ({
  ...dv(e),
  options: [e, t]
});
var bv = "Arrow", Dc = c.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...s } = e;
  return /* @__PURE__ */ p(
    Z.svg,
    {
      ...s,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ p("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Dc.displayName = bv;
var wv = Dc;
function xv(e) {
  const [t, n] = c.useState(void 0);
  return Ee(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const s = o[0];
        let a, i;
        if ("borderBoxSize" in s) {
          const u = s.borderBoxSize, l = Array.isArray(u) ? u[0] : u;
          a = l.inlineSize, i = l.blockSize;
        } else
          a = e.offsetWidth, i = e.offsetHeight;
        n({ width: a, height: i });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var As = "Popper", [Lc, Wr] = lt(As), [_v, Fc] = Lc(As), $c = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = c.useState(null);
  return /* @__PURE__ */ p(_v, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
$c.displayName = As;
var jc = "PopperAnchor", Vc = c.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, s = Fc(jc, n), a = c.useRef(null), i = he(t, a);
    return c.useEffect(() => {
      s.onAnchorChange(r?.current || a.current);
    }), r ? null : /* @__PURE__ */ p(Z.div, { ...o, ref: i });
  }
);
Vc.displayName = jc;
var Is = "PopperContent", [Sv, Cv] = Lc(Is), Bc = c.forwardRef(
  (e, t) => {
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: s = "center",
      alignOffset: a = 0,
      arrowPadding: i = 0,
      avoidCollisions: u = !0,
      collisionBoundary: l = [],
      collisionPadding: d = 0,
      sticky: f = "partial",
      hideWhenDetached: g = !1,
      updatePositionStrategy: v = "optimized",
      onPlaced: y,
      ...h
    } = e, m = Fc(Is, n), [b, w] = c.useState(null), x = he(t, (I) => w(I)), [_, C] = c.useState(null), N = xv(_), E = N?.width ?? 0, k = N?.height ?? 0, M = r + (s !== "center" ? "-" + s : ""), F = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, H = Array.isArray(l) ? l : [l], L = H.length > 0, J = {
      padding: F,
      boundary: H.filter(Rv),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: L
    }, { refs: O, floatingStyles: q, placement: B, isPositioned: Q, middlewareData: j } = uv({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: M,
      whileElementsMounted: (...I) => ev(...I, {
        animationFrame: v === "always"
      }),
      elements: {
        reference: m.anchor
      },
      middleware: [
        fv({ mainAxis: o + k, alignmentAxis: a }),
        u && pv({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? hv() : void 0,
          ...J
        }),
        u && mv({ ...J }),
        gv({
          ...J,
          apply: ({ elements: I, rects: re, availableWidth: ce, availableHeight: ue }) => {
            const { width: we, height: Se } = re.reference, $e = I.floating.style;
            $e.setProperty("--radix-popper-available-width", `${ce}px`), $e.setProperty("--radix-popper-available-height", `${ue}px`), $e.setProperty("--radix-popper-anchor-width", `${we}px`), $e.setProperty("--radix-popper-anchor-height", `${Se}px`);
          }
        }),
        _ && yv({ element: _, padding: i }),
        Tv({ arrowWidth: E, arrowHeight: k }),
        g && vv({ strategy: "referenceHidden", ...J })
      ]
    }), [P, fe] = Wc(B), le = Ne(y);
    Ee(() => {
      Q && le?.();
    }, [Q, le]);
    const R = j.arrow?.x, K = j.arrow?.y, G = j.arrow?.centerOffset !== 0, [z, ee] = c.useState();
    return Ee(() => {
      b && ee(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ p(
      "div",
      {
        ref: O.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...q,
          transform: Q ? q.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: z,
          "--radix-popper-transform-origin": [
            j.transformOrigin?.x,
            j.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...j.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ p(
          Sv,
          {
            scope: n,
            placedSide: P,
            onArrowChange: C,
            arrowX: R,
            arrowY: K,
            shouldHideArrow: G,
            children: /* @__PURE__ */ p(
              Z.div,
              {
                "data-side": P,
                "data-align": fe,
                ...h,
                ref: x,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: Q ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Bc.displayName = Is;
var Uc = "PopperArrow", Ev = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, zc = c.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, s = Cv(Uc, r), a = Ev[s.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ p(
      "span",
      {
        ref: s.onArrowChange,
        style: {
          position: "absolute",
          left: s.arrowX,
          top: s.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[s.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[s.placedSide],
          visibility: s.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ p(
          wv,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
zc.displayName = Uc;
function Rv(e) {
  return e !== null;
}
var Tv = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: n, rects: r, middlewareData: o } = t, a = o.arrow?.centerOffset !== 0, i = a ? 0 : e.arrowWidth, u = a ? 0 : e.arrowHeight, [l, d] = Wc(n), f = { start: "0%", center: "50%", end: "100%" }[d], g = (o.arrow?.x ?? 0) + i / 2, v = (o.arrow?.y ?? 0) + u / 2;
    let y = "", h = "";
    return l === "bottom" ? (y = a ? f : `${g}px`, h = `${-u}px`) : l === "top" ? (y = a ? f : `${g}px`, h = `${r.floating.height + u}px`) : l === "right" ? (y = `${-u}px`, h = a ? f : `${v}px`) : l === "left" && (y = `${r.floating.width + u}px`, h = a ? f : `${v}px`), { data: { x: y, y: h } };
  }
});
function Wc(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Os = $c, Hc = Vc, Kc = Bc, Zc = zc, bo = "rovingFocusGroup.onEntryFocus", Nv = { bubbles: !1, cancelable: !0 }, Qn = "RovingFocusGroup", [Yo, Gc, kv] = Vr(Qn), [Av, qc] = lt(
  Qn,
  [kv]
), [Iv, Ov] = Av(Qn), Yc = c.forwardRef(
  (e, t) => /* @__PURE__ */ p(Yo.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ p(Yo.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ p(Pv, { ...e, ref: t }) }) })
);
Yc.displayName = Qn;
var Pv = c.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: s,
    currentTabStopId: a,
    defaultCurrentTabStopId: i,
    onCurrentTabStopIdChange: u,
    onEntryFocus: l,
    preventScrollOnEntryFocus: d = !1,
    ...f
  } = e, g = c.useRef(null), v = he(t, g), y = _s(s), [h, m] = Bt({
    prop: a,
    defaultProp: i ?? null,
    onChange: u,
    caller: Qn
  }), [b, w] = c.useState(!1), x = Ne(l), _ = Gc(n), C = c.useRef(!1), [N, E] = c.useState(0);
  return c.useEffect(() => {
    const k = g.current;
    if (k)
      return k.addEventListener(bo, x), () => k.removeEventListener(bo, x);
  }, [x]), /* @__PURE__ */ p(
    Iv,
    {
      scope: n,
      orientation: r,
      dir: y,
      loop: o,
      currentTabStopId: h,
      onItemFocus: c.useCallback(
        (k) => m(k),
        [m]
      ),
      onItemShiftTab: c.useCallback(() => w(!0), []),
      onFocusableItemAdd: c.useCallback(
        () => E((k) => k + 1),
        []
      ),
      onFocusableItemRemove: c.useCallback(
        () => E((k) => k - 1),
        []
      ),
      children: /* @__PURE__ */ p(
        Z.div,
        {
          tabIndex: b || N === 0 ? -1 : 0,
          "data-orientation": r,
          ...f,
          ref: v,
          style: { outline: "none", ...e.style },
          onMouseDown: $(e.onMouseDown, () => {
            C.current = !0;
          }),
          onFocus: $(e.onFocus, (k) => {
            const M = !C.current;
            if (k.target === k.currentTarget && M && !b) {
              const F = new CustomEvent(bo, Nv);
              if (k.currentTarget.dispatchEvent(F), !F.defaultPrevented) {
                const H = _().filter((B) => B.focusable), L = H.find((B) => B.active), J = H.find((B) => B.id === h), q = [L, J, ...H].filter(
                  Boolean
                ).map((B) => B.ref.current);
                Jc(q, d);
              }
            }
            C.current = !1;
          }),
          onBlur: $(e.onBlur, () => w(!1))
        }
      )
    }
  );
}), Qc = "RovingFocusGroupItem", Xc = c.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: s,
      children: a,
      ...i
    } = e, u = Re(), l = s || u, d = Ov(Qc, n), f = d.currentTabStopId === l, g = Gc(n), { onFocusableItemAdd: v, onFocusableItemRemove: y, currentTabStopId: h } = d;
    return c.useEffect(() => {
      if (r)
        return v(), () => y();
    }, [r, v, y]), /* @__PURE__ */ p(
      Yo.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ p(
          Z.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": d.orientation,
            ...i,
            ref: t,
            onMouseDown: $(e.onMouseDown, (m) => {
              r ? d.onItemFocus(l) : m.preventDefault();
            }),
            onFocus: $(e.onFocus, () => d.onItemFocus(l)),
            onKeyDown: $(e.onKeyDown, (m) => {
              if (m.key === "Tab" && m.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (m.target !== m.currentTarget) return;
              const b = Lv(m, d.orientation, d.dir);
              if (b !== void 0) {
                if (m.metaKey || m.ctrlKey || m.altKey || m.shiftKey) return;
                m.preventDefault();
                let x = g().filter((_) => _.focusable).map((_) => _.ref.current);
                if (b === "last") x.reverse();
                else if (b === "prev" || b === "next") {
                  b === "prev" && x.reverse();
                  const _ = x.indexOf(m.currentTarget);
                  x = d.loop ? Fv(x, _ + 1) : x.slice(_ + 1);
                }
                setTimeout(() => Jc(x));
              }
            }),
            children: typeof a == "function" ? a({ isCurrentTabStop: f, hasTabStop: h != null }) : a
          }
        )
      }
    );
  }
);
Xc.displayName = Qc;
var Mv = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Dv(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Lv(e, t, n) {
  const r = Dv(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return Mv[r];
}
function Jc(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function Fv(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var $v = Yc, jv = Xc, Qo = ["Enter", " "], Vv = ["ArrowDown", "PageUp", "Home"], el = ["ArrowUp", "PageDown", "End"], Bv = [...Vv, ...el], Uv = {
  ltr: [...Qo, "ArrowRight"],
  rtl: [...Qo, "ArrowLeft"]
}, zv = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Xn = "Menu", [Bn, Wv, Hv] = Vr(Xn), [Gt, tl] = lt(Xn, [
  Hv,
  Wr,
  qc
]), Jn = Wr(), nl = qc(), [rl, At] = Gt(Xn), [Kv, er] = Gt(Xn), ol = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: s, modal: a = !0 } = e, i = Jn(t), [u, l] = c.useState(null), d = c.useRef(!1), f = Ne(s), g = _s(o);
  return c.useEffect(() => {
    const v = () => {
      d.current = !0, document.addEventListener("pointerdown", y, { capture: !0, once: !0 }), document.addEventListener("pointermove", y, { capture: !0, once: !0 });
    }, y = () => d.current = !1;
    return document.addEventListener("keydown", v, { capture: !0 }), () => {
      document.removeEventListener("keydown", v, { capture: !0 }), document.removeEventListener("pointerdown", y, { capture: !0 }), document.removeEventListener("pointermove", y, { capture: !0 });
    };
  }, []), /* @__PURE__ */ p(Os, { ...i, children: /* @__PURE__ */ p(
    rl,
    {
      scope: t,
      open: n,
      onOpenChange: f,
      content: u,
      onContentChange: l,
      children: /* @__PURE__ */ p(
        Kv,
        {
          scope: t,
          onClose: c.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: d,
          dir: g,
          modal: a,
          children: r
        }
      )
    }
  ) });
};
ol.displayName = Xn;
var Zv = "MenuAnchor", Ps = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Jn(n);
    return /* @__PURE__ */ p(Hc, { ...o, ...r, ref: t });
  }
);
Ps.displayName = Zv;
var Ms = "MenuPortal", [Gv, sl] = Gt(Ms, {
  forceMount: void 0
}), al = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, s = At(Ms, t);
  return /* @__PURE__ */ p(Gv, { scope: t, forceMount: n, children: /* @__PURE__ */ p(ut, { present: n || s.open, children: /* @__PURE__ */ p(Gn, { asChild: !0, container: o, children: r }) }) });
};
al.displayName = Ms;
var je = "MenuContent", [qv, Ds] = Gt(je), il = c.forwardRef(
  (e, t) => {
    const n = sl(je, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, s = At(je, e.__scopeMenu), a = er(je, e.__scopeMenu);
    return /* @__PURE__ */ p(Bn.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ p(ut, { present: r || s.open, children: /* @__PURE__ */ p(Bn.Slot, { scope: e.__scopeMenu, children: a.modal ? /* @__PURE__ */ p(Yv, { ...o, ref: t }) : /* @__PURE__ */ p(Qv, { ...o, ref: t }) }) }) });
  }
), Yv = c.forwardRef(
  (e, t) => {
    const n = At(je, e.__scopeMenu), r = c.useRef(null), o = he(t, r);
    return c.useEffect(() => {
      const s = r.current;
      if (s) return ms(s);
    }, []), /* @__PURE__ */ p(
      Ls,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: $(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), Qv = c.forwardRef((e, t) => {
  const n = At(je, e.__scopeMenu);
  return /* @__PURE__ */ p(
    Ls,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Xv = /* @__PURE__ */ Vt("MenuContent.ScrollLock"), Ls = c.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: s,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: i,
      onEntryFocus: u,
      onEscapeKeyDown: l,
      onPointerDownOutside: d,
      onFocusOutside: f,
      onInteractOutside: g,
      onDismiss: v,
      disableOutsideScroll: y,
      ...h
    } = e, m = At(je, n), b = er(je, n), w = Jn(n), x = nl(n), _ = Wv(n), [C, N] = c.useState(null), E = c.useRef(null), k = he(t, E, m.onContentChange), M = c.useRef(0), F = c.useRef(""), H = c.useRef(0), L = c.useRef(null), J = c.useRef("right"), O = c.useRef(0), q = y ? Fr : c.Fragment, B = y ? { as: Xv, allowPinchZoom: !0 } : void 0, Q = (P) => {
      const fe = F.current + P, le = _().filter((I) => !I.disabled), R = document.activeElement, K = le.find((I) => I.ref.current === R)?.textValue, G = le.map((I) => I.textValue), z = uy(G, fe, K), ee = le.find((I) => I.textValue === z)?.ref.current;
      (function I(re) {
        F.current = re, window.clearTimeout(M.current), re !== "" && (M.current = window.setTimeout(() => I(""), 1e3));
      })(fe), ee && setTimeout(() => ee.focus());
    };
    c.useEffect(() => () => window.clearTimeout(M.current), []), hs();
    const j = c.useCallback((P) => J.current === L.current?.side && fy(P, L.current?.area), []);
    return /* @__PURE__ */ p(
      qv,
      {
        scope: n,
        searchRef: F,
        onItemEnter: c.useCallback(
          (P) => {
            j(P) && P.preventDefault();
          },
          [j]
        ),
        onItemLeave: c.useCallback(
          (P) => {
            j(P) || (E.current?.focus(), N(null));
          },
          [j]
        ),
        onTriggerLeave: c.useCallback(
          (P) => {
            j(P) && P.preventDefault();
          },
          [j]
        ),
        pointerGraceTimerRef: H,
        onPointerGraceIntentChange: c.useCallback((P) => {
          L.current = P;
        }, []),
        children: /* @__PURE__ */ p(q, { ...B, children: /* @__PURE__ */ p(
          Dr,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: $(s, (P) => {
              P.preventDefault(), E.current?.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: a,
            children: /* @__PURE__ */ p(
              Zn,
              {
                asChild: !0,
                disableOutsidePointerEvents: i,
                onEscapeKeyDown: l,
                onPointerDownOutside: d,
                onFocusOutside: f,
                onInteractOutside: g,
                onDismiss: v,
                children: /* @__PURE__ */ p(
                  $v,
                  {
                    asChild: !0,
                    ...x,
                    dir: b.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: C,
                    onCurrentTabStopIdChange: N,
                    onEntryFocus: $(u, (P) => {
                      b.isUsingKeyboardRef.current || P.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ p(
                      Kc,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Cl(m.open),
                        "data-radix-menu-content": "",
                        dir: b.dir,
                        ...w,
                        ...h,
                        ref: k,
                        style: { outline: "none", ...h.style },
                        onKeyDown: $(h.onKeyDown, (P) => {
                          const le = P.target.closest("[data-radix-menu-content]") === P.currentTarget, R = P.ctrlKey || P.altKey || P.metaKey, K = P.key.length === 1;
                          le && (P.key === "Tab" && P.preventDefault(), !R && K && Q(P.key));
                          const G = E.current;
                          if (P.target !== G || !Bv.includes(P.key)) return;
                          P.preventDefault();
                          const ee = _().filter((I) => !I.disabled).map((I) => I.ref.current);
                          el.includes(P.key) && ee.reverse(), cy(ee);
                        }),
                        onBlur: $(e.onBlur, (P) => {
                          P.currentTarget.contains(P.target) || (window.clearTimeout(M.current), F.current = "");
                        }),
                        onPointerMove: $(
                          e.onPointerMove,
                          Un((P) => {
                            const fe = P.target, le = O.current !== P.clientX;
                            if (P.currentTarget.contains(fe) && le) {
                              const R = P.clientX > O.current ? "right" : "left";
                              J.current = R, O.current = P.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
il.displayName = je;
var Jv = "MenuGroup", Fs = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ p(Z.div, { role: "group", ...r, ref: t });
  }
);
Fs.displayName = Jv;
var ey = "MenuLabel", cl = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ p(Z.div, { ...r, ref: t });
  }
);
cl.displayName = ey;
var Nr = "MenuItem", Qa = "menu.itemSelect", Hr = c.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, s = c.useRef(null), a = er(Nr, e.__scopeMenu), i = Ds(Nr, e.__scopeMenu), u = he(t, s), l = c.useRef(!1), d = () => {
      const f = s.current;
      if (!n && f) {
        const g = new CustomEvent(Qa, { bubbles: !0, cancelable: !0 });
        f.addEventListener(Qa, (v) => r?.(v), { once: !0 }), fs(f, g), g.defaultPrevented ? l.current = !1 : a.onClose();
      }
    };
    return /* @__PURE__ */ p(
      ll,
      {
        ...o,
        ref: u,
        disabled: n,
        onClick: $(e.onClick, d),
        onPointerDown: (f) => {
          e.onPointerDown?.(f), l.current = !0;
        },
        onPointerUp: $(e.onPointerUp, (f) => {
          l.current || f.currentTarget?.click();
        }),
        onKeyDown: $(e.onKeyDown, (f) => {
          const g = i.searchRef.current !== "";
          n || g && f.key === " " || Qo.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
Hr.displayName = Nr;
var ll = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...s } = e, a = Ds(Nr, n), i = nl(n), u = c.useRef(null), l = he(t, u), [d, f] = c.useState(!1), [g, v] = c.useState("");
    return c.useEffect(() => {
      const y = u.current;
      y && v((y.textContent ?? "").trim());
    }, [s.children]), /* @__PURE__ */ p(
      Bn.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? g,
        children: /* @__PURE__ */ p(jv, { asChild: !0, ...i, focusable: !r, children: /* @__PURE__ */ p(
          Z.div,
          {
            role: "menuitem",
            "data-highlighted": d ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...s,
            ref: l,
            onPointerMove: $(
              e.onPointerMove,
              Un((y) => {
                r ? a.onItemLeave(y) : (a.onItemEnter(y), y.defaultPrevented || y.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: $(
              e.onPointerLeave,
              Un((y) => a.onItemLeave(y))
            ),
            onFocus: $(e.onFocus, () => f(!0)),
            onBlur: $(e.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), ty = "MenuCheckboxItem", ul = c.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ p(ml, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ p(
      Hr,
      {
        role: "menuitemcheckbox",
        "aria-checked": kr(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": Vs(n),
        onSelect: $(
          o.onSelect,
          () => r?.(kr(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
ul.displayName = ty;
var dl = "MenuRadioGroup", [ny, ry] = Gt(
  dl,
  { value: void 0, onValueChange: () => {
  } }
), fl = c.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, s = Ne(r);
    return /* @__PURE__ */ p(ny, { scope: e.__scopeMenu, value: n, onValueChange: s, children: /* @__PURE__ */ p(Fs, { ...o, ref: t }) });
  }
);
fl.displayName = dl;
var pl = "MenuRadioItem", hl = c.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = ry(pl, e.__scopeMenu), s = n === o.value;
    return /* @__PURE__ */ p(ml, { scope: e.__scopeMenu, checked: s, children: /* @__PURE__ */ p(
      Hr,
      {
        role: "menuitemradio",
        "aria-checked": s,
        ...r,
        ref: t,
        "data-state": Vs(s),
        onSelect: $(
          r.onSelect,
          () => o.onValueChange?.(n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
hl.displayName = pl;
var $s = "MenuItemIndicator", [ml, oy] = Gt(
  $s,
  { checked: !1 }
), gl = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, s = oy($s, n);
    return /* @__PURE__ */ p(
      ut,
      {
        present: r || kr(s.checked) || s.checked === !0,
        children: /* @__PURE__ */ p(
          Z.span,
          {
            ...o,
            ref: t,
            "data-state": Vs(s.checked)
          }
        )
      }
    );
  }
);
gl.displayName = $s;
var sy = "MenuSeparator", vl = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ p(
      Z.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
vl.displayName = sy;
var ay = "MenuArrow", yl = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Jn(n);
    return /* @__PURE__ */ p(Zc, { ...o, ...r, ref: t });
  }
);
yl.displayName = ay;
var js = "MenuSub", [iy, bl] = Gt(js), wl = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, s = At(js, t), a = Jn(t), [i, u] = c.useState(null), [l, d] = c.useState(null), f = Ne(o);
  return c.useEffect(() => (s.open === !1 && f(!1), () => f(!1)), [s.open, f]), /* @__PURE__ */ p(Os, { ...a, children: /* @__PURE__ */ p(
    rl,
    {
      scope: t,
      open: r,
      onOpenChange: f,
      content: l,
      onContentChange: d,
      children: /* @__PURE__ */ p(
        iy,
        {
          scope: t,
          contentId: Re(),
          triggerId: Re(),
          trigger: i,
          onTriggerChange: u,
          children: n
        }
      )
    }
  ) });
};
wl.displayName = js;
var Nn = "MenuSubTrigger", xl = c.forwardRef(
  (e, t) => {
    const n = At(Nn, e.__scopeMenu), r = er(Nn, e.__scopeMenu), o = bl(Nn, e.__scopeMenu), s = Ds(Nn, e.__scopeMenu), a = c.useRef(null), { pointerGraceTimerRef: i, onPointerGraceIntentChange: u } = s, l = { __scopeMenu: e.__scopeMenu }, d = c.useCallback(() => {
      a.current && window.clearTimeout(a.current), a.current = null;
    }, []);
    return c.useEffect(() => d, [d]), c.useEffect(() => {
      const f = i.current;
      return () => {
        window.clearTimeout(f), u(null);
      };
    }, [i, u]), /* @__PURE__ */ p(Ps, { asChild: !0, ...l, children: /* @__PURE__ */ p(
      ll,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": Cl(n.open),
        ...e,
        ref: at(t, o.onTriggerChange),
        onClick: (f) => {
          e.onClick?.(f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: $(
          e.onPointerMove,
          Un((f) => {
            s.onItemEnter(f), !f.defaultPrevented && !e.disabled && !n.open && !a.current && (s.onPointerGraceIntentChange(null), a.current = window.setTimeout(() => {
              n.onOpenChange(!0), d();
            }, 100));
          })
        ),
        onPointerLeave: $(
          e.onPointerLeave,
          Un((f) => {
            d();
            const g = n.content?.getBoundingClientRect();
            if (g) {
              const v = n.content?.dataset.side, y = v === "right", h = y ? -5 : 5, m = g[y ? "left" : "right"], b = g[y ? "right" : "left"];
              s.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + h, y: f.clientY },
                  { x: m, y: g.top },
                  { x: b, y: g.top },
                  { x: b, y: g.bottom },
                  { x: m, y: g.bottom }
                ],
                side: v
              }), window.clearTimeout(i.current), i.current = window.setTimeout(
                () => s.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (s.onTriggerLeave(f), f.defaultPrevented) return;
              s.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: $(e.onKeyDown, (f) => {
          const g = s.searchRef.current !== "";
          e.disabled || g && f.key === " " || Uv[r.dir].includes(f.key) && (n.onOpenChange(!0), n.content?.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
xl.displayName = Nn;
var _l = "MenuSubContent", Sl = c.forwardRef(
  (e, t) => {
    const n = sl(je, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, s = At(je, e.__scopeMenu), a = er(je, e.__scopeMenu), i = bl(_l, e.__scopeMenu), u = c.useRef(null), l = he(t, u);
    return /* @__PURE__ */ p(Bn.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ p(ut, { present: r || s.open, children: /* @__PURE__ */ p(Bn.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ p(
      Ls,
      {
        id: i.contentId,
        "aria-labelledby": i.triggerId,
        ...o,
        ref: l,
        align: "start",
        side: a.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (d) => {
          a.isUsingKeyboardRef.current && u.current?.focus(), d.preventDefault();
        },
        onCloseAutoFocus: (d) => d.preventDefault(),
        onFocusOutside: $(e.onFocusOutside, (d) => {
          d.target !== i.trigger && s.onOpenChange(!1);
        }),
        onEscapeKeyDown: $(e.onEscapeKeyDown, (d) => {
          a.onClose(), d.preventDefault();
        }),
        onKeyDown: $(e.onKeyDown, (d) => {
          const f = d.currentTarget.contains(d.target), g = zv[a.dir].includes(d.key);
          f && g && (s.onOpenChange(!1), i.trigger?.focus(), d.preventDefault());
        })
      }
    ) }) }) });
  }
);
Sl.displayName = _l;
function Cl(e) {
  return e ? "open" : "closed";
}
function kr(e) {
  return e === "indeterminate";
}
function Vs(e) {
  return kr(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function cy(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function ly(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function uy(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((l) => l === t[0]) ? t[0] : t, s = n ? e.indexOf(n) : -1;
  let a = ly(e, Math.max(s, 0));
  o.length === 1 && (a = a.filter((l) => l !== n));
  const u = a.find(
    (l) => l.toLowerCase().startsWith(o.toLowerCase())
  );
  return u !== n ? u : void 0;
}
function dy(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let s = 0, a = t.length - 1; s < t.length; a = s++) {
    const i = t[s], u = t[a], l = i.x, d = i.y, f = u.x, g = u.y;
    d > r != g > r && n < (f - l) * (r - d) / (g - d) + l && (o = !o);
  }
  return o;
}
function fy(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return dy(n, t);
}
function Un(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var py = ol, hy = Ps, my = al, gy = il, vy = Fs, yy = cl, by = Hr, wy = ul, xy = fl, _y = hl, Sy = gl, Cy = vl, Ey = yl, Ry = wl, Ty = xl, Ny = Sl, Kr = "DropdownMenu", [ky, Bx] = lt(
  Kr,
  [tl]
), ke = tl(), [Ay, El] = ky(Kr), Rl = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: s,
    onOpenChange: a,
    modal: i = !0
  } = e, u = ke(t), l = c.useRef(null), [d, f] = Bt({
    prop: o,
    defaultProp: s ?? !1,
    onChange: a,
    caller: Kr
  });
  return /* @__PURE__ */ p(
    Ay,
    {
      scope: t,
      triggerId: Re(),
      triggerRef: l,
      contentId: Re(),
      open: d,
      onOpenChange: f,
      onOpenToggle: c.useCallback(() => f((g) => !g), [f]),
      modal: i,
      children: /* @__PURE__ */ p(py, { ...u, open: d, onOpenChange: f, dir: r, modal: i, children: n })
    }
  );
};
Rl.displayName = Kr;
var Tl = "DropdownMenuTrigger", Nl = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, s = El(Tl, n), a = ke(n);
    return /* @__PURE__ */ p(hy, { asChild: !0, ...a, children: /* @__PURE__ */ p(
      Z.button,
      {
        type: "button",
        id: s.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": s.open,
        "aria-controls": s.open ? s.contentId : void 0,
        "data-state": s.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: at(t, s.triggerRef),
        onPointerDown: $(e.onPointerDown, (i) => {
          !r && i.button === 0 && i.ctrlKey === !1 && (s.onOpenToggle(), s.open || i.preventDefault());
        }),
        onKeyDown: $(e.onKeyDown, (i) => {
          r || (["Enter", " "].includes(i.key) && s.onOpenToggle(), i.key === "ArrowDown" && s.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(i.key) && i.preventDefault());
        })
      }
    ) });
  }
);
Nl.displayName = Tl;
var Iy = "DropdownMenuPortal", kl = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = ke(t);
  return /* @__PURE__ */ p(my, { ...r, ...n });
};
kl.displayName = Iy;
var Al = "DropdownMenuContent", Il = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = El(Al, n), s = ke(n), a = c.useRef(!1);
    return /* @__PURE__ */ p(
      gy,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...s,
        ...r,
        ref: t,
        onCloseAutoFocus: $(e.onCloseAutoFocus, (i) => {
          a.current || o.triggerRef.current?.focus(), a.current = !1, i.preventDefault();
        }),
        onInteractOutside: $(e.onInteractOutside, (i) => {
          const u = i.detail.originalEvent, l = u.button === 0 && u.ctrlKey === !0, d = u.button === 2 || l;
          (!o.modal || d) && (a.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Il.displayName = Al;
var Oy = "DropdownMenuGroup", Ol = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ke(n);
    return /* @__PURE__ */ p(vy, { ...o, ...r, ref: t });
  }
);
Ol.displayName = Oy;
var Py = "DropdownMenuLabel", Pl = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ke(n);
    return /* @__PURE__ */ p(yy, { ...o, ...r, ref: t });
  }
);
Pl.displayName = Py;
var My = "DropdownMenuItem", Ml = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ke(n);
    return /* @__PURE__ */ p(by, { ...o, ...r, ref: t });
  }
);
Ml.displayName = My;
var Dy = "DropdownMenuCheckboxItem", Dl = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ke(n);
  return /* @__PURE__ */ p(wy, { ...o, ...r, ref: t });
});
Dl.displayName = Dy;
var Ly = "DropdownMenuRadioGroup", Ll = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ke(n);
  return /* @__PURE__ */ p(xy, { ...o, ...r, ref: t });
});
Ll.displayName = Ly;
var Fy = "DropdownMenuRadioItem", Fl = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ke(n);
  return /* @__PURE__ */ p(_y, { ...o, ...r, ref: t });
});
Fl.displayName = Fy;
var $y = "DropdownMenuItemIndicator", $l = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ke(n);
  return /* @__PURE__ */ p(Sy, { ...o, ...r, ref: t });
});
$l.displayName = $y;
var jy = "DropdownMenuSeparator", jl = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ke(n);
  return /* @__PURE__ */ p(Cy, { ...o, ...r, ref: t });
});
jl.displayName = jy;
var Vy = "DropdownMenuArrow", By = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ke(n);
    return /* @__PURE__ */ p(Ey, { ...o, ...r, ref: t });
  }
);
By.displayName = Vy;
var Uy = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: s } = e, a = ke(t), [i, u] = Bt({
    prop: r,
    defaultProp: s ?? !1,
    onChange: o,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ p(Ry, { ...a, open: i, onOpenChange: u, children: n });
}, zy = "DropdownMenuSubTrigger", Vl = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ke(n);
  return /* @__PURE__ */ p(Ty, { ...o, ...r, ref: t });
});
Vl.displayName = zy;
var Wy = "DropdownMenuSubContent", Bl = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ke(n);
  return /* @__PURE__ */ p(
    Ny,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Bl.displayName = Wy;
var Hy = Rl, Ky = Nl, Ul = kl, zl = Il, Zy = Ol, Wl = Pl, Hl = Ml, Kl = Dl, Gy = Ll, Zl = Fl, Gl = $l, ql = jl, qy = Uy, Yl = Vl, Ql = Bl;
const Ux = Hy, zx = Ky, Wx = Zy, Hx = Ul, Kx = qy, Zx = Gy, Yy = c.forwardRef(({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ ve(
  Yl,
  {
    ref: o,
    className: U(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ p(Mm, { className: "ml-auto h-4 w-4" })
    ]
  }
));
Yy.displayName = Yl.displayName;
const Qy = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Ql,
  {
    ref: n,
    className: U(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
Qy.displayName = Ql.displayName;
const Xy = c.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ p(Ul, { children: /* @__PURE__ */ p(
  zl,
  {
    ref: r,
    sideOffset: t,
    className: U(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
Xy.displayName = zl.displayName;
const Jy = c.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ p(
  Hl,
  {
    ref: r,
    className: U(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t && "pl-8",
      e
    ),
    ...n
  }
));
Jy.displayName = Hl.displayName;
const eb = c.forwardRef(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ ve(
  Kl,
  {
    ref: o,
    className: U(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ p("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ p(Gl, { children: /* @__PURE__ */ p(wc, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
eb.displayName = Kl.displayName;
const tb = c.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ ve(
  Zl,
  {
    ref: r,
    className: U(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ p("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ p(Gl, { children: /* @__PURE__ */ p(Lm, { className: "h-2 w-2 fill-current" }) }) }),
      t
    ]
  }
));
tb.displayName = Zl.displayName;
const nb = c.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ p(
  Wl,
  {
    ref: r,
    className: U(
      "px-2 py-1.5 text-sm font-semibold",
      t && "pl-8",
      e
    ),
    ...n
  }
));
nb.displayName = Wl.displayName;
const rb = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  ql,
  {
    ref: n,
    className: U("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
rb.displayName = ql.displayName;
const ob = ({
  className: e,
  ...t
}) => /* @__PURE__ */ p(
  "span",
  {
    className: U("ml-auto text-xs tracking-widest opacity-60", e),
    ...t
  }
);
ob.displayName = "DropdownMenuShortcut";
const sb = c.forwardRef(
  ({ className: e, type: t, error: n, success: r, ...o }, s) => /* @__PURE__ */ p(
    "input",
    {
      type: t,
      className: U(
        "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        n && "border-destructive focus-visible:ring-destructive",
        r && "border-green-500 focus-visible:ring-green-500",
        e
      ),
      ref: s,
      ...o
    }
  )
);
sb.displayName = "Input";
var ab = "Label", Xl = c.forwardRef((e, t) => /* @__PURE__ */ p(
  Z.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      n.target.closest("button, input, select, textarea") || (e.onMouseDown?.(n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
Xl.displayName = ab;
var Jl = Xl;
const ib = Mr(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), cb = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Jl,
  {
    ref: n,
    className: U(ib(), e),
    ...t
  }
));
cb.displayName = Jl.displayName;
const lb = ge.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ p(
    "div",
    {
      ref: r,
      className: _e(
        "flex flex-col space-y-6 pb-8 border-b border-border/40",
        t
      ),
      ...n,
      children: e
    }
  )
);
lb.displayName = "PageHeader";
const ub = ge.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ p(
    "div",
    {
      ref: r,
      className: _e("flex items-start justify-between", t),
      ...n,
      children: e
    }
  )
);
ub.displayName = "PageHeaderContent";
const db = ge.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ p(
    "h1",
    {
      ref: r,
      className: _e(
        "text-3xl font-semibold tracking-tight text-foreground",
        t
      ),
      ...n,
      children: e
    }
  )
);
db.displayName = "PageHeaderTitle";
const fb = ge.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ p(
    "p",
    {
      ref: r,
      className: _e(
        "text-lg text-muted-foreground mt-2",
        t
      ),
      ...n,
      children: e
    }
  )
);
fb.displayName = "PageHeaderDescription";
const pb = ge.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ p(
    "div",
    {
      ref: r,
      className: _e("flex items-center gap-2", t),
      ...n,
      children: e
    }
  )
);
pb.displayName = "PageHeaderActions";
const hb = ge.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ p(
    "nav",
    {
      ref: r,
      className: _e(
        "flex items-center space-x-1 text-sm text-muted-foreground",
        t
      ),
      ...n,
      children: e
    }
  )
);
hb.displayName = "PageHeaderBreadcrumb";
const mb = ge.forwardRef(
  ({ children: e, variant: t = "secondary", className: n, ...r }, o) => /* @__PURE__ */ p("div", { ref: o, ...r, children: /* @__PURE__ */ p(
    Op,
    {
      variant: t,
      className: _e("ml-3", n),
      children: e
    }
  ) })
);
mb.displayName = "PageHeaderBadge";
function Xa(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function gb(e) {
  const t = c.useRef({ value: e, previous: e });
  return c.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var eu = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), vb = "VisuallyHidden", Bs = c.forwardRef(
  (e, t) => /* @__PURE__ */ p(
    Z.span,
    {
      ...e,
      ref: t,
      style: { ...eu, ...e.style }
    }
  )
);
Bs.displayName = vb;
var yb = [" ", "Enter", "ArrowUp", "ArrowDown"], bb = [" ", "Enter"], Ht = "Select", [Zr, Gr, wb] = Vr(Ht), [_n, Gx] = lt(Ht, [
  wb,
  Wr
]), qr = Wr(), [xb, It] = _n(Ht), [_b, Sb] = _n(Ht), tu = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: s,
    value: a,
    defaultValue: i,
    onValueChange: u,
    dir: l,
    name: d,
    autoComplete: f,
    disabled: g,
    required: v,
    form: y
  } = e, h = qr(t), [m, b] = c.useState(null), [w, x] = c.useState(null), [_, C] = c.useState(!1), N = _s(l), [E, k] = Bt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: s,
    caller: Ht
  }), [M, F] = Bt({
    prop: a,
    defaultProp: i,
    onChange: u,
    caller: Ht
  }), H = c.useRef(null), L = m ? y || !!m.closest("form") : !0, [J, O] = c.useState(/* @__PURE__ */ new Set()), q = Array.from(J).map((B) => B.props.value).join(";");
  return /* @__PURE__ */ p(Os, { ...h, children: /* @__PURE__ */ ve(
    xb,
    {
      required: v,
      scope: t,
      trigger: m,
      onTriggerChange: b,
      valueNode: w,
      onValueNodeChange: x,
      valueNodeHasChildren: _,
      onValueNodeHasChildrenChange: C,
      contentId: Re(),
      value: M,
      onValueChange: F,
      open: E,
      onOpenChange: k,
      dir: N,
      triggerPointerDownPosRef: H,
      disabled: g,
      children: [
        /* @__PURE__ */ p(Zr.Provider, { scope: t, children: /* @__PURE__ */ p(
          _b,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: c.useCallback((B) => {
              O((Q) => new Set(Q).add(B));
            }, []),
            onNativeOptionRemove: c.useCallback((B) => {
              O((Q) => {
                const j = new Set(Q);
                return j.delete(B), j;
              });
            }, []),
            children: n
          }
        ) }),
        L ? /* @__PURE__ */ ve(
          Ru,
          {
            "aria-hidden": !0,
            required: v,
            tabIndex: -1,
            name: d,
            autoComplete: f,
            value: M,
            onChange: (B) => F(B.target.value),
            disabled: g,
            form: y,
            children: [
              M === void 0 ? /* @__PURE__ */ p("option", { value: "" }) : null,
              Array.from(J)
            ]
          },
          q
        ) : null
      ]
    }
  ) });
};
tu.displayName = Ht;
var nu = "SelectTrigger", ru = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, s = qr(n), a = It(nu, n), i = a.disabled || r, u = he(t, a.onTriggerChange), l = Gr(n), d = c.useRef("touch"), [f, g, v] = Nu((h) => {
      const m = l().filter((x) => !x.disabled), b = m.find((x) => x.value === a.value), w = ku(m, h, b);
      w !== void 0 && a.onValueChange(w.value);
    }), y = (h) => {
      i || (a.onOpenChange(!0), v()), h && (a.triggerPointerDownPosRef.current = {
        x: Math.round(h.pageX),
        y: Math.round(h.pageY)
      });
    };
    return /* @__PURE__ */ p(Hc, { asChild: !0, ...s, children: /* @__PURE__ */ p(
      Z.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: i,
        "data-disabled": i ? "" : void 0,
        "data-placeholder": Tu(a.value) ? "" : void 0,
        ...o,
        ref: u,
        onClick: $(o.onClick, (h) => {
          h.currentTarget.focus(), d.current !== "mouse" && y(h);
        }),
        onPointerDown: $(o.onPointerDown, (h) => {
          d.current = h.pointerType;
          const m = h.target;
          m.hasPointerCapture(h.pointerId) && m.releasePointerCapture(h.pointerId), h.button === 0 && h.ctrlKey === !1 && h.pointerType === "mouse" && (y(h), h.preventDefault());
        }),
        onKeyDown: $(o.onKeyDown, (h) => {
          const m = f.current !== "";
          !(h.ctrlKey || h.altKey || h.metaKey) && h.key.length === 1 && g(h.key), !(m && h.key === " ") && yb.includes(h.key) && (y(), h.preventDefault());
        })
      }
    ) });
  }
);
ru.displayName = nu;
var ou = "SelectValue", su = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: s, placeholder: a = "", ...i } = e, u = It(ou, n), { onValueNodeHasChildrenChange: l } = u, d = s !== void 0, f = he(t, u.onValueNodeChange);
    return Ee(() => {
      l(d);
    }, [l, d]), /* @__PURE__ */ p(
      Z.span,
      {
        ...i,
        ref: f,
        style: { pointerEvents: "none" },
        children: Tu(u.value) ? /* @__PURE__ */ p($t, { children: a }) : s
      }
    );
  }
);
su.displayName = ou;
var Cb = "SelectIcon", au = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ p(Z.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
au.displayName = Cb;
var Eb = "SelectPortal", iu = (e) => /* @__PURE__ */ p(Gn, { asChild: !0, ...e });
iu.displayName = Eb;
var Kt = "SelectContent", cu = c.forwardRef(
  (e, t) => {
    const n = It(Kt, e.__scopeSelect), [r, o] = c.useState();
    if (Ee(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const s = r;
      return s ? Hn.createPortal(
        /* @__PURE__ */ p(lu, { scope: e.__scopeSelect, children: /* @__PURE__ */ p(Zr.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ p("div", { children: e.children }) }) }),
        s
      ) : null;
    }
    return /* @__PURE__ */ p(uu, { ...e, ref: t });
  }
);
cu.displayName = Kt;
var Be = 10, [lu, Ot] = _n(Kt), Rb = "SelectContentImpl", Tb = /* @__PURE__ */ Vt("SelectContent.RemoveScroll"), uu = c.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: s,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: i,
      sideOffset: u,
      align: l,
      alignOffset: d,
      arrowPadding: f,
      collisionBoundary: g,
      collisionPadding: v,
      sticky: y,
      hideWhenDetached: h,
      avoidCollisions: m,
      //
      ...b
    } = e, w = It(Kt, n), [x, _] = c.useState(null), [C, N] = c.useState(null), E = he(t, (I) => _(I)), [k, M] = c.useState(null), [F, H] = c.useState(
      null
    ), L = Gr(n), [J, O] = c.useState(!1), q = c.useRef(!1);
    c.useEffect(() => {
      if (x) return ms(x);
    }, [x]), hs();
    const B = c.useCallback(
      (I) => {
        const [re, ...ce] = L().map((Se) => Se.ref.current), [ue] = ce.slice(-1), we = document.activeElement;
        for (const Se of I)
          if (Se === we || (Se?.scrollIntoView({ block: "nearest" }), Se === re && C && (C.scrollTop = 0), Se === ue && C && (C.scrollTop = C.scrollHeight), Se?.focus(), document.activeElement !== we)) return;
      },
      [L, C]
    ), Q = c.useCallback(
      () => B([k, x]),
      [B, k, x]
    );
    c.useEffect(() => {
      J && Q();
    }, [J, Q]);
    const { onOpenChange: j, triggerPointerDownPosRef: P } = w;
    c.useEffect(() => {
      if (x) {
        let I = { x: 0, y: 0 };
        const re = (ue) => {
          I = {
            x: Math.abs(Math.round(ue.pageX) - (P.current?.x ?? 0)),
            y: Math.abs(Math.round(ue.pageY) - (P.current?.y ?? 0))
          };
        }, ce = (ue) => {
          I.x <= 10 && I.y <= 10 ? ue.preventDefault() : x.contains(ue.target) || j(!1), document.removeEventListener("pointermove", re), P.current = null;
        };
        return P.current !== null && (document.addEventListener("pointermove", re), document.addEventListener("pointerup", ce, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", re), document.removeEventListener("pointerup", ce, { capture: !0 });
        };
      }
    }, [x, j, P]), c.useEffect(() => {
      const I = () => j(!1);
      return window.addEventListener("blur", I), window.addEventListener("resize", I), () => {
        window.removeEventListener("blur", I), window.removeEventListener("resize", I);
      };
    }, [j]);
    const [fe, le] = Nu((I) => {
      const re = L().filter((we) => !we.disabled), ce = re.find((we) => we.ref.current === document.activeElement), ue = ku(re, I, ce);
      ue && setTimeout(() => ue.ref.current.focus());
    }), R = c.useCallback(
      (I, re, ce) => {
        const ue = !q.current && !ce;
        (w.value !== void 0 && w.value === re || ue) && (M(I), ue && (q.current = !0));
      },
      [w.value]
    ), K = c.useCallback(() => x?.focus(), [x]), G = c.useCallback(
      (I, re, ce) => {
        const ue = !q.current && !ce;
        (w.value !== void 0 && w.value === re || ue) && H(I);
      },
      [w.value]
    ), z = r === "popper" ? Xo : du, ee = z === Xo ? {
      side: i,
      sideOffset: u,
      align: l,
      alignOffset: d,
      arrowPadding: f,
      collisionBoundary: g,
      collisionPadding: v,
      sticky: y,
      hideWhenDetached: h,
      avoidCollisions: m
    } : {};
    return /* @__PURE__ */ p(
      lu,
      {
        scope: n,
        content: x,
        viewport: C,
        onViewportChange: N,
        itemRefCallback: R,
        selectedItem: k,
        onItemLeave: K,
        itemTextRefCallback: G,
        focusSelectedItem: Q,
        selectedItemText: F,
        position: r,
        isPositioned: J,
        searchRef: fe,
        children: /* @__PURE__ */ p(Fr, { as: Tb, allowPinchZoom: !0, children: /* @__PURE__ */ p(
          Dr,
          {
            asChild: !0,
            trapped: w.open,
            onMountAutoFocus: (I) => {
              I.preventDefault();
            },
            onUnmountAutoFocus: $(o, (I) => {
              w.trigger?.focus({ preventScroll: !0 }), I.preventDefault();
            }),
            children: /* @__PURE__ */ p(
              Zn,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: s,
                onPointerDownOutside: a,
                onFocusOutside: (I) => I.preventDefault(),
                onDismiss: () => w.onOpenChange(!1),
                children: /* @__PURE__ */ p(
                  z,
                  {
                    role: "listbox",
                    id: w.contentId,
                    "data-state": w.open ? "open" : "closed",
                    dir: w.dir,
                    onContextMenu: (I) => I.preventDefault(),
                    ...b,
                    ...ee,
                    onPlaced: () => O(!0),
                    ref: E,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...b.style
                    },
                    onKeyDown: $(b.onKeyDown, (I) => {
                      const re = I.ctrlKey || I.altKey || I.metaKey;
                      if (I.key === "Tab" && I.preventDefault(), !re && I.key.length === 1 && le(I.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(I.key)) {
                        let ue = L().filter((we) => !we.disabled).map((we) => we.ref.current);
                        if (["ArrowUp", "End"].includes(I.key) && (ue = ue.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(I.key)) {
                          const we = I.target, Se = ue.indexOf(we);
                          ue = ue.slice(Se + 1);
                        }
                        setTimeout(() => B(ue)), I.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
uu.displayName = Rb;
var Nb = "SelectItemAlignedPosition", du = c.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, s = It(Kt, n), a = Ot(Kt, n), [i, u] = c.useState(null), [l, d] = c.useState(null), f = he(t, (E) => d(E)), g = Gr(n), v = c.useRef(!1), y = c.useRef(!0), { viewport: h, selectedItem: m, selectedItemText: b, focusSelectedItem: w } = a, x = c.useCallback(() => {
    if (s.trigger && s.valueNode && i && l && h && m && b) {
      const E = s.trigger.getBoundingClientRect(), k = l.getBoundingClientRect(), M = s.valueNode.getBoundingClientRect(), F = b.getBoundingClientRect();
      if (s.dir !== "rtl") {
        const we = F.left - k.left, Se = M.left - we, $e = E.left - Se, Pt = E.width + $e, Qr = Math.max(Pt, k.width), Xr = window.innerWidth - Be, Jr = Xa(Se, [
          Be,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Be, Xr - Qr)
        ]);
        i.style.minWidth = Pt + "px", i.style.left = Jr + "px";
      } else {
        const we = k.right - F.right, Se = window.innerWidth - M.right - we, $e = window.innerWidth - E.right - Se, Pt = E.width + $e, Qr = Math.max(Pt, k.width), Xr = window.innerWidth - Be, Jr = Xa(Se, [
          Be,
          Math.max(Be, Xr - Qr)
        ]);
        i.style.minWidth = Pt + "px", i.style.right = Jr + "px";
      }
      const H = g(), L = window.innerHeight - Be * 2, J = h.scrollHeight, O = window.getComputedStyle(l), q = parseInt(O.borderTopWidth, 10), B = parseInt(O.paddingTop, 10), Q = parseInt(O.borderBottomWidth, 10), j = parseInt(O.paddingBottom, 10), P = q + B + J + j + Q, fe = Math.min(m.offsetHeight * 5, P), le = window.getComputedStyle(h), R = parseInt(le.paddingTop, 10), K = parseInt(le.paddingBottom, 10), G = E.top + E.height / 2 - Be, z = L - G, ee = m.offsetHeight / 2, I = m.offsetTop + ee, re = q + B + I, ce = P - re;
      if (re <= G) {
        const we = H.length > 0 && m === H[H.length - 1].ref.current;
        i.style.bottom = "0px";
        const Se = l.clientHeight - h.offsetTop - h.offsetHeight, $e = Math.max(
          z,
          ee + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (we ? K : 0) + Se + Q
        ), Pt = re + $e;
        i.style.height = Pt + "px";
      } else {
        const we = H.length > 0 && m === H[0].ref.current;
        i.style.top = "0px";
        const $e = Math.max(
          G,
          q + h.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (we ? R : 0) + ee
        ) + ce;
        i.style.height = $e + "px", h.scrollTop = re - G + h.offsetTop;
      }
      i.style.margin = `${Be}px 0`, i.style.minHeight = fe + "px", i.style.maxHeight = L + "px", r?.(), requestAnimationFrame(() => v.current = !0);
    }
  }, [
    g,
    s.trigger,
    s.valueNode,
    i,
    l,
    h,
    m,
    b,
    s.dir,
    r
  ]);
  Ee(() => x(), [x]);
  const [_, C] = c.useState();
  Ee(() => {
    l && C(window.getComputedStyle(l).zIndex);
  }, [l]);
  const N = c.useCallback(
    (E) => {
      E && y.current === !0 && (x(), w?.(), y.current = !1);
    },
    [x, w]
  );
  return /* @__PURE__ */ p(
    Ab,
    {
      scope: n,
      contentWrapper: i,
      shouldExpandOnScrollRef: v,
      onScrollButtonChange: N,
      children: /* @__PURE__ */ p(
        "div",
        {
          ref: u,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: _
          },
          children: /* @__PURE__ */ p(
            Z.div,
            {
              ...o,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
du.displayName = Nb;
var kb = "SelectPopperPosition", Xo = c.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = Be,
    ...s
  } = e, a = qr(n);
  return /* @__PURE__ */ p(
    Kc,
    {
      ...a,
      ...s,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...s.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Xo.displayName = kb;
var [Ab, Us] = _n(Kt, {}), Jo = "SelectViewport", fu = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, s = Ot(Jo, n), a = Us(Jo, n), i = he(t, s.onViewportChange), u = c.useRef(0);
    return /* @__PURE__ */ ve($t, { children: [
      /* @__PURE__ */ p(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ p(Zr.Slot, { scope: n, children: /* @__PURE__ */ p(
        Z.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: i,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: $(o.onScroll, (l) => {
            const d = l.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: g } = a;
            if (g?.current && f) {
              const v = Math.abs(u.current - d.scrollTop);
              if (v > 0) {
                const y = window.innerHeight - Be * 2, h = parseFloat(f.style.minHeight), m = parseFloat(f.style.height), b = Math.max(h, m);
                if (b < y) {
                  const w = b + v, x = Math.min(y, w), _ = w - x;
                  f.style.height = x + "px", f.style.bottom === "0px" && (d.scrollTop = _ > 0 ? _ : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            u.current = d.scrollTop;
          })
        }
      ) })
    ] });
  }
);
fu.displayName = Jo;
var pu = "SelectGroup", [Ib, Ob] = _n(pu), hu = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = Re();
    return /* @__PURE__ */ p(Ib, { scope: n, id: o, children: /* @__PURE__ */ p(Z.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
hu.displayName = pu;
var mu = "SelectLabel", gu = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = Ob(mu, n);
    return /* @__PURE__ */ p(Z.div, { id: o.id, ...r, ref: t });
  }
);
gu.displayName = mu;
var Ar = "SelectItem", [Pb, vu] = _n(Ar), yu = c.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: s,
      ...a
    } = e, i = It(Ar, n), u = Ot(Ar, n), l = i.value === r, [d, f] = c.useState(s ?? ""), [g, v] = c.useState(!1), y = he(
      t,
      (w) => u.itemRefCallback?.(w, r, o)
    ), h = Re(), m = c.useRef("touch"), b = () => {
      o || (i.onValueChange(r), i.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ p(
      Pb,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: h,
        isSelected: l,
        onItemTextChange: c.useCallback((w) => {
          f((x) => x || (w?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ p(
          Zr.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: d,
            children: /* @__PURE__ */ p(
              Z.div,
              {
                role: "option",
                "aria-labelledby": h,
                "data-highlighted": g ? "" : void 0,
                "aria-selected": l && g,
                "data-state": l ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...a,
                ref: y,
                onFocus: $(a.onFocus, () => v(!0)),
                onBlur: $(a.onBlur, () => v(!1)),
                onClick: $(a.onClick, () => {
                  m.current !== "mouse" && b();
                }),
                onPointerUp: $(a.onPointerUp, () => {
                  m.current === "mouse" && b();
                }),
                onPointerDown: $(a.onPointerDown, (w) => {
                  m.current = w.pointerType;
                }),
                onPointerMove: $(a.onPointerMove, (w) => {
                  m.current = w.pointerType, o ? u.onItemLeave?.() : m.current === "mouse" && w.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: $(a.onPointerLeave, (w) => {
                  w.currentTarget === document.activeElement && u.onItemLeave?.();
                }),
                onKeyDown: $(a.onKeyDown, (w) => {
                  u.searchRef?.current !== "" && w.key === " " || (bb.includes(w.key) && b(), w.key === " " && w.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
yu.displayName = Ar;
var kn = "SelectItemText", bu = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...s } = e, a = It(kn, n), i = Ot(kn, n), u = vu(kn, n), l = Sb(kn, n), [d, f] = c.useState(null), g = he(
      t,
      (b) => f(b),
      u.onItemTextChange,
      (b) => i.itemTextRefCallback?.(b, u.value, u.disabled)
    ), v = d?.textContent, y = c.useMemo(
      () => /* @__PURE__ */ p("option", { value: u.value, disabled: u.disabled, children: v }, u.value),
      [u.disabled, u.value, v]
    ), { onNativeOptionAdd: h, onNativeOptionRemove: m } = l;
    return Ee(() => (h(y), () => m(y)), [h, m, y]), /* @__PURE__ */ ve($t, { children: [
      /* @__PURE__ */ p(Z.span, { id: u.textId, ...s, ref: g }),
      u.isSelected && a.valueNode && !a.valueNodeHasChildren ? Hn.createPortal(s.children, a.valueNode) : null
    ] });
  }
);
bu.displayName = kn;
var wu = "SelectItemIndicator", xu = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return vu(wu, n).isSelected ? /* @__PURE__ */ p(Z.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
xu.displayName = wu;
var es = "SelectScrollUpButton", _u = c.forwardRef((e, t) => {
  const n = Ot(es, e.__scopeSelect), r = Us(es, e.__scopeSelect), [o, s] = c.useState(!1), a = he(t, r.onScrollButtonChange);
  return Ee(() => {
    if (n.viewport && n.isPositioned) {
      let i = function() {
        const l = u.scrollTop > 0;
        s(l);
      };
      const u = n.viewport;
      return i(), u.addEventListener("scroll", i), () => u.removeEventListener("scroll", i);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ p(
    Cu,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: i, selectedItem: u } = n;
        i && u && (i.scrollTop = i.scrollTop - u.offsetHeight);
      }
    }
  ) : null;
});
_u.displayName = es;
var ts = "SelectScrollDownButton", Su = c.forwardRef((e, t) => {
  const n = Ot(ts, e.__scopeSelect), r = Us(ts, e.__scopeSelect), [o, s] = c.useState(!1), a = he(t, r.onScrollButtonChange);
  return Ee(() => {
    if (n.viewport && n.isPositioned) {
      let i = function() {
        const l = u.scrollHeight - u.clientHeight, d = Math.ceil(u.scrollTop) < l;
        s(d);
      };
      const u = n.viewport;
      return i(), u.addEventListener("scroll", i), () => u.removeEventListener("scroll", i);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ p(
    Cu,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: i, selectedItem: u } = n;
        i && u && (i.scrollTop = i.scrollTop + u.offsetHeight);
      }
    }
  ) : null;
});
Su.displayName = ts;
var Cu = c.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, s = Ot("SelectScrollButton", n), a = c.useRef(null), i = Gr(n), u = c.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return c.useEffect(() => () => u(), [u]), Ee(() => {
    i().find((d) => d.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [i]), /* @__PURE__ */ p(
    Z.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: $(o.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerMove: $(o.onPointerMove, () => {
        s.onItemLeave?.(), a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerLeave: $(o.onPointerLeave, () => {
        u();
      })
    }
  );
}), Mb = "SelectSeparator", Eu = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ p(Z.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
Eu.displayName = Mb;
var ns = "SelectArrow", Db = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = qr(n), s = It(ns, n), a = Ot(ns, n);
    return s.open && a.position === "popper" ? /* @__PURE__ */ p(Zc, { ...o, ...r, ref: t }) : null;
  }
);
Db.displayName = ns;
var Lb = "SelectBubbleInput", Ru = c.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, r) => {
    const o = c.useRef(null), s = he(r, o), a = gb(t);
    return c.useEffect(() => {
      const i = o.current;
      if (!i) return;
      const u = window.HTMLSelectElement.prototype, d = Object.getOwnPropertyDescriptor(
        u,
        "value"
      ).set;
      if (a !== t && d) {
        const f = new Event("change", { bubbles: !0 });
        d.call(i, t), i.dispatchEvent(f);
      }
    }, [a, t]), /* @__PURE__ */ p(
      Z.select,
      {
        ...n,
        style: { ...eu, ...n.style },
        ref: s,
        defaultValue: t
      }
    );
  }
);
Ru.displayName = Lb;
function Tu(e) {
  return e === "" || e === void 0;
}
function Nu(e) {
  const t = Ne(e), n = c.useRef(""), r = c.useRef(0), o = c.useCallback(
    (a) => {
      const i = n.current + a;
      t(i), function u(l) {
        n.current = l, window.clearTimeout(r.current), l !== "" && (r.current = window.setTimeout(() => u(""), 1e3));
      }(i);
    },
    [t]
  ), s = c.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return c.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, s];
}
function ku(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((l) => l === t[0]) ? t[0] : t, s = n ? e.indexOf(n) : -1;
  let a = Fb(e, Math.max(s, 0));
  o.length === 1 && (a = a.filter((l) => l !== n));
  const u = a.find(
    (l) => l.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return u !== n ? u : void 0;
}
function Fb(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var $b = tu, Au = ru, jb = su, Vb = au, Bb = iu, Iu = cu, Ub = fu, zb = hu, Ou = gu, Pu = yu, Wb = bu, Hb = xu, Mu = _u, Du = Su, Lu = Eu;
const qx = $b, Yx = zb, Qx = jb, Kb = c.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ ve(
  Au,
  {
    ref: r,
    className: U(
      "flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ p(Vb, { asChild: !0, children: /* @__PURE__ */ p(xc, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
Kb.displayName = Au.displayName;
const Fu = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Mu,
  {
    ref: n,
    className: U(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ p(Dm, { className: "h-4 w-4" })
  }
));
Fu.displayName = Mu.displayName;
const $u = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Du,
  {
    ref: n,
    className: U(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ p(xc, { className: "h-4 w-4" })
  }
));
$u.displayName = Du.displayName;
const Zb = c.forwardRef(({ className: e, children: t, position: n = "popper", ...r }, o) => /* @__PURE__ */ p(Bb, { children: /* @__PURE__ */ ve(
  Iu,
  {
    ref: o,
    className: U(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...r,
    children: [
      /* @__PURE__ */ p(Fu, {}),
      /* @__PURE__ */ p(
        Ub,
        {
          className: U(
            "p-1",
            n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ p($u, {})
    ]
  }
) }));
Zb.displayName = Iu.displayName;
const Gb = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Ou,
  {
    ref: n,
    className: U("py-1.5 pl-8 pr-2 text-sm font-semibold", e),
    ...t
  }
));
Gb.displayName = Ou.displayName;
const qb = c.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ ve(
  Pu,
  {
    ref: r,
    className: U(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ p("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ p(Hb, { children: /* @__PURE__ */ p(wc, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ p(Wb, { children: t })
    ]
  }
));
qb.displayName = Pu.displayName;
const Yb = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Lu,
  {
    ref: n,
    className: U("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
Yb.displayName = Lu.displayName;
var Qb = "Separator", Ja = "horizontal", Xb = ["horizontal", "vertical"], ju = c.forwardRef((e, t) => {
  const { decorative: n, orientation: r = Ja, ...o } = e, s = Jb(r) ? r : Ja, i = n ? { role: "none" } : { "aria-orientation": s === "vertical" ? s : void 0, role: "separator" };
  return /* @__PURE__ */ p(
    Z.div,
    {
      "data-orientation": s,
      ...i,
      ...o,
      ref: t
    }
  );
});
ju.displayName = Qb;
function Jb(e) {
  return Xb.includes(e);
}
var Vu = ju;
const ew = c.forwardRef(
  ({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }, o) => /* @__PURE__ */ p(
    Vu,
    {
      ref: o,
      decorative: n,
      orientation: t,
      className: U(
        "shrink-0 bg-border",
        t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        e
      ),
      ...r
    }
  )
);
ew.displayName = Vu.displayName;
const tw = ge.forwardRef(
  ({ status: e, size: t = "md", showDot: n = !0, children: r, className: o, ...s }, a) => {
    const i = {
      success: "text-green-700 bg-green-50 border-green-200 dark:text-green-400 dark:bg-green-950/20 dark:border-green-800/30",
      warning: "text-amber-700 bg-amber-50 border-amber-200 dark:text-amber-400 dark:bg-amber-950/20 dark:border-amber-800/30",
      error: "text-red-700 bg-red-50 border-red-200 dark:text-red-400 dark:bg-red-950/20 dark:border-red-800/30",
      info: "text-blue-700 bg-blue-50 border-blue-200 dark:text-blue-400 dark:bg-blue-950/20 dark:border-blue-800/30",
      default: "text-muted-foreground bg-muted border-border"
    }, u = {
      success: "bg-green-500",
      warning: "bg-amber-500",
      error: "bg-red-500",
      info: "bg-blue-500",
      default: "bg-muted-foreground"
    }, l = {
      sm: "px-2 py-1 text-xs",
      md: "px-3 py-1.5 text-sm",
      lg: "px-4 py-2 text-base"
    }, d = {
      sm: "w-1.5 h-1.5",
      md: "w-2 h-2",
      lg: "w-2.5 h-2.5"
    };
    return /* @__PURE__ */ ve(
      "div",
      {
        ref: a,
        className: _e(
          "inline-flex items-center gap-2 rounded-full border font-medium",
          i[e],
          l[t],
          o
        ),
        ...s,
        children: [
          n && /* @__PURE__ */ p("div", { className: _e(
            "rounded-full",
            u[e],
            d[t]
          ) }),
          r
        ]
      }
    );
  }
);
tw.displayName = "StatusIndicator";
const nw = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ p(
  "table",
  {
    ref: n,
    className: U("w-full caption-bottom text-sm", e),
    ...t
  }
) }));
nw.displayName = "Table";
const rw = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p("thead", { ref: n, className: U("[&_tr]:border-b", e), ...t }));
rw.displayName = "TableHeader";
const ow = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "tbody",
  {
    ref: n,
    className: U("[&_tr:last-child]:border-0", e),
    ...t
  }
));
ow.displayName = "TableBody";
const sw = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "tfoot",
  {
    ref: n,
    className: U("border-t bg-muted/50 font-medium [&>tr]:last:border-b-0", e),
    ...t
  }
));
sw.displayName = "TableFooter";
const aw = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "tr",
  {
    ref: n,
    className: U(
      "border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted",
      e
    ),
    ...t
  }
));
aw.displayName = "TableRow";
const iw = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "th",
  {
    ref: n,
    className: U(
      "h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0",
      e
    ),
    ...t
  }
));
iw.displayName = "TableHead";
const cw = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "td",
  {
    ref: n,
    className: U("p-4 align-middle [&:has([role=checkbox])]:pr-0", e),
    ...t
  }
));
cw.displayName = "TableCell";
const lw = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "caption",
  {
    ref: n,
    className: U("mt-4 text-sm text-muted-foreground", e),
    ...t
  }
));
lw.displayName = "TableCaption";
const uw = c.forwardRef(
  ({ className: e, error: t, success: n, ...r }, o) => /* @__PURE__ */ p(
    "textarea",
    {
      className: U(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        t && "border-destructive focus-visible:ring-destructive",
        n && "border-green-500 focus-visible:ring-green-500",
        e
      ),
      ref: o,
      ...r
    }
  )
);
uw.displayName = "Textarea";
var zs = "ToastProvider", [Ws, dw, fw] = Vr("Toast"), [Bu, Xx] = lt("Toast", [fw]), [pw, Yr] = Bu(zs), Uu = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: s = 50,
    children: a
  } = e, [i, u] = c.useState(null), [l, d] = c.useState(0), f = c.useRef(!1), g = c.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${zs}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ p(Ws.Provider, { scope: t, children: /* @__PURE__ */ p(
    pw,
    {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: o,
      swipeThreshold: s,
      toastCount: l,
      viewport: i,
      onViewportChange: u,
      onToastAdd: c.useCallback(() => d((v) => v + 1), []),
      onToastRemove: c.useCallback(() => d((v) => v - 1), []),
      isFocusedToastEscapeKeyDownRef: f,
      isClosePausedRef: g,
      children: a
    }
  ) });
};
Uu.displayName = zs;
var zu = "ToastViewport", hw = ["F8"], rs = "toast.viewportPause", os = "toast.viewportResume", Wu = c.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: r = hw,
      label: o = "Notifications ({hotkey})",
      ...s
    } = e, a = Yr(zu, n), i = dw(n), u = c.useRef(null), l = c.useRef(null), d = c.useRef(null), f = c.useRef(null), g = he(t, f, a.onViewportChange), v = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), y = a.toastCount > 0;
    c.useEffect(() => {
      const m = (b) => {
        r.length !== 0 && r.every((x) => b[x] || b.code === x) && f.current?.focus();
      };
      return document.addEventListener("keydown", m), () => document.removeEventListener("keydown", m);
    }, [r]), c.useEffect(() => {
      const m = u.current, b = f.current;
      if (y && m && b) {
        const w = () => {
          if (!a.isClosePausedRef.current) {
            const N = new CustomEvent(rs);
            b.dispatchEvent(N), a.isClosePausedRef.current = !0;
          }
        }, x = () => {
          if (a.isClosePausedRef.current) {
            const N = new CustomEvent(os);
            b.dispatchEvent(N), a.isClosePausedRef.current = !1;
          }
        }, _ = (N) => {
          !m.contains(N.relatedTarget) && x();
        }, C = () => {
          m.contains(document.activeElement) || x();
        };
        return m.addEventListener("focusin", w), m.addEventListener("focusout", _), m.addEventListener("pointermove", w), m.addEventListener("pointerleave", C), window.addEventListener("blur", w), window.addEventListener("focus", x), () => {
          m.removeEventListener("focusin", w), m.removeEventListener("focusout", _), m.removeEventListener("pointermove", w), m.removeEventListener("pointerleave", C), window.removeEventListener("blur", w), window.removeEventListener("focus", x);
        };
      }
    }, [y, a.isClosePausedRef]);
    const h = c.useCallback(
      ({ tabbingDirection: m }) => {
        const w = i().map((x) => {
          const _ = x.ref.current, C = [_, ...Tw(_)];
          return m === "forwards" ? C : C.reverse();
        });
        return (m === "forwards" ? w.reverse() : w).flat();
      },
      [i]
    );
    return c.useEffect(() => {
      const m = f.current;
      if (m) {
        const b = (w) => {
          const x = w.altKey || w.ctrlKey || w.metaKey;
          if (w.key === "Tab" && !x) {
            const C = document.activeElement, N = w.shiftKey;
            if (w.target === m && N) {
              l.current?.focus();
              return;
            }
            const M = h({ tabbingDirection: N ? "backwards" : "forwards" }), F = M.findIndex((H) => H === C);
            wo(M.slice(F + 1)) ? w.preventDefault() : N ? l.current?.focus() : d.current?.focus();
          }
        };
        return m.addEventListener("keydown", b), () => m.removeEventListener("keydown", b);
      }
    }, [i, h]), /* @__PURE__ */ ve(
      lh,
      {
        ref: u,
        role: "region",
        "aria-label": o.replace("{hotkey}", v),
        tabIndex: -1,
        style: { pointerEvents: y ? void 0 : "none" },
        children: [
          y && /* @__PURE__ */ p(
            ss,
            {
              ref: l,
              onFocusFromOutsideViewport: () => {
                const m = h({
                  tabbingDirection: "forwards"
                });
                wo(m);
              }
            }
          ),
          /* @__PURE__ */ p(Ws.Slot, { scope: n, children: /* @__PURE__ */ p(Z.ol, { tabIndex: -1, ...s, ref: g }) }),
          y && /* @__PURE__ */ p(
            ss,
            {
              ref: d,
              onFocusFromOutsideViewport: () => {
                const m = h({
                  tabbingDirection: "backwards"
                });
                wo(m);
              }
            }
          )
        ]
      }
    );
  }
);
Wu.displayName = zu;
var Hu = "ToastFocusProxy", ss = c.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...o } = e, s = Yr(Hu, n);
    return /* @__PURE__ */ p(
      Bs,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (a) => {
          const i = a.relatedTarget;
          !s.viewport?.contains(i) && r();
        }
      }
    );
  }
);
ss.displayName = Hu;
var tr = "Toast", mw = "toast.swipeStart", gw = "toast.swipeMove", vw = "toast.swipeCancel", yw = "toast.swipeEnd", Ku = c.forwardRef(
  (e, t) => {
    const { forceMount: n, open: r, defaultOpen: o, onOpenChange: s, ...a } = e, [i, u] = Bt({
      prop: r,
      defaultProp: o ?? !0,
      onChange: s,
      caller: tr
    });
    return /* @__PURE__ */ p(ut, { present: n || i, children: /* @__PURE__ */ p(
      xw,
      {
        open: i,
        ...a,
        ref: t,
        onClose: () => u(!1),
        onPause: Ne(e.onPause),
        onResume: Ne(e.onResume),
        onSwipeStart: $(e.onSwipeStart, (l) => {
          l.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: $(e.onSwipeMove, (l) => {
          const { x: d, y: f } = l.detail.delta;
          l.currentTarget.setAttribute("data-swipe", "move"), l.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${d}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${f}px`);
        }),
        onSwipeCancel: $(e.onSwipeCancel, (l) => {
          l.currentTarget.setAttribute("data-swipe", "cancel"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: $(e.onSwipeEnd, (l) => {
          const { x: d, y: f } = l.detail.delta;
          l.currentTarget.setAttribute("data-swipe", "end"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${d}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${f}px`), u(!1);
        })
      }
    ) });
  }
);
Ku.displayName = tr;
var [bw, ww] = Bu(tr, {
  onClose() {
  }
}), xw = c.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: o,
      open: s,
      onClose: a,
      onEscapeKeyDown: i,
      onPause: u,
      onResume: l,
      onSwipeStart: d,
      onSwipeMove: f,
      onSwipeCancel: g,
      onSwipeEnd: v,
      ...y
    } = e, h = Yr(tr, n), [m, b] = c.useState(null), w = he(t, (O) => b(O)), x = c.useRef(null), _ = c.useRef(null), C = o || h.duration, N = c.useRef(0), E = c.useRef(C), k = c.useRef(0), { onToastAdd: M, onToastRemove: F } = h, H = Ne(() => {
      m?.contains(document.activeElement) && h.viewport?.focus(), a();
    }), L = c.useCallback(
      (O) => {
        !O || O === 1 / 0 || (window.clearTimeout(k.current), N.current = (/* @__PURE__ */ new Date()).getTime(), k.current = window.setTimeout(H, O));
      },
      [H]
    );
    c.useEffect(() => {
      const O = h.viewport;
      if (O) {
        const q = () => {
          L(E.current), l?.();
        }, B = () => {
          const Q = (/* @__PURE__ */ new Date()).getTime() - N.current;
          E.current = E.current - Q, window.clearTimeout(k.current), u?.();
        };
        return O.addEventListener(rs, B), O.addEventListener(os, q), () => {
          O.removeEventListener(rs, B), O.removeEventListener(os, q);
        };
      }
    }, [h.viewport, C, u, l, L]), c.useEffect(() => {
      s && !h.isClosePausedRef.current && L(C);
    }, [s, C, h.isClosePausedRef, L]), c.useEffect(() => (M(), () => F()), [M, F]);
    const J = c.useMemo(() => m ? Ju(m) : null, [m]);
    return h.viewport ? /* @__PURE__ */ ve($t, { children: [
      J && /* @__PURE__ */ p(
        _w,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: J
        }
      ),
      /* @__PURE__ */ p(bw, { scope: n, onClose: H, children: Hn.createPortal(
        /* @__PURE__ */ p(Ws.ItemSlot, { scope: n, children: /* @__PURE__ */ p(
          ch,
          {
            asChild: !0,
            onEscapeKeyDown: $(i, () => {
              h.isFocusedToastEscapeKeyDownRef.current || H(), h.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ p(
              Z.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": s ? "open" : "closed",
                "data-swipe-direction": h.swipeDirection,
                ...y,
                ref: w,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: $(e.onKeyDown, (O) => {
                  O.key === "Escape" && (i?.(O.nativeEvent), O.nativeEvent.defaultPrevented || (h.isFocusedToastEscapeKeyDownRef.current = !0, H()));
                }),
                onPointerDown: $(e.onPointerDown, (O) => {
                  O.button === 0 && (x.current = { x: O.clientX, y: O.clientY });
                }),
                onPointerMove: $(e.onPointerMove, (O) => {
                  if (!x.current) return;
                  const q = O.clientX - x.current.x, B = O.clientY - x.current.y, Q = !!_.current, j = ["left", "right"].includes(h.swipeDirection), P = ["left", "up"].includes(h.swipeDirection) ? Math.min : Math.max, fe = j ? P(0, q) : 0, le = j ? 0 : P(0, B), R = O.pointerType === "touch" ? 10 : 2, K = { x: fe, y: le }, G = { originalEvent: O, delta: K };
                  Q ? (_.current = K, cr(gw, f, G, {
                    discrete: !1
                  })) : ei(K, h.swipeDirection, R) ? (_.current = K, cr(mw, d, G, {
                    discrete: !1
                  }), O.target.setPointerCapture(O.pointerId)) : (Math.abs(q) > R || Math.abs(B) > R) && (x.current = null);
                }),
                onPointerUp: $(e.onPointerUp, (O) => {
                  const q = _.current, B = O.target;
                  if (B.hasPointerCapture(O.pointerId) && B.releasePointerCapture(O.pointerId), _.current = null, x.current = null, q) {
                    const Q = O.currentTarget, j = { originalEvent: O, delta: q };
                    ei(q, h.swipeDirection, h.swipeThreshold) ? cr(yw, v, j, {
                      discrete: !0
                    }) : cr(
                      vw,
                      g,
                      j,
                      {
                        discrete: !0
                      }
                    ), Q.addEventListener("click", (P) => P.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        h.viewport
      ) })
    ] }) : null;
  }
), _w = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, o = Yr(tr, t), [s, a] = c.useState(!1), [i, u] = c.useState(!1);
  return Ew(() => a(!0)), c.useEffect(() => {
    const l = window.setTimeout(() => u(!0), 1e3);
    return () => window.clearTimeout(l);
  }, []), i ? null : /* @__PURE__ */ p(Gn, { asChild: !0, children: /* @__PURE__ */ p(Bs, { ...r, children: s && /* @__PURE__ */ ve($t, { children: [
    o.label,
    " ",
    n
  ] }) }) });
}, Sw = "ToastTitle", Zu = c.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ p(Z.div, { ...r, ref: t });
  }
);
Zu.displayName = Sw;
var Cw = "ToastDescription", Gu = c.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ p(Z.div, { ...r, ref: t });
  }
);
Gu.displayName = Cw;
var qu = "ToastAction", Yu = c.forwardRef(
  (e, t) => {
    const { altText: n, ...r } = e;
    return n.trim() ? /* @__PURE__ */ p(Xu, { altText: n, asChild: !0, children: /* @__PURE__ */ p(Hs, { ...r, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${qu}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
Yu.displayName = qu;
var Qu = "ToastClose", Hs = c.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e, o = ww(Qu, n);
    return /* @__PURE__ */ p(Xu, { asChild: !0, children: /* @__PURE__ */ p(
      Z.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: $(e.onClick, o.onClose)
      }
    ) });
  }
);
Hs.displayName = Qu;
var Xu = c.forwardRef((e, t) => {
  const { __scopeToast: n, altText: r, ...o } = e;
  return /* @__PURE__ */ p(
    Z.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...o,
      ref: t
    }
  );
});
function Ju(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), Rw(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", s = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (s) {
          const a = r.dataset.radixToastAnnounceAlt;
          a && t.push(a);
        } else
          t.push(...Ju(r));
    }
  }), t;
}
function cr(e, t, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, s = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? fs(o, s) : o.dispatchEvent(s);
}
var ei = (e, t, n = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), s = r > o;
  return t === "left" || t === "right" ? s && r > n : !s && o > n;
};
function Ew(e = () => {
}) {
  const t = Ne(e);
  Ee(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function Rw(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function Tw(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function wo(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var Nw = Uu, ed = Wu, td = Ku, nd = Zu, rd = Gu, od = Yu, sd = Hs;
const kw = Nw, ad = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  ed,
  {
    ref: n,
    className: U(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      e
    ),
    ...t
  }
));
ad.displayName = ed.displayName;
const Aw = Mr(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground",
        success: "border-success bg-success text-success-foreground",
        warning: "border-warning bg-warning text-warning-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), id = c.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ p(
  td,
  {
    ref: r,
    className: U(Aw({ variant: t }), e),
    ...n
  }
));
id.displayName = td.displayName;
const Iw = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  od,
  {
    ref: n,
    className: U(
      "inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive",
      e
    ),
    ...t
  }
));
Iw.displayName = od.displayName;
const cd = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  sd,
  {
    ref: n,
    className: U(
      "absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ p(_c, { className: "h-4 w-4" })
  }
));
cd.displayName = sd.displayName;
const ld = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  nd,
  {
    ref: n,
    className: U("text-sm font-semibold", e),
    ...t
  }
));
ld.displayName = nd.displayName;
const ud = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  rd,
  {
    ref: n,
    className: U("text-sm opacity-90", e),
    ...t
  }
));
ud.displayName = rd.displayName;
const Ow = 1, Pw = 1e6;
let xo = 0;
function Mw() {
  return xo = (xo + 1) % Number.MAX_SAFE_INTEGER, xo.toString();
}
const _o = /* @__PURE__ */ new Map(), ti = (e) => {
  if (_o.has(e))
    return;
  const t = setTimeout(() => {
    _o.delete(e), Pn({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, Pw);
  _o.set(e, t);
}, Dw = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, Ow)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map(
          (n) => n.id === t.toast.id ? { ...n, ...t.toast } : n
        )
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return n ? ti(n) : e.toasts.forEach((r) => {
        ti(r.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, pr = [];
let hr = { toasts: [] };
function Pn(e) {
  hr = Dw(hr, e), pr.forEach((t) => {
    t(hr);
  });
}
function Lw({ ...e }) {
  const t = Mw(), n = (o) => Pn({
    type: "UPDATE_TOAST",
    toast: { ...o, id: t }
  }), r = () => Pn({ type: "DISMISS_TOAST", toastId: t });
  return Pn({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (o) => {
        o || r();
      }
    }
  }), {
    id: t,
    dismiss: r,
    update: n
  };
}
function Fw() {
  const [e, t] = c.useState(hr);
  return c.useEffect(() => (pr.push(t), () => {
    const n = pr.indexOf(t);
    n > -1 && pr.splice(n, 1);
  }), [e]), {
    ...e,
    toast: Lw,
    dismiss: (n) => Pn({ type: "DISMISS_TOAST", toastId: n })
  };
}
function Jx() {
  const { toasts: e } = Fw();
  return /* @__PURE__ */ ve(kw, { children: [
    e.map(function({ id: t, title: n, description: r, action: o, ...s }) {
      return /* @__PURE__ */ ve(id, { ...s, children: [
        /* @__PURE__ */ ve("div", { className: "grid gap-1", children: [
          n && /* @__PURE__ */ p(ld, { children: n }),
          r && /* @__PURE__ */ p(ud, { children: r })
        ] }),
        o,
        /* @__PURE__ */ p(cd, {})
      ] }, t);
    }),
    /* @__PURE__ */ p(ad, {})
  ] });
}
function e_({
  items: e,
  itemHeight: t,
  containerHeight: n,
  renderItem: r,
  className: o,
  overscan: s = 5,
  onScroll: a,
  onLoadMore: i,
  hasMore: u = !1,
  loading: l = !1,
  loadingComponent: d,
  emptyComponent: f,
  estimatedItemHeight: g
}) {
  const [v, y] = St(0), h = Zs(null), m = Zs(null), b = 200, w = to(() => {
    const k = g || t, M = Math.max(0, Math.floor(v / k) - s), F = Math.ceil(n / k), H = Math.min(
      e.length - 1,
      M + F + s * 2
    );
    return { startIndex: M, endIndex: H };
  }, [v, n, t, g, s, e.length]), x = to(() => e.length * (g || t), [e.length, t, g]), _ = to(() => e.slice(w.startIndex, w.endIndex + 1), [e, w.startIndex, w.endIndex]), C = In((k) => {
    const M = k.currentTarget.scrollTop;
    y(M), h.current && clearTimeout(h.current), h.current = setTimeout(() => {
    }, 150), a?.(M), u && !l && i && k.currentTarget.scrollHeight - k.currentTarget.scrollTop - k.currentTarget.clientHeight < b && i();
  }, [a, i, u, l]);
  An(() => () => {
    h.current && clearTimeout(h.current);
  }, []);
  const N = In(() => {
    m.current && (m.current.scrollTop = 0, y(0));
  }, []), E = In((k) => {
    if (m.current) {
      const F = k * (g || t);
      m.current.scrollTop = F, y(F);
    }
  }, [t, g]);
  return An(() => {
    if (m.current) {
      const k = m.current;
      k.scrollToTop = N, k.scrollToItem = E;
    }
  }, [N, E]), e.length === 0 && !l ? /* @__PURE__ */ p(
    "div",
    {
      className: U("flex items-center justify-center", o),
      style: { height: n },
      children: f || /* @__PURE__ */ p("div", { className: "text-muted-foreground", children: "No items found" })
    }
  ) : /* @__PURE__ */ p(
    "div",
    {
      ref: m,
      className: U("overflow-auto", o),
      style: { height: n },
      onScroll: C,
      role: "grid",
      "aria-rowcount": e.length,
      "aria-label": "Virtualized list",
      children: /* @__PURE__ */ p("div", { style: { height: x, position: "relative" }, children: /* @__PURE__ */ ve(
        "div",
        {
          style: {
            transform: `translateY(${w.startIndex * (g || t)}px)`,
            position: "absolute",
            top: 0,
            left: 0,
            right: 0
          },
          children: [
            _.map((k, M) => {
              const F = w.startIndex + M;
              return /* @__PURE__ */ p(
                "div",
                {
                  style: {
                    height: g || t,
                    overflow: "hidden"
                  },
                  role: "gridcell",
                  "aria-rowindex": F + 1,
                  children: r(k, F)
                },
                F
              );
            }),
            l && u && /* @__PURE__ */ p(
              "div",
              {
                style: { height: 60 },
                className: "flex items-center justify-center border-t",
                children: d || /* @__PURE__ */ ve("div", { className: "flex items-center gap-2 text-sm text-muted-foreground py-4", children: [
                  /* @__PURE__ */ p("div", { className: "animate-spin rounded-full h-4 w-4 border-b-2 border-primary" }),
                  /* @__PURE__ */ p("span", { children: "Loading more..." })
                ] })
              }
            )
          ]
        }
      ) })
    }
  );
}
function t_() {
  const [e, t] = St(!1), [n, r] = St(!1), [o, s] = St(1), a = In(async (u) => {
    if (!e) {
      t(!0);
      try {
        const l = await u(o + 1);
        return s((d) => d + 1), r(l.hasMore), l;
      } catch (l) {
        return console.error("Failed to load more items:", l), { items: [], hasMore: !1 };
      } finally {
        t(!1);
      }
    }
  }, [e, o]), i = In(() => {
    t(!1), r(!1), s(1);
  }, []);
  return {
    loading: e,
    hasMore: n,
    page: o,
    loadMore: a,
    reset: i,
    setHasMore: r
  };
}
export {
  Yd as AgentSchema,
  nf as ApiClientError,
  Xw as ApiErrorSchema,
  Qw as ApiResponseSchema,
  Np as Avatar,
  Ap as AvatarFallback,
  kp as AvatarImage,
  Op as Badge,
  rx as BaseQueryParamsSchema,
  Mp as Button,
  Dp as Card,
  jp as CardContent,
  $p as CardDescription,
  Vp as CardFooter,
  Lp as CardHeader,
  Fp as CardTitle,
  $m as Command,
  Bm as CommandEmpty,
  Um as CommandGroup,
  jm as CommandInput,
  Wm as CommandItem,
  Vm as CommandList,
  zm as CommandSeparator,
  Hm as CommandShortcut,
  nx as CreateMessageRequestSchema,
  ex as CreateTicketRequestSchema,
  tf as CursorInfoSchema,
  qd as CustomerSchema,
  Km as DataCard,
  Ym as DataCardActions,
  qm as DataCardContent,
  Zm as DataCardHeader,
  Gm as DataCardTitle,
  sx as DateRangeParamsSchema,
  tg as DetailItem,
  Qm as DetailSection,
  eg as DetailSectionContent,
  Xm as DetailSectionHeader,
  Jm as DetailSectionTitle,
  $x as Dialog,
  Vx as DialogClose,
  rg as DialogContent,
  ig as DialogDescription,
  sg as DialogFooter,
  og as DialogHeader,
  Sc as DialogOverlay,
  ng as DialogPortal,
  ag as DialogTitle,
  jx as DialogTrigger,
  Ux as DropdownMenu,
  eb as DropdownMenuCheckboxItem,
  Xy as DropdownMenuContent,
  Wx as DropdownMenuGroup,
  Jy as DropdownMenuItem,
  nb as DropdownMenuLabel,
  Hx as DropdownMenuPortal,
  Zx as DropdownMenuRadioGroup,
  tb as DropdownMenuRadioItem,
  rb as DropdownMenuSeparator,
  ob as DropdownMenuShortcut,
  Kx as DropdownMenuSub,
  Qy as DropdownMenuSubContent,
  Yy as DropdownMenuSubTrigger,
  zx as DropdownMenuTrigger,
  sb as Input,
  qw as IntegrationSchema,
  Jd as IntegrationStatusSchema,
  Xd as IntegrationTypeSchema,
  cb as Label,
  Hw as LoginRequestSchema,
  Kw as LoginResponseSchema,
  Gw as MessageSchema,
  Qd as MessageSenderTypeSchema,
  Yw as NotificationSchema,
  ef as NotificationTypeSchema,
  lb as PageHeader,
  pb as PageHeaderActions,
  mb as PageHeaderBadge,
  hb as PageHeaderBreadcrumb,
  ub as PageHeaderContent,
  fb as PageHeaderDescription,
  db as PageHeaderTitle,
  Jw as PaginatedResponseSchema,
  Gd as ProjectSchema,
  qx as Select,
  Zb as SelectContent,
  Yx as SelectGroup,
  qb as SelectItem,
  Gb as SelectLabel,
  $u as SelectScrollDownButton,
  Fu as SelectScrollUpButton,
  Yb as SelectSeparator,
  Kb as SelectTrigger,
  Qx as SelectValue,
  ew as Separator,
  tw as StatusIndicator,
  nw as Table,
  ow as TableBody,
  lw as TableCaption,
  cw as TableCell,
  sw as TableFooter,
  iw as TableHead,
  rw as TableHeader,
  aw as TableRow,
  Ww as TenantSchema,
  uw as Textarea,
  Uw as ThemeProvider,
  zw as ThemeToggle,
  ox as TicketFiltersSchema,
  Ir as TicketPrioritySchema,
  Zw as TicketSchema,
  fi as TicketSourceSchema,
  is as TicketStatusSchema,
  cs as TicketTypeSchema,
  rf as TmsApiClient,
  id as Toast,
  Iw as ToastAction,
  cd as ToastClose,
  ud as ToastDescription,
  kw as ToastProvider,
  ld as ToastTitle,
  ad as ToastViewport,
  Jx as Toaster,
  tx as UpdateTicketRequestSchema,
  Zd as UserSchema,
  e_ as VirtualizedList,
  Te as apiClient,
  Ip as badgeVariants,
  Pp as buttonVariants,
  Ex as capitalize,
  U as cn,
  Mx as copyToClipboard,
  Px as createSortComparator,
  kx as debounce,
  up as deepMerge,
  lp as formatDate,
  Nx as formatFileSize,
  Sx as formatRelativeTime,
  Ix as generateId,
  Tx as getInitials,
  Ox as isEmpty,
  pe as queryKeys,
  Ax as sleep,
  Rx as toTitleCase,
  Cx as truncate,
  hx as useAgents,
  fx as useCreateTicket,
  gx as useCustomer,
  mx as useCustomers,
  yx as useIntegration,
  vx as useIntegrations,
  ix as useLogin,
  cx as useLogout,
  xx as useMarkNotificationRead,
  lx as useMe,
  bx as useNotifications,
  _x as usePrefetchTicket,
  vd as useTheme,
  dx as useTicket,
  ux as useTickets,
  Fw as useToast,
  wx as useUnreadNotificationCount,
  px as useUpdateTicket,
  t_ as useVirtualizedList
};
//# sourceMappingURL=index.mjs.map
